(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3511],{

/***/ 81324:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/pdp-v2",
      function () {
        return __webpack_require__(34322);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 70315:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/PDF-ANN.a1a3ec81.svg","height":27,"width":22});

/***/ }),

/***/ 93655:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/close-dark-new.9e6d0c26.svg","height":22,"width":22});

/***/ }),

/***/ 39306:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/email.b2f119d5.svg","height":20,"width":28});

/***/ }),

/***/ 52324:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/phone-icon.92125abd.svg","height":22,"width":19});

/***/ }),

/***/ 7033:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/tooltip.396c7bfc.svg","height":30,"width":30});

/***/ }),

/***/ 14629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47956);
/* harmony import */ var _components_core_SelectDropdown_index_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8618);
/* harmony import */ var _components_core_SelectDropdown_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_components_core_SelectDropdown_index_module_scss__WEBPACK_IMPORTED_MODULE_4__);





const SelectDropdown = (props)=>{
    const [showList, setShowList] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [opened, setOpened] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [filteredData, setFilteredData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    let isFocused = false;
    const dropDownClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()({
        "select-dropdown": true,
        "dropdown--open": showList
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (showList) {
            setOpened(true);
        } else if (!showList && opened && props.onClose) {
            props.onClose();
            setOpened(false);
        }
        const targetEelement = (e)=>{
            if (showList && document.getElementById(props.id) && !document.getElementById(props.id).contains(e.target)) {
                setShowList(false);
            }
        };
        document.addEventListener("click", targetEelement);
        return ()=>{
            document.removeEventListener("click", targetEelement);
        };
    }, [
        showList
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setFilteredData(props.data);
    }, [
        props.data
    ]);
    const handleSelect = (value)=>{
        props.onChange(value);
        setShowList(false);
    };
    const handleMouseDownEvent = ()=>{
        isFocused = true;
        setShowList(!showList);
    };
    const handleBlurEvent = (e)=>{
        if (e instanceof MouseEvent) {
            isFocused;
            setShowList(false);
        }
        if (typeof props.onBlur === "function") {
            props.onBlur();
        }
    };
    const toggleList = ()=>{
        if (showList) {
            setShowList(false);
            document.getElementById(props.id).focus();
        } else {
            var ref;
            setShowList(true);
            (ref = document.getElementById("".concat(props.id, "-list"))) === null || ref === void 0 ? void 0 : ref.childNodes[0].focus();
        }
    };
    const btnKeyDown = (e)=>{
        const { KEYCODE  } = _constants_index__WEBPACK_IMPORTED_MODULE_3__["default"];
        switch(e.keyCode){
            case KEYCODE.SPACE:
                break;
            case KEYCODE.ENTER:
                e.preventDefault();
                toggleList();
                break;
            default:
                break;
        }
    };
    const handleKeyDown = (i, e)=>{
        const { KEYCODE  } = _constants_index__WEBPACK_IMPORTED_MODULE_3__["default"];
        const ele = document.getElementById("".concat(props.id, "-list")).childNodes;
        switch(e.keyCode){
            case KEYCODE.ESC:
                toggleList();
                break;
            case KEYCODE.UP:
                if (i > 0) ele[i - 1].focus();
                break;
            case KEYCODE.DOWN:
                if (i < ele.length - 1) ele[i + 1].focus();
                break;
            case KEYCODE.SPACE:
                break;
            case KEYCODE.ENTER:
                ele[i].click();
                document.getElementById(props.id).focus();
                break;
            default:
                break;
        }
    };
    const { customClass , id , tabIndex , label , ariaLabel , ariaRequired , value , ariaStateText , data , showError , errorMessage  } = props;
    const filterCityNames = (e)=>{
        var ref;
        const key = e === null || e === void 0 ? void 0 : (ref = e.key) === null || ref === void 0 ? void 0 : ref.toLowerCase();
        if ((key === null || key === void 0 ? void 0 : key.length) === 1 && (key === null || key === void 0 ? void 0 : key.match(_constants_index__WEBPACK_IMPORTED_MODULE_3__["default"].REGEX_CONTAINS_LETTER))) {
            const filtered = data === null || data === void 0 ? void 0 : data.filter((item)=>{
                return item === null || item === void 0 ? void 0 : item.toLowerCase().startsWith(key);
            });
            setFilteredData(filtered !== null && filtered !== void 0 ? filtered : data);
        } else if (key === "backspace") {
            setFilteredData(data);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_components_core_SelectDropdown_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            onClick: handleMouseDownEvent,
            onBlur: handleBlurEvent,
            className: "".concat(dropDownClass, " ").concat(customClass !== null && customClass !== void 0 ? customClass : ""),
            onKeyDown: (e)=>filterCityNames(e),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    id: id,
                    className: "select-dropdown__field ".concat(showError ? "--with-error" : ""),
                    onKeyDown: btnKeyDown,
                    tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : 0,
                    role: "combobox",
                    "aria-controls": "dropdown-listbox",
                    "aria-expanded": showList,
                    "aria-haspopup": "true",
                    "aria-label": label ? label.replace(/\*/g, "") : ariaLabel ? ariaLabel.replace(/\*/g, "") : "",
                    "aria-required": (ariaRequired !== null && ariaRequired !== void 0 ? ariaRequired : label.indexOf("*") > 0) ? true : false,
                    "aria-describedby": "".concat(id, "-selected"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "select-dropdown__display",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    "aria-hidden": true,
                                    className: "select-dropdown__placeholder ".concat(value ? "--label" : ""),
                                    children: label
                                }),
                                value && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    id: "".concat(id, "-selected"),
                                    className: "select-dropdown__value",
                                    children: value
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "select-dropdown__icon ".concat(showList ? "--open" : ""),
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: "/icons/down-icon.svg",
                                alt: "open-icon"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                    id: "".concat(id, "-list"),
                    className: "select-dropdown__dropdown",
                    role: "listbox",
                    tabIndex: "-1",
                    "aria-expanded": "true",
                    "data-testid": "select-dropdown",
                    children: [
                        !ariaStateText && (filteredData === null || filteredData === void 0 ? void 0 : filteredData.map((item, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: "select-dropdown__list-item ".concat(item === value && "selected-item"),
                                "aria-selected": item === value,
                                role: "option",
                                tabIndex: "-1",
                                onClick: ()=>handleSelect(item),
                                onKeyDown: (e)=>handleKeyDown(i, e),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "select-dropdown__list-value",
                                    children: item
                                })
                            }, i))),
                        ariaStateText && (filteredData === null || filteredData === void 0 ? void 0 : filteredData.map((item, i)=>{
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: "select-dropdown__list-item ".concat(item.code === value && "selected-item"),
                                "aria-selected": item === value,
                                role: "option",
                                tabIndex: "-1",
                                "aria-label": item.name,
                                onClick: ()=>{
                                    return handleSelect((props === null || props === void 0 ? void 0 : props.showStateName) ? item === null || item === void 0 ? void 0 : item.name : item === null || item === void 0 ? void 0 : item.code);
                                },
                                onKeyDown: (e)=>handleKeyDown(i, e),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "select-dropdown__list-value",
                                    children: (props === null || props === void 0 ? void 0 : props.showStateName) ? item === null || item === void 0 ? void 0 : item.name : item === null || item === void 0 ? void 0 : item.code
                                })
                            }, i);
                        }))
                    ]
                }),
                showError && errorMessage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    "aria-live": "polite",
                    role: "region",
                    className: "select-dropdown__error-message",
                    children: errorMessage
                })
            ]
        })
    });
};
SelectDropdown.defaultProps = {
    label: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (SelectDropdown);


/***/ }),

/***/ 10512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _public_icons_close_white_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26693);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88751);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47956);
/* harmony import */ var _components_core_Toaster_index_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46805);
/* harmony import */ var _components_core_Toaster_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_components_core_Toaster_index_module_scss__WEBPACK_IMPORTED_MODULE_7__);









const Toaster = (param)=>{
    let { onClose  } = param;
    const { toaster: { message , isVisible  }  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_5__/* .selectGenericState */ .Px);
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    const [timeoutVal, setTimeoutVal] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (timeoutVal) {
            clearTimeout(timeoutVal);
            setTimeoutVal(null);
        }
        if (isVisible && !timeoutVal) {
            const tmVal = setTimeout(()=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_5__/* .hideToast */ .PE)());
            }, _constants_index__WEBPACK_IMPORTED_MODULE_6__.TOAST_MESSAGE_DEFAULT_DURATION);
            setTimeoutVal(tmVal);
        }
    }, [
        isVisible
    ]);
    const handleClose = ()=>{
        if (onClose) {
            onClose();
        } else {
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_5__/* .hideToast */ .PE)());
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_components_core_Toaster_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: isVisible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "toast-msg",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container kf-react-container toast-msg__content",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "toast-msg__message",
                            role: "alert",
                            dangerouslySetInnerHTML: {
                                __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3___default().sanitize(message)
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "toast-msg__close",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: _public_icons_close_white_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z === null || _public_icons_close_white_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z === void 0 ? void 0 : _public_icons_close_white_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"].src */ .Z.src,
                                alt: "close",
                                onClick: handleClose
                            })
                        })
                    ]
                })
            })
        })
    });
};
Toaster.propTypes = {
    message: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string.isRequired),
    onClose: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().func)
};
/* harmony default export */ __webpack_exports__["default"] = (Toaster);


/***/ }),

/***/ 34322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pdp_v2; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./components/AemGrid.jsx + 103 modules
var AemGrid = __webpack_require__(30390);
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/hooks/useIsSsr.js
var useIsSsr = __webpack_require__(7154);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/hooks/usePageAuth.js
var usePageAuth = __webpack_require__(85614);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(27514);
// EXTERNAL MODULE: ./src/components/ProductDetail/v3/productDetailsHelper.js
var productDetailsHelper = __webpack_require__(50023);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./src/store/features/authSlice.js
var authSlice = __webpack_require__(2693);
// EXTERNAL MODULE: ./store/features/pdpSlice.js
var pdpSlice = __webpack_require__(44561);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageHeader.jsx + 29 modules
var GlobalPageHeader = __webpack_require__(73750);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageFooter.jsx
var GlobalPageFooter = __webpack_require__(10884);
// EXTERNAL MODULE: ./src/components/Shared/GlobalPage/GlobalPageLayout.jsx
var GlobalPageLayout = __webpack_require__(82706);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./public/images/image-missing.png
var image_missing = __webpack_require__(36513);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var dist_lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./node_modules/react-sticky-el/lib/index.js
var react_sticky_el_lib = __webpack_require__(75198);
var react_sticky_el_lib_default = /*#__PURE__*/__webpack_require__.n(react_sticky_el_lib);
// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(66261);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(57333);
;// CONCATENATED MODULE: ./components/ProductDetail/v1/ProductDetailView/analytics.js
// import { calculateCartData } from "@Globals/js/helper"
const analytics_addDataLayer = (params)=>{
    var ref;
    const { title , eventMsg =null , eventStatus =null , productInfo =null , productArray =null , isSticky =false , calculated_Values ="" , isSampleOverlay =false , isSort =false , filterProps =null , toolTipProps =null , isAddtoCart =false , navProps =null , pdfProps =null , isDetailsTab =false , isTechnicalTab =false , isrecomendedProps =null , url =null , navTitle =null , breadCrumbObj =null , finishVal =null , shapeVal =null , colorVal =null , cartData =null , sysOverlayObj =null  } = params;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const componentName = page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.pageType;
    const eventType = title === "add to compare" || title === "remove compare" ? "n/a" : "navigation";
    const calculatedValues = document.querySelector(".trim-calculator_main-block") && (calculated_Values === null || calculated_Values === void 0 ? void 0 : calculated_Values.length) > 0 ? JSON.parse(calculated_Values) : null;
    const pdfData = pdfProps && (pdfProps === null || pdfProps === void 0 ? void 0 : pdfProps.pdf_Data) ? JSON.parse(pdfProps === null || pdfProps === void 0 ? void 0 : pdfProps.pdf_Data) : null;
    const filterArrayJSON = filterProps && filterProps.appliedFilters && filterProps.appliedFilters.length > 0 ? {
        filterArray: filterProps === null || filterProps === void 0 ? void 0 : filterProps.appliedFilters
    } : null;
    const productInfoJSON = isAddtoCart && isSampleOverlay && productArray && productArray.length > 0 ? {
        productArray: JSON.parse(productArray)
    } : productInfo && productInfo.length > 0 ? {
        productInfo: JSON.parse(productInfo)
    } : null;
    // if (cartData) {
    //   const { cart } = calculateCartData({ cart: cartData })
    //   page.cart = cart
    // }
    let eventAction, internalLinkZoneName, internalLinkPosition, internalLinkName, internalLinkType;
    if (isSticky) {
        internalLinkZoneName = "".concat(componentName, ":sticky nav");
        eventAction = "".concat(internalLinkZoneName, ":").concat(title);
        internalLinkPosition = "header";
        if (title === "sticky nav links") {
            eventAction = "".concat(componentName, ":").concat(title);
            internalLinkName = "".concat(navTitle);
            internalLinkType = "".concat(componentName, ":navigation");
            internalLinkPosition = "".concat(componentName);
        }
    } else if (title === "notify me") {
        internalLinkZoneName = "".concat(componentName, ":modal:availability notification");
        eventAction = "".concat(internalLinkZoneName, ":").concat(title);
    } else if (title === "how much grout do i need" && !(isrecomendedProps === null || isrecomendedProps === void 0 ? void 0 : isrecomendedProps.isrecomended)) {
        internalLinkType = "".concat(componentName, ":navigation");
    } else if (title === "calculate footage" || title === "overage") {
        eventAction = "".concat(componentName, ":product details:calculate footage");
        internalLinkName = title === "calculate footage" ? "square feet changed" : "overage selection";
    } else if (title === "recommended grout" || title === "recommended trim") {
        internalLinkType = "".concat(componentName, ":navigation");
    } else if (title === "finish selection" || title === "style selection" || title === "color selection") {
        internalLinkType = "".concat(componentName, ":").concat(title, ":").concat(title === "finish selection" ? finishVal : title === "color selection" ? colorVal : shapeVal);
    } else if ((toolTipProps === null || toolTipProps === void 0 ? void 0 : toolTipProps.isToolTip) && !isDetailsTab) {
        internalLinkName = "".concat(toolTipProps === null || toolTipProps === void 0 ? void 0 : toolTipProps.toolTipValue);
        internalLinkType = "".concat(componentName, ":mouseover");
    } else if (navProps === null || navProps === void 0 ? void 0 : navProps.isNav) {
        internalLinkZoneName = "".concat(componentName, ":main content area");
        eventAction = "".concat(internalLinkZoneName, ":").concat(title);
        internalLinkName = "".concat(navProps === null || navProps === void 0 ? void 0 : navProps.navTitle);
        internalLinkType = "".concat(componentName, ":navigation");
    } else if (isSampleOverlay) {
        internalLinkZoneName = "".concat(componentName, ":order a sample overlay");
        eventAction = "".concat(internalLinkZoneName, ":").concat(title);
        if (filterProps === null || filterProps === void 0 ? void 0 : filterProps.isFilter) {
            internalLinkType = "".concat(componentName, ":filters");
            internalLinkName = (filterProps === null || filterProps === void 0 ? void 0 : filterProps.filterName) ? filterProps === null || filterProps === void 0 ? void 0 : filterProps.filterName : null;
        } else if (isSort) {
            eventAction = "".concat(internalLinkZoneName, ":sort by");
            internalLinkType = "".concat(componentName, ":sort by");
        }
    } else if (isDetailsTab) {
        internalLinkZoneName = "".concat(componentName, ":details tab");
        eventAction = "".concat(internalLinkZoneName, ":").concat(title);
        if (pdfProps === null || pdfProps === void 0 ? void 0 : pdfProps.isPdf) {
            internalLinkName = pdfProps === null || pdfProps === void 0 ? void 0 : pdfProps.fileName;
            internalLinkType = "".concat(componentName, ":download");
        } else if (toolTipProps === null || toolTipProps === void 0 ? void 0 : toolTipProps.isToolTip) {
            internalLinkName = toolTipProps === null || toolTipProps === void 0 ? void 0 : toolTipProps.toolTipValue;
            internalLinkType = "".concat(componentName, ":mouseover");
        }
    } else if (isTechnicalTab) {
        internalLinkZoneName = "".concat(componentName, ":technical tab");
        eventAction = "".concat(internalLinkZoneName, ":").concat(title);
        internalLinkType = "".concat(componentName, ":navigation");
    } else if (isrecomendedProps === null || isrecomendedProps === void 0 ? void 0 : isrecomendedProps.isrecomended) {
        internalLinkZoneName = "".concat(componentName, ":").concat(isrecomendedProps === null || isrecomendedProps === void 0 ? void 0 : isrecomendedProps.type);
        eventAction = "".concat(internalLinkZoneName, ":").concat(title);
        internalLinkType = "".concat(componentName, ":").concat(title === "close" ? "close" : "navigation");
        internalLinkName = (isrecomendedProps === null || isrecomendedProps === void 0 ? void 0 : isrecomendedProps.tileName) ? isrecomendedProps === null || isrecomendedProps === void 0 ? void 0 : isrecomendedProps.tileName : null;
    } else if (breadCrumbObj) {
        eventAction = "".concat(componentName, ":").concat(breadCrumbObj === null || breadCrumbObj === void 0 ? void 0 : breadCrumbObj.breadCrumbTitle);
        internalLinkType = eventAction;
        internalLinkName = "".concat(breadCrumbObj === null || breadCrumbObj === void 0 ? void 0 : breadCrumbObj.breadCrumbPath);
        internalLinkPosition = "".concat(componentName);
    } else if (sysOverlayObj) {
        const { overlayTitle , overlayType , sysVal  } = sysOverlayObj;
        eventAction = "".concat(componentName, ":product details:").concat(overlayTitle, ":").concat(title);
        internalLinkType = "".concat(componentName, ":").concat(overlayType).concat(sysVal);
        internalLinkZoneName = "".concat(componentName, ":product details:").concat(overlayTitle);
    }
    const eventInfo = {
        eventAction: eventAction || "".concat(componentName, ":product details:").concat(title),
        eventName: eventAction || "".concat(componentName, ":product details:").concat(title),
        eventType: eventType,
        eventMsg: eventMsg || "n/a",
        eventStatus: eventStatus || "n/a",
        internalLinkName: internalLinkName || "".concat(title),
        internalLinkPosition: internalLinkPosition || "".concat(componentName),
        internalLinkType: internalLinkType || "".concat(componentName, ":").concat(title),
        internalLinkZoneName: internalLinkZoneName || "".concat(componentName, ":product details"),
        internalLinkURL: url || "n/a",
        clickInternalLinks: "true",
        ...pdfData,
        ...calculatedValues,
        ...filterArrayJSON
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page,
        ...productInfoJSON
    });
};

// EXTERNAL MODULE: ./src/components/core/Button/Button.jsx
var Button_Button = __webpack_require__(82476);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./constants/index.js + 2 modules
var constants = __webpack_require__(47956);
;// CONCATENATED MODULE: ./components/ProductDetail/v1/StickyHeader.jsx













const StickyHeader = (props)=>{
    var ref, ref1, ref2;
    const [showBuyBoxArea, setShowBuyBoxArea] = (0,react.useState)(true);
    const [finalPrice, setFinalPrice] = (0,react.useState)(props.price);
    var ref3;
    const [updatedFinalPrice, setItemFinalPrice] = (0,react.useState)(Number((ref3 = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("itemFinalPrice")) !== null && ref3 !== void 0 ? ref3 : 0));
    const itemStatus = get_default()(props, "itemStatus", "available");
    let statusText = "";
    let buttonText = props.templateType === "tile" || props.templateType === "trim" ? props === null || props === void 0 ? void 0 : (ref = props.staticTexts) === null || ref === void 0 ? void 0 : ref.calcAddCart : props.staticTexts.addToCart;
    if (props.isColorDiscontinued) {
        buttonText = props.staticTexts.availColorCTA;
    }
    if (itemStatus === "outOfStock" || !(props.productStock > 0) && (props.specialOrder !== "Yes" || props.backOrder !== "Yes")) {
        statusText = props.staticTexts.outOfStock;
        buttonText = props.staticTexts.notifyMailCTA;
    } else if (itemStatus === "discontinued") {
        statusText = props.staticTexts.discontinued;
        buttonText = props.staticTexts.findSimilar;
    } else if (itemStatus === "preOrder") {
        buttonText = props.staticTexts.preOrder;
    } else if (itemStatus === "specialOrder") {
        buttonText = props.staticTexts.specialOrder;
    }
    var _productCategoryType;
    const productCategoryType = (_productCategoryType = props.productCategoryType) !== null && _productCategoryType !== void 0 ? _productCategoryType : "";
    const isSamplesPdp = productCategoryType.toLowerCase() === "samples";
    (0,react.useEffect)(()=>{
        if (updatedFinalPrice > 0) {
            setFinalPrice(updatedFinalPrice);
        }
    }, [
        updatedFinalPrice
    ]);
    (0,react.useEffect)(()=>{
        const handleScroll = ()=>{
            const navEl = props.navData.map((el)=>document.getElementById(el.elemId));
            const navSize = dist_lib/* isMobile */.tq && window.outerWidth < 1024 ? 63 : 163;
            const windowTop = window.scrollY + navSize;
            navEl.forEach((ele, i)=>{
                if (ele) {
                    const { offsetBottom , offsetTop  } = getDimensions(ele);
                    if (windowTop > offsetTop && windowTop < offsetBottom) {
                        props.handleScrollNav(i);
                    }
                }
            });
        };
        window.addEventListener("scroll", handleScroll);
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    (0,react.useEffect)(()=>{
        if (props.productIsRetail) {
            setShowBuyBoxArea(false);
        } else if (!(props === null || props === void 0 ? void 0 : props.price) && !(props === null || props === void 0 ? void 0 : props.disableEcommerce)) {
            setShowBuyBoxArea(false);
        } else {
            setShowBuyBoxArea(true);
        }
    }, [
        props.productIsRetail,
        props.price
    ]);
    const getDimensions = (ele)=>{
        const { height  } = ele.getBoundingClientRect();
        const offsetTop = ele.offsetTop;
        const offsetBottom = offsetTop + height;
        return {
            height,
            offsetTop,
            offsetBottom
        };
    };
    const handleNavChange = (navActive, value)=>{
        props.handleNavChange(navActive);
        analytics_addDataLayer({
            title: "sticky nav links",
            isSticky: true,
            navTitle: value.toLowerCase(),
            productInfo: props === null || props === void 0 ? void 0 : props.analyticsProductInfo
        });
    };
    const scrollToTrimBlock = (idInfo, e)=>{
        var ref;
        e.preventDefault();
        analytics_addDataLayer({
            title: (idInfo === "email" ? props.staticTexts.notifyMailCTA : (ref = props.staticTexts) === null || ref === void 0 ? void 0 : ref.addToCart).toLowerCase(),
            productInfo: props === null || props === void 0 ? void 0 : props.analyticsProductInfo,
            isSticky: true
        });
        modules/* scroller.scrollTo */.OK.scrollTo(idInfo, {
            duration: 1500,
            delay: 0,
            smooth: "easeInOutQuart",
            offset: -190
        });
    };
    const handleStickyCart = ()=>{
        localStorage.setItem("headerAtcIsClicked", true);
        if (props === null || props === void 0 ? void 0 : props.replaceAddToCart) {
            document.querySelector(".ecommerce-cart__main-button") ? document.querySelector(".ecommerce-cart__main-button").click() : "";
        } else {
            document.querySelector(".add-to-cart__main-button") ? document.querySelector(".add-to-cart__main-button").click() : "";
        }
    };
    const AddToCartActionsMarkup = ()=>{
        var ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "sticky-header__cart-block",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                id: "sticky__add-to-cart",
                className: "sticky__add-to-cart",
                label: (ref = props.staticTexts) === null || ref === void 0 ? void 0 : ref.addToCart,
                size: "small",
                type: "primary",
                onClick: handleStickyCart
            })
        });
    };
    const handleAssetId = function() {
        let imageUrl = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        var ref, ref1;
        const lastImageId = (ref = imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.split("/")) === null || ref === void 0 ? void 0 : ref.pop();
        const res = ((ref1 = lastImageId === null || lastImageId === void 0 ? void 0 : lastImageId.split("?")) === null || ref1 === void 0 ? void 0 : ref1.length) ? lastImageId === null || lastImageId === void 0 ? void 0 : lastImageId.split("?")[0] : lastImageId;
        return res;
    };
    const preseterUrl = function() {
        let imgUrl = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        return (0,helper/* getAsPDPThumbnail */.wN4)(props === null || props === void 0 ? void 0 : props.swatchUrl, props === null || props === void 0 ? void 0 : props.presetConfig, handleAssetId(imgUrl), props === null || props === void 0 ? void 0 : props.accountName);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "sticky-header container-fluid",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "sticky-header__details-wrap container-fluid",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "sticky-header__container container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            onError: (e)=>{
                                return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                            },
                            src: preseterUrl(props.imgUrl),
                            alt: props.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "sticky-header__details",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "sticky-header__brand-name",
                                children: props.title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "sticky-header__rating-desc",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "sticky-header__description",
                                children: props.description
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "sticky-header__shape-desc",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: props.ProductDescriptionDetail_s
                            })
                        }),
                        (props === null || props === void 0 ? void 0 : props.leadTimeRange) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "sticky-header__shipping-time",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: constants.SHIPS_IN_LABEL + " " + (props === null || props === void 0 ? void 0 : props.leadTimeRange)
                            })
                        }),
                        showBuyBoxArea && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()({
                                "sticky-header__right": true,
                                "sticky-header__right--retailers": props.productIsRetail
                            }),
                            children: [
                                itemStatus !== "discontinued" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "sticky-header__price-block",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "sticky-header__price-text",
                                            id: "sticky-header__price-text",
                                            children: props.productStock > 0 ? updatedFinalPrice > 0 ? props === null || props === void 0 ? void 0 : (ref1 = props.staticTexts) === null || ref1 === void 0 ? void 0 : ref1.calculatedTotal : props === null || props === void 0 ? void 0 : (ref2 = props.staticTexts) === null || ref2 === void 0 ? void 0 : ref2.startingAt : ""
                                        }),
                                        !isSamplesPdp && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "sticky-header__price",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                    value: finalPrice,
                                                    displayType: "text",
                                                    thousandSeparator: true,
                                                    prefix: props.currencySign,
                                                    decimalScale: 2,
                                                    fixedDecimalScale: true,
                                                    id: "sticky-header__price"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "sticky-header__price-type",
                                                    children: updatedFinalPrice ? "" : props === null || props === void 0 ? void 0 : props.priceTag
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                updatedFinalPrice > 0 && props.productStock && !props.disableEcommerce ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCartActionsMarkup, {}) : !(props.productStock > 0) && (props.specialOrder === "Yes" || props.backOrder === "Yes" && props.templateType !== "samples" || props.isParts) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCartActionsMarkup, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "sticky-header__cart-block",
                                    children: !props.disableEcommerce ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        id: "calc__add-to-cart-btn",
                                        className: "calc__add-to-cart ".concat(!props.productStock ? "calc__notify-cart-btn" : ""),
                                        label: buttonText,
                                        size: "small",
                                        type: "primary",
                                        onClick: props.productStock ? props.templateType === "grout" ? handleStickyCart : (e)=>scrollToTrimBlock("trim-calculator_main-block", e) : (e)=>scrollToTrimBlock("email", e),
                                        to: props.productStock ? props.templateType === "grout" ? "javascript:void(0)" : "#trim-calculator_main-block" : "#email"
                                    }) : props.replaceAddToCart && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        id: "ecommerce-cart-btn",
                                        className: "calc__add-to-cart",
                                        label: props.replaceAddToCartCtaLabel,
                                        size: "small",
                                        type: "primary",
                                        flexible: true,
                                        tag: "anchor",
                                        to: props.replaceAddToCartCtaLink ? (0,helper/* getShortenedUrlwithGeneral */.vu1)(props.replaceAddToCartCtaLink, props.general) : "javascript:void(0)",
                                        target: props.linkNewTab === "true" ? "_blank" : "_self",
                                        onClick: handleStickyCart
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "sticky-header__nav-container container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "sticky-header__nav-items",
                    children: props.navData.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: item.elemId,
                            className: item.isActive ? "sticky-nav-active" : "",
                            onClick: ()=>handleNavChange(index, item.label),
                            children: item.label
                        }, index))
                })
            })
        ]
    });
};
/* harmony default export */ var v1_StickyHeader = (StickyHeader);

;// CONCATENATED MODULE: ./public/icons/tooltip-new.svg
/* harmony default export */ var tooltip_new = ({"src":"/_next/static/media/tooltip-new.7d3d3a1b.svg","height":17,"width":16});
// EXTERNAL MODULE: ./src/utils/cart.js
var utils_cart = __webpack_require__(87292);
;// CONCATENATED MODULE: ./public/icons/arrow-down-new.svg
/* harmony default export */ var arrow_down_new = ({"src":"/_next/static/media/arrow-down-new.1d9e77f3.svg","height":9,"width":16});
// EXTERNAL MODULE: ./src/components/core/ToolTip/ToolTip.jsx
var ToolTip = __webpack_require__(45138);
// EXTERNAL MODULE: ./public/icons/close-dark-new.svg
var close_dark_new = __webpack_require__(93655);
;// CONCATENATED MODULE: ./public/icons/filter-all.svg
/* harmony default export */ var filter_all = ({"src":"/_next/static/media/filter-all.592ad218.svg","height":14,"width":21});
;// CONCATENATED MODULE: ./public/icons/check-icon-new.svg
/* harmony default export */ var check_icon_new = ({"src":"/_next/static/media/check-icon-new.bd6e14e3.svg","height":11,"width":12});
;// CONCATENATED MODULE: ./public/images/design-missing.png
/* harmony default export */ var design_missing = ({"src":"/_next/static/media/design-missing.dc5e4bf3.png","height":88,"width":70,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAAGFBMVEXa2trV1dXc3NzX19fPz8/Hx8fDw8OkpKTl8L6xAAAAAnRSTlPj7Kp8w0QAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAqSURBVAiZJce5DQAwDMNAQZ/339hwwuZA8AWyPTSju4SEbPtIKlCtiN8CEL8AkBtycAMAAAAASUVORK5CYII=","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/ProductDetail/v1/SelectYourStyle/v1/ProductColorFinish.jsx








const ProductColorFinish = (param)=>{
    let { swatchUrl , isDiscontinued , isColorDiscontinued , isShape , image , showModal , isColor , closeModal , colorsPopUp , openFilter , showActivePreview , updateShapeImagePreview , modalColorApplyBtn , applyBtn , i18n , showFilter , colorFamily , colorFamilyCount , accountName ="" , presetConfig ={} , productImages =[] , applySelectedShape , styleOptionsNotPresent , selectYourStyleInfo , ...props } = param;
    const [colorFinishMapping, setColorFinishMapping] = (0,react.useState)([]);
    const [colorFamilyDetails, setcolorFamilyDetails] = (0,react.useState)([]);
    const [selectedColors, setSelectedColors] = (0,react.useState)([]);
    const [activeSku, setActiveSku] = (0,react.useState)(null);
    const [activeSkuImg, setactiveSkuImg] = (0,react.useState)(null);
    const [hoveredSku, setHoveredSku] = (0,react.useState)(null);
    const [hoverSkuImg, setHoverSkuImg] = (0,react.useState)(null);
    const [showNoDesignNote, setShowNoDesignNote] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        setcolorFamilyDetails(colorFamily);
        if (colorFamily && colorFamily.length > 0) {
            const activeColor = colorFamily === null || colorFamily === void 0 ? void 0 : colorFamily.find((cf)=>{
                return cf.split("|")[3] === (props === null || props === void 0 ? void 0 : props.activeSku);
            });
            let activeSku_s = activeColor ? activeColor.split("|")[3] : colorFamily[0].split("|")[3];
            setActiveSku(activeSku);
            if (activeColor) {
                let imageTag = productImages.filter((image)=>image.sku === activeSku_s);
                setactiveSkuImg(imageTag.length > 0 ? imageTag[0].tag : null);
            }
        }
        setColorFinishMapping(colorFamilyCount);
    }, [
        colorFamily,
        colorFamilyCount
    ]);
    (0,react.useLayoutEffect)(()=>{
        openFilter();
    }, []);
    const ColorFinishLength = colorFinishMapping && colorFinishMapping.reduce((total, color)=>{
        const count = parseInt(color.split("|")[1]);
        return total + count;
    }, 0);
    const handleCheckboxChange = (event, colorItem)=>{
        const checkboxValue = event.target.value;
        const isChecked = event.target.checked;
        if (isChecked) {
            setSelectedColors((prevColors)=>[
                    ...prevColors,
                    colorItem
                ]);
        } else {
            setSelectedColors((prevColors)=>prevColors.filter((selectedColor)=>selectedColor !== colorItem));
        }
    };
    const colorFamilyFilteredValues = colorFamilyDetails ? colorFamilyDetails.filter((value)=>{
        return selectedColors.includes(value.split("|")[0]);
    }) : [];
    const timeout = (delay)=>new Promise((res)=>setTimeout(res, delay));
    const showActivePreviewImg = async (skuValue, imageValue)=>{
        setActiveSku(skuValue);
        setactiveSkuImg(imageValue);
        await timeout(2000);
        if (isShape) {
            applyBtn("product-select-style__modal-shape-select-option-img-active", "ProductDetailImageURL_s");
        }
        if (isColor) {
            modalColorApplyBtn("product-select-style__modal-color-custom-img-block-active", "skuId", "colorFinish", "imageItem");
        }
    };
    const showActivePreviewImgShape = async (i)=>{
        showActivePreview("modal-shape-select-option-img" + i, "product-select-style__modal-shape-select-option-img", true, i);
        await timeout(2000);
        if (isShape) {
            // applyBtn(
            //   "product-select-style__modal-shape-select-option-img-active",
            //   "ProductDetailImageURL_s"
            // )
            applySelectedShape(i);
        }
    };
    const isActiveskuId = "skuId";
    const isActiveSkuValue = activeSku;
    const handleMouseEnter = (skuValue, imageValue)=>{
        let imageTag = productImages.filter((image)=>image.sku === skuValue);
        setHoverSkuImg(imageTag.length > 0 ? imageTag[0].tag : null);
        setHoveredSku(skuValue);
    };
    const handleMouseLeave = ()=>{
        setHoverSkuImg(null);
        setHoveredSku(null);
    };
    const uncheckFilterAll = ()=>{
        setSelectedColors([]);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: !isDiscontinued && !isColorDiscontinued && showModal && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "product-select-style__overlay",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-select-style__modal",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "product-select-style__modal-row",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: isShape ? "select-style-popup product-select-style__modal-main-block shape-block" : "select-style-popup product-select-style__modal-main-block",
                        children: [
                            isShape && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "select-style-view product-select-style__modal-color-image-block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "select-style-view-img product-select-style__modal-color-image-box",
                                    children: image.length > 0 && image.map((imageItem, i)=>{
                                        return imageItem["isActive"] === true && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            onError: (e)=>{
                                                return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                                            },
                                            src: imageItem["src"] ? imageItem["src"] : image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src,
                                            className: "product-select-style__modal-color-image-preview",
                                            id: "product-select-style__modal-image-preview"
                                        });
                                    })
                                })
                            }),
                            isColor && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "select-style-view product-select-style__modal-color-image-block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "select-style-view-img product-select-style__modal-color-image-box",
                                    id: "modal-color-image-box-block",
                                    children: colorsPopUp.length > 0 && colorsPopUp.map((colorsItem, i)=>{
                                        const colorsImage = colorsItem["src"] && colorsItem["src"];
                                        const updatedImageWithPreset = colorsImage && (0,helper/* getAsPDPThumbnail */.wN4)(swatchUrl, presetConfig, hoverSkuImg ? hoverSkuImg : activeSkuImg, accountName);
                                        return colorsItem["isActive"] === true && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            [isActiveskuId]: isActiveSkuValue,
                                            onError: (e)=>{
                                                return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                                            },
                                            src: updatedImageWithPreset !== null && updatedImageWithPreset !== void 0 ? updatedImageWithPreset : image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src,
                                            className: "product-select-style__modal-color-image-preview",
                                            id: "product-select-style__modal-color-image-preview"
                                        });
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "select-style-info product-select-style__modal-content-block",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-select-style__modal-close",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            onError: (e)=>{
                                                return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                                            },
                                            src: close_dark_new/* default */.Z === null || close_dark_new/* default */.Z === void 0 ? void 0 : close_dark_new/* default.src */.Z.src,
                                            alt: "close",
                                            onClick: ()=>closeModal()
                                        })
                                    }),
                                    isShape && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "product-select-style__modal-color-title-block shape-title-block",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "product-select-style__modal-color-title",
                                                children: i18n.productSelectStyleShapeLabel
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "product-select-style__modal-color-total-options",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "product-select-style__modal-color-total-block",
                                                        children: image !== undefined && image !== "" ? image.length : ""
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "product-select-style__modal-shape-total-label",
                                                        children: i18n.productSelectStyleShapeTotalOptions
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    isColor && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "product-select-style__modal-color-title-block color-title-block",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "product-select-style__modal-color-title",
                                                children: i18n.productSelectStyleModalColorTitle
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "product-select-style__modal-color-total-options",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "product-select-style__modal-color-total-block",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "product-select-style__modal-color-total",
                                                                children: colorFamilyFilteredValues.length > 0 ? "".concat(colorFamilyFilteredValues === null || colorFamilyFilteredValues === void 0 ? void 0 : colorFamilyFilteredValues.length, "/").concat(ColorFinishLength) : "".concat(ColorFinishLength)
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "product-select-style__modal-color-total-label",
                                                                children: i18n.productSelectStyleShapeTotalOptions
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "product-select-style__modal-color-filter-block",
                                                        onClick: ()=>openFilter(),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                onError: (e)=>{
                                                                    return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                                                                },
                                                                src: filter_all === null || filter_all === void 0 ? void 0 : filter_all.src,
                                                                className: "product-select-style__modal-color-filter-icon"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "product-select-style__modal-color-filter-label-block",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "product-select-style__modal-color-filter-label",
                                                                        id: "product-select-style__filter-label",
                                                                        children: showFilter ? i18n.productSelectStyleShowFilter : i18n.productSelectStyleHideFilter
                                                                    }),
                                                                    (selectedColors === null || selectedColors === void 0 ? void 0 : selectedColors.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        className: "product-select-style__modal-color-filter-count",
                                                                        children: [
                                                                            "(",
                                                                            selectedColors.length + " " + i18n.productSelectStyleAppliedLabel,
                                                                            ")"
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    isColor && !showFilter && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "product-select-style__modal-color-checkbox-block",
                                        id: "prduct-select-style__color-panel",
                                        style: {
                                            "display": "block"
                                        },
                                        children: [
                                            (colorFinishMapping === null || colorFinishMapping === void 0 ? void 0 : colorFinishMapping.length) > 0 && colorFinishMapping.map((colorItems)=>{
                                                const [colorItem, colorCount] = colorItems.split("|");
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "product-select-style__modal-color-checkbox",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        className: "checkbox checkbox__black",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                type: "checkbox",
                                                                className: "finish_selection_checkbox",
                                                                name: "",
                                                                value: colorItem,
                                                                checked: selectedColors.includes(colorItem),
                                                                onChange: (event)=>handleCheckboxChange(event, colorItem)
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "checkbox__marker",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    className: "checkbox__marker-icon",
                                                                    src: check_icon_new === null || check_icon_new === void 0 ? void 0 : check_icon_new.src,
                                                                    alt: "Checkbox"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "checkbox__color-name",
                                                                children: [
                                                                    colorItem,
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        className: "checkbox__color-count",
                                                                        children: [
                                                                            "(",
                                                                            colorCount,
                                                                            ")"
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }, colorItem);
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: selectedColors && selectedColors.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "product-select-style__modal-clearall-block",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "product-select-style__clearall-button",
                                                        onClick: ()=>uncheckFilterAll(),
                                                        children: i18n.productSelectStyleModalClearAll
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    isShape && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-select-style__modal-color-select-block",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "product-select-style__modal-color-custom-select",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                className: "product-select-style__modal-color-ul m-0",
                                                children: image.length > 0 && image.map((imageItem, i)=>{
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: "product-select-style__modal-color-li",
                                                        onClick: ()=>showActivePreviewImgShape(i),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                            href: "javascript:void(0)",
                                                            className: "product-select-style__modal-shape-link",
                                                            onMouseOver: ()=>updateShapeImagePreview(imageItem["src"]),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    onError: (e)=>{
                                                                        return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                                                                    },
                                                                    src: imageItem["src"],
                                                                    className: imageItem["isActive"] === true ? "product-select-style__modal-shape-select-option-img product-select-style__modal-shape-select-option-img-active" : "product-select-style__modal-shape-select-option-img",
                                                                    id: "modal-shape-select-option-img" + i
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "product-select-style__modal-shape-sub-heading",
                                                                    children: imageItem["name"]
                                                                })
                                                            ]
                                                        })
                                                    }, i);
                                                })
                                            })
                                        })
                                    }),
                                    isColor && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-select-style__modal-color-select-block ".concat(showFilter ? "filter-open" : ""),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "product-select-style__modal-color-custom-select",
                                            id: "modal-color-select-block",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                className: "product-select-style__modal-color-ul m-0",
                                                children: [
                                                    selectedColors.length === 0 ? colorFamilyDetails.length > 0 && colorFamilyDetails.map((value, index)=>{
                                                        var ref;
                                                        const [colorValue, colorItemValue, imageValue, skuValue] = value.split("|");
                                                        const finishName = (ref = colorsPopUp.find((cp)=>{
                                                            return (cp === null || cp === void 0 ? void 0 : cp.skuId) === skuValue;
                                                        })) === null || ref === void 0 ? void 0 : ref.finishName;
                                                        const dynamicskuId = "skuId";
                                                        const dynamicSkuValue = skuValue;
                                                        const dynamicColorFinish = "colorFinish";
                                                        const imageSrc = "imageItem";
                                                        const dynamicColorFinishValue = "".concat(colorItemValue, " ").concat(index <= colorsPopUp.length - 1 ? "- ".concat(colorsPopUp[index]["finishName"]) : "");
                                                        const colorsImage = imageValue && imageValue;
                                                        const urlParts = colorsImage && (colorsImage === null || colorsImage === void 0 ? void 0 : colorsImage.split("/"));
                                                        const imageId = urlParts && urlParts[(urlParts === null || urlParts === void 0 ? void 0 : urlParts.length) - 1];
                                                        const updatedImageWithPreset = colorsImage && (0,helper/* getAsPDPThumbnail */.wN4)(swatchUrl, presetConfig, imageId, accountName);
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            onClick: ()=>showActivePreviewImg(skuValue, imageValue),
                                                            onMouseEnter: ()=>handleMouseEnter(skuValue, imageValue),
                                                            onMouseLeave: handleMouseLeave,
                                                            className: "product-select-style__modal-color-li",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "product-select-style__modal-color-link",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: activeSku === skuValue ? "product-select-style__modal-color-custom-img-block product-select-style__modal-color-custom-img-block-active" : "product-select-style__modal-color-custom-img-block",
                                                                        [dynamicskuId]: dynamicSkuValue,
                                                                        [dynamicColorFinish]: dynamicColorFinishValue,
                                                                        [imageSrc]: imageValue,
                                                                        children: colorsImage !== "N/A" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                            className: "product-select-style__modal-color-select-option-img",
                                                                            src: updatedImageWithPreset,
                                                                            alt: colorValue,
                                                                            onError: (e)=>{
                                                                                return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                                                                            }
                                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                            className: "product-select-style__modal-color-select-option-no-img",
                                                                            src: image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src,
                                                                            alt: colorValue
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        className: "product-select-style__modal-color-sub-heading",
                                                                        children: [
                                                                            colorItemValue,
                                                                            " ",
                                                                            index <= colorsPopUp.length - 1 ? " - ".concat(finishName) : ""
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }, index);
                                                    }) : colorFamilyFilteredValues.map((value, index)=>{
                                                        const [colorValue, colorItemValue, imageValue, skuValue] = value.split("|");
                                                        const filteredPopup = colorsPopUp.find((cp)=>cp["skuId"] === skuValue);
                                                        const dynamicskuId = "skuId";
                                                        const dynamicSkuValue = skuValue;
                                                        const dynamicColorFinish = "colorFinish";
                                                        const imageSrc = "imageItem";
                                                        const dynamicColorFinishValue = "".concat(colorItemValue, " - ").concat(filteredPopup["finishName"]);
                                                        const colorsImage = imageValue && imageValue;
                                                        const urlParts = colorsImage && (colorsImage === null || colorsImage === void 0 ? void 0 : colorsImage.split("/"));
                                                        const imageId = urlParts && urlParts[(urlParts === null || urlParts === void 0 ? void 0 : urlParts.length) - 1];
                                                        const updatedImageWithPreset = colorsImage && (0,helper/* getAsPDPThumbnail */.wN4)(swatchUrl, presetConfig, imageId, accountName);
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            onClick: ()=>showActivePreviewImg(skuValue, imageValue),
                                                            onMouseEnter: ()=>handleMouseEnter(skuValue, imageValue),
                                                            onMouseLeave: handleMouseLeave,
                                                            className: "product-select-style__modal-color-li",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "product-select-style__modal-color-link",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: activeSku === skuValue ? "product-select-style__modal-color-custom-img-block product-select-style__modal-color-custom-img-block-active" : "product-select-style__modal-color-custom-img-block",
                                                                        [dynamicskuId]: dynamicSkuValue,
                                                                        [dynamicColorFinish]: dynamicColorFinishValue,
                                                                        [imageSrc]: imageValue,
                                                                        children: colorsImage !== "N/A" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                            className: "product-select-style__modal-color-select-option-img",
                                                                            src: updatedImageWithPreset,
                                                                            alt: colorValue,
                                                                            onError: (e)=>{
                                                                                return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                                                                            }
                                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                            className: "product-select-style__modal-color-select-option-no-img",
                                                                            src: image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src,
                                                                            alt: colorValue
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        className: "product-select-style__modal-color-sub-heading",
                                                                        children: [
                                                                            colorItemValue,
                                                                            " -",
                                                                            " ",
                                                                            filteredPopup["finishName"]
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }, index);
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "product-select-style__title",
                                                        children: styleOptionsNotPresent && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "product-select-style__note",
                                                            dangerouslySetInnerHTML: {
                                                                __html: DOMPurify.sanitize((0,helper/* cleanRedirectLinks */._Dk)(selectYourStyleInfo))
                                                            }
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var v1_ProductColorFinish = (ProductColorFinish);

// EXTERNAL MODULE: ./src/components/core/SelectDropdown/SelectDropdown.jsx
var SelectDropdown = __webpack_require__(14629);
;// CONCATENATED MODULE: ./components/ProductDetail/v1/SelectYourStyle/v1/ProductSize.jsx





const ProductSize = (props)=>{
    const { comboSkuDetails , i18n , authorData , productCategoryType  } = props;
    const [general, setGeneral] = (0,react.useState)({});
    const allowMaxSize = 3;
    (0,react.useEffect)(()=>{
        const configFn = async ()=>{
            const { general  } = await (0,constants_config/* getConfig */.i)();
            setGeneral(general);
        };
        configFn();
    }, []);
    var _plpPagePath;
    const plpPagePath = (0,helper/* getShortenedUrlwithGeneral */.vu1)((_plpPagePath = general.plpPagePath) !== null && _plpPagePath !== void 0 ? _plpPagePath : "/", general);
    const handleProductSelect = (selectedProductSize)=>{
        const selectedindex = comboSkuDetails.findIndex((obj)=>{
            return obj.ProductSize_ss === selectedProductSize;
        });
        if (selectedProductSize) {
            const selectedProduct = comboSkuDetails[selectedindex];
            const newUrl = "".concat(plpPagePath, "/").concat(productCategoryType.toLowerCase(), "/").concat(selectedProduct.slug_s, ".html?skuId=").concat(selectedProduct.sku_s);
            window.history.replaceState({}, "", newUrl);
            window.location.reload(true);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: comboSkuDetails && comboSkuDetails.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "product-size",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                    className: "title",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "lable",
                            children: [
                                authorData && authorData.sizeShapeDesign ? authorData.sizeShapeDesign : i18n.size,
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "info",
                            children: comboSkuDetails && comboSkuDetails.length > 0 && comboSkuDetails.map((item)=>item.selected_b && item.selected_b === true ? item.ProductGroupDescription_s : "")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: comboSkuDetails.length > allowMaxSize ? "size-row scroll" : "size-row",
                    children: comboSkuDetails.map((item, index)=>{
                        const ProductGroupSwatch = item.ProductGroupSwatch_s ? (0,helper/* sanitizeUrl */.Nmg)("".concat(props.swatchUrl) + item.ProductGroupSwatch_s) : image_missing/* default */.Z;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "size-column ".concat(item.selected_b && item.selected_b === true ? "active" : ""),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: ()=>handleProductSelect(item.ProductSize_ss),
                                    className: "size-swatch",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        onError: (e)=>e.target.src = image_missing/* default */.Z,
                                        src: ProductGroupSwatch,
                                        className: "img"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "desc",
                                    children: item.ProductGroupDescription_s
                                })
                            ]
                        }, "size-".concat(index));
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var v1_ProductSize = (ProductSize);

;// CONCATENATED MODULE: ./components/ProductDetail/v1/SelectYourStyle/v1/StoneTopShelf.jsx







const StoneTopShelf = (props)=>{
    const { comboSkuDetails , i18n , authorData , swatchUrl , productCategoryType , selectStyleTooltipHandler , setSelectStyleTooltip , tooltipdata , styleTooltip , currentSku  } = props;
    const [general, setGeneral] = (0,react.useState)({});
    const [vanityData, setVanityData] = (0,react.useState)(null);
    const [topSwatchDetail, setTopSwatchDetail] = (0,react.useState)([]);
    const [activeValues, setActiveValues] = (0,react.useState)({});
    const [sku, setSku] = (0,react.useState)("");
    var _plpPagePath;
    const plpPagePath = (0,helper/* getShortenedUrlwithGeneral */.vu1)((_plpPagePath = general.plpPagePath) !== null && _plpPagePath !== void 0 ? _plpPagePath : "/", general);
    (0,react.useEffect)(()=>{
        const configFn = async ()=>{
            const { general  } = await (0,constants_config/* getConfig */.i)();
            setGeneral(general);
        };
        configFn();
    }, []);
    (0,react.useEffect)(()=>{
        const findSwatchDetails = comboSkuDetails && comboSkuDetails.length > 0 ? comboSkuDetails.find((item)=>item.selected_b === true) : null;
        if (findSwatchDetails) {
            const matchingSku = findSwatchDetails && findSwatchDetails["topSwatchDetails_ss"] ? findSwatchDetails["topSwatchDetails_ss"].find((sku)=>sku.startsWith(findSwatchDetails.sku_s + "|")) : null;
            let matchingValues = null;
            if (matchingSku) {
                const [sku, vanity, swatch] = matchingSku.split("|");
                matchingValues = {
                    sku,
                    vanity,
                    swatch
                };
            }
            setActiveValues(matchingValues);
            setTopSwatchDetail(findSwatchDetails["topSwatchDetails_ss"]);
            setSku(findSwatchDetails.sku_s);
            setVanityData(findSwatchDetails);
        }
    }, [
        comboSkuDetails
    ]);
    const handleSelect = (sku, vanity, swatch)=>{
        setActiveValues({
            sku,
            vanity,
            swatch
        });
        const vanityUrl = "".concat(plpPagePath, "/").concat(productCategoryType.toLowerCase(), "/").concat(vanityData.slug_s, ".html?skuId=").concat(sku);
        window.history.replaceState({}, "", vanityUrl);
    };
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: comboSkuDetails && comboSkuDetails.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "product-stoneTop",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                    className: "title",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "lable",
                            children: [
                                authorData && authorData.swatchFilename ? authorData.swatchFilename : i18n.stoneTop,
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "info",
                            children: activeValues ? activeValues.vanity : null
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "stoneTop-row",
                    children: [
                        topSwatchDetail && topSwatchDetail.map((item, index)=>{
                            const [vanitysku, vanitymaterial, vanityswatch] = item.split("|");
                            if (!vanitysku || !vanitymaterial || !vanityswatch) {
                                return null;
                            }
                            const KUVanityTopSwatch = vanityswatch ? (0,helper/* sanitizeUrl */.Nmg)("".concat(swatchUrl) + vanityswatch) : image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "column ".concat(vanitysku === activeValues.sku ? "active" : ""),
                                onClick: ()=>handleSelect(vanitysku, vanitymaterial, vanityswatch),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    onError: (e)=>{
                                        return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                                    },
                                    src: KUVanityTopSwatch,
                                    className: "swatch-img",
                                    alt: vanitymaterial
                                })
                            }, "TopSwatch-".concat(index));
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "tool-tip",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: tooltip_new === null || tooltip_new === void 0 ? void 0 : tooltip_new.src,
                                    className: "vanitytooltip",
                                    onMouseOver: ()=>selectStyleTooltipHandler(false, false, false, true, (ref = tooltipdata["KUVanityTopSwatchFilename_s"]) !== null && ref !== void 0 ? ref : "n/a"),
                                    onMouseLeave: ()=>setSelectStyleTooltip({
                                            shareTooltip: false,
                                            colorTooltip: false,
                                            finishTooltip: false,
                                            vanityTooltip: false
                                        })
                                }),
                                tooltipdata && tooltipdata["KUVanityTopSwatchFilename_s"] && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "product-select-style__list-tooltip".concat((styleTooltip === null || styleTooltip === void 0 ? void 0 : styleTooltip.vanityTooltip) ? "--show" : "--hide"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-select-style__list-tooltip-color-wrapper",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolTip/* default */.Z, {
                                            message: tooltipdata["KUVanityTopSwatchFilename_s"]
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var v1_StoneTopShelf = (StoneTopShelf);

;// CONCATENATED MODULE: ./components/ProductDetail/v1/SelectYourStyle/v1/SelectYourStyle.view.jsx











const SelectYourStyleView = (param)=>{
    let { authorData ={} , applyBtn , colorFamily , closeModal , colorHeading ="" , colors =[] , colorsPopUp , descriptionDetail ="" , descriptionDetails ="" , finishFilterChange , colorFamilyCount , finishSelectedValue ="" , finishType =[] , getNewVarients , handleShapeSizeSelectChange , i18n ={} , isColor , isColorDiscontinued , isDiscontinued , image , isShape , modalColorApplyBtn , notallowFinishValue , openFilter , openModal , ProductDescriptionDetail ="" , ProductLocalCategory , productTitle , selectStyleTooltipHandler , setSelectStyleTooltip , styleTooltip , swatchUrl ="" , showActivePreview , showFilter , showModal , tooltip ="" , tooltipdata ={} , updateLabelHeading , updateShapeImagePreview , allowMaxColor , colorsDiscontinuedVarients =[] , currentSku , finalAvailableColors =[] , shapeHeading , comboSkuDetails =[] , productCategoryType ="" , NO_FINISH_TYPE , activeSku ="" , isCollapsedPDP , discontinuedCTALink ="" , presetConfig ={} , accountName ="" , productImages =[] , applySelectedShape , styleOptionsNotPresent  } = param;
    const truncateText = (text, maxLength)=>{
        return (text === null || text === void 0 ? void 0 : text.length) > maxLength ? text.slice(0, maxLength) + "..." : text;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (isDiscontinued || isColorDiscontinued) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    (colorsDiscontinuedVarients === null || colorsDiscontinuedVarients === void 0 ? void 0 : colorsDiscontinuedVarients.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "product-select-style__color product-select-style__discoutinued-main-block",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "product-select-style__color-label",
                                        children: [
                                            i18n.productSelectStyleDiscotinuedLabel,
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "product-select-style__color-text",
                                        id: "product-select-style__color-text",
                                        children: currentSku ? (colorsDiscontinuedVarients === null || colorsDiscontinuedVarients === void 0 ? void 0 : colorsDiscontinuedVarients.length) > 0 && colorsDiscontinuedVarients.map((colorsItem)=>{
                                            return colorsItem["id"] === currentSku && colorsItem["label"];
                                        }) : ""
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product-select-style__color-img-block",
                                children: (colorsDiscontinuedVarients === null || colorsDiscontinuedVarients === void 0 ? void 0 : colorsDiscontinuedVarients.length) > 0 && colorsDiscontinuedVarients.map((colorsItem, idx)=>{
                                    return colorsItem["id"] === currentSku && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-select-style__color-img-outer-block product-select-style__color-img-outer-block-active",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            onError: (e)=>{
                                                return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                                            },
                                            src: colorsItem["colorUrl"] ? colorsItem["colorUrl"] : image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src,
                                            className: "product-select-style__color-image"
                                        })
                                    }, "colorsDiscontinuedVarients-".concat(idx));
                                })
                            })
                        ]
                    }),
                    isColorDiscontinued && !isDiscontinued ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "product-select-style__discoutinued-block",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "product-select-style__discoutinued-msg",
                                children: i18n.productSelectStyleDiscotinuedMsg
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "product-select-style__discoutinued-link-block",
                                children: (finalAvailableColors === null || finalAvailableColors === void 0 ? void 0 : finalAvailableColors.length) > 0 && finalAvailableColors["0"]["skuId"] && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "javascript:void(0)",
                                    className: "product-select-style__discoutinued-link-lable",
                                    onClick: ()=>getNewVarients(finalAvailableColors["0"]["skuId"] ? finalAvailableColors["0"]["skuId"] : "", finalAvailableColors["0"], true),
                                    children: i18n.seeAvailableColor
                                })
                            })
                        ]
                    }) : isDiscontinued ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "product-select-style__discoutinued-block",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "product-select-style__discoutinued-msg",
                                children: i18n.productSelectStyleDiscotinuedMsg
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "product-select-style__discoutinued-link-block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: (0,helper/* getShortenedUrl */.Ppy)(discontinuedCTALink),
                                    className: "product-select-style__discoutinued-link-lable",
                                    children: (authorData === null || authorData === void 0 ? void 0 : authorData.discontinuedCTALabel) || i18n.contactShowroom
                                })
                            })
                        ]
                    }) : ""
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ProductColorFinish, {
                swatchUrl: swatchUrl,
                productTitle: productTitle,
                isDiscontinued: isDiscontinued,
                isColorDiscontinued: isColorDiscontinued,
                isShape: isShape,
                image: image,
                showModal: showModal,
                isColor: isColor,
                colorsPopUp: colorsPopUp,
                ProductLocalCategory: ProductLocalCategory,
                i18n: i18n,
                showActivePreview: showActivePreview,
                updateShapeImagePreview: updateShapeImagePreview,
                closeModal: closeModal,
                modalColorApplyBtn: modalColorApplyBtn,
                openFilter: openFilter,
                applyBtn: applyBtn,
                showFilter: showFilter,
                colorFamily: colorFamily,
                colorFamilyCount: colorFamilyCount,
                activeSku: activeSku,
                presetConfig: presetConfig,
                accountName: accountName,
                productImages: productImages,
                applySelectedShape: applySelectedShape,
                styleOptionsNotPresent: styleOptionsNotPresent,
                selectYourStyleInfo: authorData === null || authorData === void 0 ? void 0 : authorData.selectYourStyleInfo
            }),
            !isDiscontinued && !isColorDiscontinued && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    (colors.length > 0 || image.length > 1) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: "product-select-style__title",
                        children: [
                            authorData && authorData.selectYourStyleTitle ? authorData.selectYourStyleTitle : i18n.productSelectStyleTitle,
                            styleOptionsNotPresent && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "product-select-style__note",
                                dangerouslySetInnerHTML: {
                                    __html: DOMPurify.sanitize((0,helper/* cleanRedirectLinks */._Dk)(authorData === null || authorData === void 0 ? void 0 : authorData.selectYourStyleInfo))
                                }
                            })
                        ]
                    }),
                    isCollapsedPDP && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ProductSize, {
                        comboSkuDetails: comboSkuDetails,
                        i18n: i18n,
                        swatchUrl: swatchUrl,
                        productCategoryType: productCategoryType,
                        authorData: authorData
                    }),
                    image.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product-select-style__shape",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "product-select-style__shape-label",
                                    children: [
                                        authorData && authorData.sizeShapeDesign ? "".concat(authorData.sizeShapeDesign, " ") : "".concat(i18n.productSelectStyleShapeLabel, " "),
                                        shapeHeading,
                                        image.length >= 7 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "product-select-style__shape-count",
                                            children: " / " + parseInt(image.length) + " " + i18n.productSelectStyleShapeTotalOptions
                                        }) : ""
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: image.length < 7 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "product-select-style__shape-img-block",
                                    role: "radiogroup",
                                    "aria-label": authorData && authorData.sizeShapeDesign ? authorData.sizeShapeDesign : i18n.productSelectStyleShapeLabel,
                                    children: [
                                        image.length > 0 && image.map((imageItem, i)=>{
                                            const activeImageItem = image.find((imageItem)=>imageItem["isActive"]);
                                            const shapeImage = imageItem["src"] && imageItem["src"];
                                            const urlParts = shapeImage && (shapeImage === null || shapeImage === void 0 ? void 0 : shapeImage.split("/"));
                                            const imageId = urlParts && urlParts[(urlParts === null || urlParts === void 0 ? void 0 : urlParts.length) - 1];
                                            const updatedImageWithPreset = shapeImage && (0,helper/* getAsPDPThumbnail */.wN4)(swatchUrl, presetConfig, imageId, accountName);
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                "aria-label": imageItem["name"],
                                                onClick: ()=>handleShapeSizeSelectChange(imageItem["name"], imageItem["src"]),
                                                onMouseOver: ()=>updateLabelHeading("product-select-style__shape-text", imageItem["name"]),
                                                onMouseLeave: ()=>updateLabelHeading("product-select-style__shape-text", activeImageItem["name"]),
                                                role: "radio",
                                                "aria-checked": imageItem["isActive"] === true,
                                                className: "product-select-style__shape-button",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    onError: (e)=>{
                                                        return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                                                    },
                                                    src: updatedImageWithPreset !== null && updatedImageWithPreset !== void 0 ? updatedImageWithPreset : image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src,
                                                    "aria-hidden": "true",
                                                    alt: imageItem["name"],
                                                    className: imageItem["isActive"] === true ? "product-select-style__shape-image product-select-style__shape-image-active" : "product-select-style__shape-image"
                                                })
                                            }, i);
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            role: "tooltip",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: tooltip === null || tooltip === void 0 ? void 0 : tooltip.src,
                                                    onMouseOver: ()=>{
                                                        return selectStyleTooltipHandler(true, false, false, false, tooltipdata === null || tooltipdata === void 0 ? void 0 : tooltipdata.ProductDetailImageURL_s);
                                                    },
                                                    onFocus: ()=>{
                                                        return selectStyleTooltipHandler(true, false, false, false, tooltipdata === null || tooltipdata === void 0 ? void 0 : tooltipdata.ProductDetailImageURL_s);
                                                    },
                                                    onMouseLeave: ()=>setSelectStyleTooltip({
                                                            shareTooltip: false,
                                                            colorTooltip: false,
                                                            finishTooltip: false,
                                                            vanityTooltip: false
                                                        }),
                                                    onBlur: ()=>setSelectStyleTooltip({
                                                            shareTooltip: false,
                                                            colorTooltip: false,
                                                            finishTooltip: false,
                                                            vanityTooltip: false
                                                        }),
                                                    tabIndex: "0",
                                                    className: "product-select-style__shape-tooltip",
                                                    "aria-describedby": "tooltip-message"
                                                }),
                                                (tooltipdata === null || tooltipdata === void 0 ? void 0 : tooltipdata.ProductDetailImageURL_s) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    id: "tooltip-message",
                                                    className: "product-select-style__list-tooltip".concat(styleTooltip.shareTooltip ? "--show" : "--hide"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "product-select-style__list-tooltip-wrapper",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolTip/* default */.Z, {
                                                            message: tooltipdata.ProductDetailImageURL_s
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "product-select-style__color-custom-block product-select-style-shape",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "product-select-style__color-custom-select-block mb-20",
                                            onClick: ()=>openModal("shape"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                className: "product-select-style__shape-ul p-0 m-0",
                                                children: image.length > 0 && image.map((imageItem, i)=>{
                                                    return imageItem["isActive"] === true && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                        className: "product-select-style__shape-li",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                href: "javascript:void(0)",
                                                                className: "product-select-style__shape-link",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        onError: (e)=>{
                                                                            return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                                                                        },
                                                                        src: imageItem["src"],
                                                                        className: "product-select-style__shape-select-option-img"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "product-select-style__shape-sub-heading",
                                                                        children: imageItem["name"]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                onError: (e)=>{
                                                                    return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                                                                },
                                                                src: arrow_down_new === null || arrow_down_new === void 0 ? void 0 : arrow_down_new.src,
                                                                className: "product-select-style__shape-arrow-down-img"
                                                            })
                                                        ]
                                                    }, "imageItem-".concat(i));
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "product-select-style__shape-select-tooltip-block",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: tooltip === null || tooltip === void 0 ? void 0 : tooltip.src,
                                                    className: "product-select-style__shape-select-tooltip",
                                                    onMouseOver: ()=>{
                                                        return selectStyleTooltipHandler(true, false, false, false, tooltipdata === null || tooltipdata === void 0 ? void 0 : tooltipdata.ProductDetailImageURL_s);
                                                    },
                                                    onMouseLeave: ()=>setSelectStyleTooltip({
                                                            shareTooltip: false,
                                                            colorTooltip: false,
                                                            finishTooltip: false,
                                                            vanityTooltip: false
                                                        })
                                                }),
                                                (tooltipdata === null || tooltipdata === void 0 ? void 0 : tooltipdata.ProductDetailImageURL_s) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "product-select-style__list-tooltip".concat(styleTooltip.shareTooltip ? "--show" : "--hide"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "product-select-style__list-tooltip-color-wrapper",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolTip/* default */.Z, {
                                                            message: tooltipdata.ProductDetailImageURL_s
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: colors.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: finishType.length <= notallowFinishValue ? "product-select-style__color color-finish" : "product-select-style__color",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "product-select-style__color-label",
                                        children: [
                                            authorData && authorData.color ? authorData.color : finishType.length <= notallowFinishValue ? "".concat(i18n.productSelectStyleColorLabel, "/").concat(i18n.productSelectStyleFinishLabel) : i18n.productSelectStyleColorLabel,
                                            ": ",
                                            colorHeading,
                                            finishType.length > notallowFinishValue && colors.length > allowMaxColor && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "product-select-style__color-count",
                                                children: " / ".concat(colors.length, " ").concat(i18n.productSelectStyleShapeTotalOptions)
                                            })
                                        ]
                                    })
                                }),
                                colors.length < allowMaxColor ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "product-select-style__color-img-block",
                                    role: "radiogroup",
                                    "aria-label": authorData && authorData.color ? authorData.color : finishType.length <= notallowFinishValue ? "".concat(i18n.productSelectStyleColorLabel, "/").concat(i18n.productSelectStyleFinishLabel) : i18n.productSelectStyleColorLabel,
                                    children: [
                                        colors.length > 0 && colors.map((colorsItem, i)=>{
                                            const activeColorItem = colors.find((color)=>color["isActive"] === true);
                                            const colorImage = colorsItem["src"] && colorsItem["src"];
                                            const urlParts = colorImage && (colorImage === null || colorImage === void 0 ? void 0 : colorImage.split("/"));
                                            const imageId = urlParts && urlParts[(urlParts === null || urlParts === void 0 ? void 0 : urlParts.length) - 1];
                                            const updatedColorImageWithPreset = colorImage && (0,helper/* getAsPDPThumbnail */.wN4)(swatchUrl, presetConfig, imageId, accountName);
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                role: "radio",
                                                className: colorsItem["isActive"] === true ? "product-select-style__color-img-outer-block product-select-style__color-img-outer-block-active" : "product-select-style__color-img-outer-block",
                                                onClick: ()=>getNewVarients(colorsItem["skuId"] ? colorsItem["skuId"] : "", colorsItem, true),
                                                onMouseOver: ()=>updateLabelHeading("product-select-style__color-text", "".concat(colorsItem["name"], " ").concat(colorsItem["finishName"] !== NO_FINISH_TYPE ? " - ".concat(colorsItem["finishName"]) : "")),
                                                onMouseLeave: ()=>updateLabelHeading("product-select-style__color-text", "".concat(activeColorItem["name"], " ").concat(activeColorItem["finishName"] !== NO_FINISH_TYPE ? " -  ".concat(activeColorItem["finishName"]) : "")),
                                                "aria-checked": colorsItem["isActive"] === true,
                                                tabIndex: "0",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    onError: (e)=>{
                                                        return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                                                    },
                                                    src: updatedColorImageWithPreset !== null && updatedColorImageWithPreset !== void 0 ? updatedColorImageWithPreset : image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src,
                                                    className: "product-select-style__color-image",
                                                    alt: "Color is ".concat(activeColorItem["name"], " ").concat(activeColorItem["finishName"]),
                                                    tabIndex: "0"
                                                })
                                            }, i);
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            role: "tooltip",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: tooltip === null || tooltip === void 0 ? void 0 : tooltip.src,
                                                    className: "product-select-style__color-tooltip",
                                                    tabIndex: 0,
                                                    onMouseOver: ()=>selectStyleTooltipHandler(false, true, false, false, tooltipdata["Color.Name"]),
                                                    onFocus: ()=>selectStyleTooltipHandler(false, true, false, false, tooltipdata["Color.Name"]),
                                                    onMouseLeave: ()=>setSelectStyleTooltip({
                                                            shareTooltip: false,
                                                            colorTooltip: false,
                                                            finishTooltip: false,
                                                            vanityTooltip: false
                                                        }),
                                                    onBlur: ()=>setSelectStyleTooltip({
                                                            shareTooltip: false,
                                                            colorTooltip: false,
                                                            finishTooltip: false,
                                                            vanityTooltip: false
                                                        }),
                                                    "aria-describedby": "tooltip-color-message"
                                                }),
                                                tooltipdata && tooltipdata["Color.Name"] && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    id: "tooltip-color-message",
                                                    className: "product-select-style__list-tooltip".concat(styleTooltip.colorTooltip ? "--show" : "--hide"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "product-select-style__list-tooltip-color-wrapper",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolTip/* default */.Z, {
                                                            message: tooltipdata["Color.Name"]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: colors.length >= allowMaxColor ? "product-select-style__color-custom-block product-select-style-color product-color-dropdown" : "product-select-style__color-custom-block product-select-style-color",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "product-select-style__color-custom-select-block",
                                            onClick: ()=>openModal("color"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                className: "product-select-style__color-ul p-0 m-0",
                                                children: colors.length > 0 && colors.map((colorsItem, idx)=>{
                                                    const colorsItemImage = colorsItem["src"] && colorsItem["src"];
                                                    const urlParts = colorsItemImage && (colorsItemImage === null || colorsItemImage === void 0 ? void 0 : colorsItemImage.split("/"));
                                                    const imageId = urlParts && urlParts[(urlParts === null || urlParts === void 0 ? void 0 : urlParts.length) - 1];
                                                    const updatedColorsImageWithPreset = colorsItemImage && (0,helper/* getAsPDPThumbnail */.wN4)(swatchUrl, presetConfig, imageId, accountName);
                                                    return colorsItem["isActive"] === true && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                        className: "product-select-style__color-li",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                href: "javascript:void(0)",
                                                                className: "product-select-style__color-link",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "product-select-style__color-select-option-img-block",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                            onError: (e)=>{
                                                                                return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                                                                            },
                                                                            src: updatedColorsImageWithPreset !== null && updatedColorsImageWithPreset !== void 0 ? updatedColorsImageWithPreset : image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src,
                                                                            className: "product-select-style__color-select-option-img"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "product-select-style__color-sub-heading",
                                                                        children: colorsItem["finishName"] !== NO_FINISH_TYPE ? truncateText("".concat(colorsItem["name"], " - ").concat(colorsItem["finishName"]), 30) : truncateText(colorsItem["name"], 30)
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                onError: (e)=>{
                                                                    return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                                                                },
                                                                src: arrow_down_new === null || arrow_down_new === void 0 ? void 0 : arrow_down_new.src,
                                                                className: "product-select-style__color-arrow-down-img"
                                                            })
                                                        ]
                                                    }, "colors-".concat(idx));
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "product-select-style__color-select-tooltip-block",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: tooltip === null || tooltip === void 0 ? void 0 : tooltip.src,
                                                    onMouseOver: ()=>selectStyleTooltipHandler(false, true, false, false, tooltipdata["Color.Name"]),
                                                    onMouseLeave: ()=>setSelectStyleTooltip({
                                                            shareTooltip: false,
                                                            colorTooltip: false,
                                                            finishTooltip: false,
                                                            vanityTooltip: false
                                                        }),
                                                    className: "product-select-style__color-select-tooltip"
                                                }),
                                                tooltipdata && tooltipdata["Color.Name"] && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "product-select-style__list-tooltip".concat(styleTooltip.colorTooltip ? "--show" : "--hide"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "product-select-style__list-tooltip-color-wrapper",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolTip/* default */.Z, {
                                                            message: tooltipdata["Color.Name"]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: (finishType === null || finishType === void 0 ? void 0 : finishType.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: (finishType === null || finishType === void 0 ? void 0 : finishType.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-select-style__finish",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            className: "m-0",
                                            htmlFor: "finish-select",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "product-select-style__finish-label",
                                                    children: [
                                                        i18n.productSelectStyleFinishLabel,
                                                        ":"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "product-select-style__finish-text",
                                                    id: "product-select-style__finish-text",
                                                    children: finishSelectedValue
                                                }),
                                                (finishType === null || finishType === void 0 ? void 0 : finishType.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "product-select-style__finish-count",
                                                    children: " / " + (parseInt(finishType === null || finishType === void 0 ? void 0 : finishType.length) - 1) + " " + i18n.productSelectStyleShapeTotalOptions
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-select-style__finish-form",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                            className: "form",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                                                    id: "finish-select",
                                                    data: finishType,
                                                    value: finishSelectedValue,
                                                    onChange: (val)=>finishFilterChange(val),
                                                    label: "finish-select"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: tooltip === null || tooltip === void 0 ? void 0 : tooltip.src,
                                                    onMouseOver: ()=>selectStyleTooltipHandler(false, false, true, false, tooltipdata["colorFinishFamilyList_ss"]),
                                                    onMouseLeave: ()=>setSelectStyleTooltip({
                                                            shareTooltip: false,
                                                            colorTooltip: false,
                                                            finishTooltip: false,
                                                            vanityTooltip: false
                                                        }),
                                                    className: "product-select-style__finish-tooltip"
                                                }),
                                                tooltipdata && tooltipdata["colorFinishFamilyList_ss"] && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "product-select-style__list-tooltip".concat(styleTooltip.finishTooltip ? "--show" : "--hide"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "product-select-style__list-tooltip-color-wrapper",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolTip/* default */.Z, {
                                                            message: tooltipdata["colorFinishFamilyList_ss"]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }) : null
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_StoneTopShelf, {
                        i18n: i18n,
                        authorData: authorData,
                        comboSkuDetails: comboSkuDetails,
                        swatchUrl: swatchUrl,
                        productCategoryType: productCategoryType,
                        selectStyleTooltipHandler: selectStyleTooltipHandler,
                        setSelectStyleTooltip: setSelectStyleTooltip,
                        tooltipdata: tooltipdata,
                        styleTooltip: styleTooltip,
                        currentSku: currentSku
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var SelectYourStyle_view = (SelectYourStyleView);

;// CONCATENATED MODULE: ./components/ProductDetail/v1/SelectYourStyle/v1/SelectYourStyle.jsx














const SelectYourStyle = (param)=>{
    let { i18n , imageDetails , selectOption , setSkuVariant , colorDiscontinuedVarients , isDiscontinued , customLabelDetails , isColorDiscontinued , productTitle , authorData , descriptionDetails =[] , lwAppName ="" , ProductLocalCategory ="" , productCollection ="" , availableColors =[] , priceData =[] , isCollapsedPDP , productImages , ...props } = param;
    var ref;
    let currentSku = (props === null || props === void 0 ? void 0 : props.currentSku) ? props === null || props === void 0 ? void 0 : props.currentSku : "";
    const [colorHeading, setColorHeading] = (0,react.useState)(null);
    const [showModal, setShowModal] = (0,react.useState)(false);
    const [isShape, setModalShape] = (0,react.useState)(false);
    const [shapeHeading, setShapeHeading] = (0,react.useState)(null);
    const [isColor, setModalColor] = (0,react.useState)(false);
    const [showFilter, setModalFilter] = (0,react.useState)(false);
    const [colors, setColors] = (0,react.useState)([]);
    const [colorsPopUp, setColorsPopUp] = (0,react.useState)([]);
    const [finish, setFinish] = (0,react.useState)([]);
    const [colorFamily, setColorFamily] = (0,react.useState)([]);
    const [colorFamilyCount, SetColorFamilyCount] = (0,react.useState)([]);
    const [activeSku, setActiveSku] = (0,react.useState)("");
    const [CONFIG, setCONFIG] = (0,react.useState)({});
    const [general, setGeneral] = (0,react.useState)({});
    const [colorsDiscontinuedVarients, setDiscontinuedColors] = (0,react.useState)(colorDiscontinuedVarients);
    const [discontinuedCTALink, setDiscontinuedCTALink] = (0,react.useState)("");
    const [finalAvailableColors, setAvailableColors] = (0,react.useState)([]);
    const [image, setImage] = (0,react.useState)([]);
    const [styleTooltip, setSelectStyleTooltip] = (0,react.useState)({
        shareTooltip: false,
        colorTooltip: false,
        finishTooltip: false,
        vanityTooltip: false
    });
    const SHOWALL = "Show All";
    const NO_FINISH_TYPE = "noFinishType";
    const [tooltipdata, setTooltipData] = (0,react.useState)([]);
    const finishType = (props === null || props === void 0 ? void 0 : (ref = props.finishType) === null || ref === void 0 ? void 0 : ref.length) > 1 ? [
        SHOWALL,
        ...props.finishType
    ] : props === null || props === void 0 ? void 0 : props.finishType;
    let styleOptionsNotPresent = (props === null || props === void 0 ? void 0 : props.styleOptionsNotPresent) || false;
    const [finishSelectedValue, setFinishSelectedValue] = (0,react.useState)();
    const [colorDefaultDetails, setColorDefaultDetails] = (0,react.useState)([]);
    const [tempIndex, setTempIndex] = (0,react.useState)(0);
    const [ProductDescriptionDetail, setProductDescriptionDetail] = (0,react.useState)(props === null || props === void 0 ? void 0 : props.ProductDescriptionDetail_s);
    const [updatedImageDetails, setUpdatedImageDetails] = (0,react.useState)(undefined);
    const allowMaxColor = 7;
    const notallowFinishValue = 1;
    const handleShapeSizeDesignImageUrl = (productDescriptions, productDetailImageURLs)=>{
        return productDescriptions.reduce((acc, item)=>{
            const cloneProductDetailImageURLs = productDetailImageURLs === null || productDetailImageURLs === void 0 ? void 0 : productDetailImageURLs.map((productDetailImageURL)=>productDetailImageURL.split("|")[0]);
            const addedImageUrls = acc === null || acc === void 0 ? void 0 : acc.map((productDetailImageURL)=>productDetailImageURL.split("|")[0]);
            const findx = cloneProductDetailImageURLs.findIndex((aa)=>aa === item);
            if (cloneProductDetailImageURLs.includes(item) && !addedImageUrls.includes(item)) {
                acc.push(productDetailImageURLs[findx]);
            } else if (!cloneProductDetailImageURLs.includes(item) && !addedImageUrls.includes(item) && findx === -1) {
                styleOptionsNotPresent = true;
                return [
                    ...acc
                ];
            }
            return acc.flat();
        }, []);
    };
    const descriptionDetails_ = descriptionDetails === null || descriptionDetails === void 0 ? void 0 : descriptionDetails.filter((_, idx)=>idx % 2 === 0);
    const shapeImageUrls = imageDetails === null || imageDetails === void 0 ? void 0 : imageDetails.filter((_, idx)=>idx % 2 === 0);
    const updatedImageDetailsFn = (0,react.useCallback)(()=>handleShapeSizeDesignImageUrl(descriptionDetails_, shapeImageUrls), [
        shapeImageUrls
    ]);
    const updatedImageDetails_ = updatedImageDetailsFn();
    const shapeSizeDesignImageDescription = updatedImageDetails && (updatedImageDetails === null || updatedImageDetails === void 0 ? void 0 : updatedImageDetails.filter((_, idx)=>idx % 2 === 0).map((imageDetail)=>{
        const split = imageDetail === null || imageDetail === void 0 ? void 0 : imageDetail.split("|");
        return {
            code: split[0],
            image: split[1]
        };
    }));
    const [descriptionDetail, setDescriptionDetail] = (0,react.useState)("");
    const [descripritionWithImageDetail, setDescripritionWithImageDetail] = (0,react.useState)({});
    (0,react.useEffect)(()=>{
        const configFn = async ()=>{
            const config = await (0,constants_config/* getConfig */.i)();
            setCONFIG(config);
        };
        configFn();
    }, []);
    const plpServletPath = get_default()(CONFIG, "plpServletPath", "");
    const selectedCategoriesForStandaloneListprice = [
        "Trims & Moldings",
        "Field Tiles",
        "Mosaics"
    ];
    (0,react.useEffect)(()=>{
        const configFn = async ()=>{
            const { general  } = await (0,constants_config/* getConfig */.i)();
            setGeneral(general);
        };
        configFn();
    }, []);
    (0,react.useEffect)(()=>{
        const handleShortned = async ()=>{
            const discontinueShortened = await (0,helper/* getShortenedUrl */.Ppy)(authorData === null || authorData === void 0 ? void 0 : authorData.discontinuedCTALink);
            setDiscontinuedCTALink(discontinueShortened);
        };
        handleShortned();
        setProductDescriptionDetail(props === null || props === void 0 ? void 0 : props.ProductDescriptionDetail_s);
    }, [
        authorData
    ]);
    (0,react.useEffect)(()=>{
        setDescriptionDetail((descriptionDetails_ === null || descriptionDetails_ === void 0 ? void 0 : descriptionDetails_.length) > 0 ? descriptionDetails_[0] : "");
        setUpdatedImageDetails(updatedImageDetails_);
        setDescripritionWithImageDetail((shapeSizeDesignImageDescription === null || shapeSizeDesignImageDescription === void 0 ? void 0 : shapeSizeDesignImageDescription.length) > 0 ? shapeSizeDesignImageDescription[0] : "");
    }, [
        imageDetails
    ]);
    const dispatch = (0,es/* useDispatch */.I0)();
    let queryParams = new URLSearchParams(window.location.search);
    const productDescriptionDetailFormat = function() {
        let productDescriptionDetail = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        const numbers = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9
        ];
        const toArr = productDescriptionDetail === null || productDescriptionDetail === void 0 ? void 0 : productDescriptionDetail.split("");
        return toArr === null || toArr === void 0 ? void 0 : toArr.map((item, idx)=>{
            if (numbers.includes(parseInt(item)) && !numbers.includes(parseInt(toArr[idx + 1]))) {
                return item + "\\";
            } else return item;
        }).join("");
    };
    const handleShapeSizeSelectChange = async function(selectedItem) {
        let imageUrl = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, isOverlay = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        var ref, ref1, ref2, ref3;
        setDescriptionDetail(selectedItem);
        setProductDescriptionDetail(selectedItem);
        setDescripritionWithImageDetail(selectedItem);
        const { data  } = await api/* apim.get */.TH.get("/search/plp", {
            params: {
                q: "*:*",
                fq: [
                    'Collapse_Field_s:"'.concat(ProductLocalCategory, " ").concat(productCollection, '"'),
                    "isCollapsedPDP_b:true",
                    'ProductDescriptionDetail_s:"'.concat(productDescriptionDetailFormat(selectedItem), '"')
                ],
                fl: "slug_s",
                profilename: "profile_".concat(lwAppName.toLowerCase(), "_PDP"),
                collections: lwAppName.toLowerCase()
            },
            paramsSerializer: (params)=>lib_default().stringify(params, {
                    arrayFormat: "repeat",
                    encode: true
                })
        });
        const slug = (ref1 = data === null || data === void 0 ? void 0 : (ref = data.response) === null || ref === void 0 ? void 0 : ref.docs[0]) === null || ref1 === void 0 ? void 0 : ref1["slug_s"];
        let datalayerObj = {
            title: isOverlay ? i18n === null || i18n === void 0 ? void 0 : (ref2 = i18n.productSelectStyleShapeApplyBtn) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase() : "style selection",
            productInfo: (ref3 = JSON.stringify({
                style: selectedItem,
                defaultImageName: imageUrl
            })) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()
        };
        if (isOverlay) {
            var ref4;
            datalayerObj.sysOverlayObj = {
                overlayTitle: "select your style overlay",
                overlayType: i18n === null || i18n === void 0 ? void 0 : (ref4 = i18n.productSelectStyleShapeLabel) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase(),
                sysVal: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.toLowerCase()
            };
        } else {
            datalayerObj.shapeVal = selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.toLowerCase();
        }
        analytics_addDataLayer(datalayerObj);
        if (ProductLocalCategory && plpServletPath) {
            let pdpPageDetails = plpServletPath.find((el)=>el.categories.includes(ProductLocalCategory));
            const redirect = pdpPageDetails ? (pdpPageDetails === null || pdpPageDetails === void 0 ? void 0 : pdpPageDetails.url) ? (0,helper/* getShortenedUrlwithGeneral */.vu1)(pdpPageDetails.url + "/" + slug + ".html", general) : "" : "";
            window.location = redirect;
        }
    };
    (0,react.useEffect)(()=>{
        const skuId = queryParams.has("skuId") ? queryParams.get("skuId") : "";
        skuId && dispatch((0,pdpSlice/* updateVariantSkuInTabDetails */.Bm)({
            sku: skuId
        }));
        if (finishSelectedValue && colorDefaultDetails.length) {
            !skuId && queryParams.set("skuId", colorDefaultDetails[0].split("|")[2]);
            queryParams.set("finish", finishSelectedValue);
            window.history.replaceState(null, null, "?" + queryParams.toString());
        }
    }, [
        finishSelectedValue
    ]);
    const finishFilterChange = (val)=>{
        setFinishSelectedValue(val);
        analytics_addDataLayer({
            title: "finish selection",
            productInfo: props === null || props === void 0 ? void 0 : props.analyticsProductInfo,
            finishVal: val === null || val === void 0 ? void 0 : val.toLowerCase()
        });
        if ((val === null || val === void 0 ? void 0 : val.toLowerCase()) === SHOWALL.toLowerCase()) {
            var ref;
            const colorBaseFinish = getColorBasedFinish(val);
            queryParams.set("finish", val);
            const modifiedColorsData = modifyColorData(props === null || props === void 0 ? void 0 : props.colorDetails, 1, "");
            let clonedColorsData = [
                ...modifiedColorsData
            ];
            if (clonedColorsData && clonedColorsData.length > 0) {
                setColorsPopUp(clonedColorsData);
                setColors(modifiedColorsData);
            }
            setColorDefaultDetails(props === null || props === void 0 ? void 0 : props.colorDetails);
            setFinishSelectedValue(val);
            const skuId = queryParams.has("skuId") ? queryParams.get("skuId") : "";
            if (val && (colorBaseFinish === null || colorBaseFinish === void 0 ? void 0 : colorBaseFinish.length)) {
                queryParams.set("skuId", skuId);
                queryParams.set("finish", val);
                window.history.replaceState(null, null, "?" + queryParams.toString());
            }
            const colorsItem = (modifiedColorsData === null || modifiedColorsData === void 0 ? void 0 : modifiedColorsData.find((colorDetail)=>colorDetail["skuId"] === skuId)) || {};
            skuId && getNewVarients(colorsItem["skuId"] ? colorsItem["skuId"] : "", colorsItem);
            var ref1;
            let colorDataDetails = (ref1 = modifiedColorsData === null || modifiedColorsData === void 0 ? void 0 : modifiedColorsData.find((colorData)=>{
                return (colorData === null || colorData === void 0 ? void 0 : colorData.skuId) === skuId;
            })) !== null && ref1 !== void 0 ? ref1 : {};
            if (colorDataDetails && ((ref = Object.keys(colorDataDetails)) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                setColorHeading(colorDataDetails["name"] + " - " + colorDataDetails["finishName"]);
                colorDataDetails["isActive"] = true;
            }
            return;
        }
        let colorBaseFinish1 = getColorBasedFinish(val);
        setColorDefaultDetails(colorBaseFinish1);
        if (val && (colorBaseFinish1 === null || colorBaseFinish1 === void 0 ? void 0 : colorBaseFinish1.length)) {
            queryParams.set("skuId", colorBaseFinish1[0].split("|")[2]);
            queryParams.set("finish", val);
            window.history.replaceState(null, null, "?" + queryParams.toString());
        }
        let tmpColorData = colorBaseFinish1.length > 0 ? modifyColorData(colorBaseFinish1, 1, "") : "";
        let colorDataDetails1 = [
            ...tmpColorData
        ];
        if (colorDataDetails1 && (colorDataDetails1 === null || colorDataDetails1 === void 0 ? void 0 : colorDataDetails1.length) > 0) {
            setColorHeading("".concat(colorDataDetails1[0]["name"], " ").concat(colorDataDetails1[0]["finishName"] !== NO_FINISH_TYPE ? " - ".concat(colorDataDetails1[0]["finishName"]) : ""));
            colorDataDetails1[0]["isActive"] = true;
        }
        setColorsPopUp(tmpColorData);
        setColors(colorDataDetails1);
        const skuId1 = queryParams.has("skuId") ? queryParams.get("skuId") : "";
        const colorsItem1 = (colorDataDetails1 === null || colorDataDetails1 === void 0 ? void 0 : colorDataDetails1.find((colorDetail)=>colorDetail["skuId"] === skuId1)) || {};
        skuId1 && getNewVarients(colorsItem1["skuId"] ? colorsItem1["skuId"] : "", colorsItem1);
    };
    const finishTypeFromSkuId = function() {
        let skuId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", colorDetails = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], colorFinishTypeDetails = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
        let finishVal = "";
        const colorDetail = Array.isArray(colorDetails) ? colorDetails === null || colorDetails === void 0 ? void 0 : colorDetails.filter((cd)=>{
            return (cd === null || cd === void 0 ? void 0 : cd.split("|")[2]) === skuId;
        })[0] : "";
        const findFinishVal = Array.isArray(colorFinishTypeDetails) ? colorFinishTypeDetails === null || colorFinishTypeDetails === void 0 ? void 0 : colorFinishTypeDetails.find((cftd)=>{
            return (cftd === null || cftd === void 0 ? void 0 : cftd.split("|")[1]) === (colorDetail === null || colorDetail === void 0 ? void 0 : colorDetail.split("|")[0]);
        }) : "";
        finishVal = findFinishVal === null || findFinishVal === void 0 ? void 0 : findFinishVal.split("|")[0];
        return finishVal;
    };
    const getColorBasedFinish = (tmpFinishVal)=>{
        var ref;
        let finalList = [];
        let finalColorFamilyList = [];
        let finishVal = "";
        const { colorDetails =[] , colorFinishTypeDetails =[]  } = props;
        const isShowAll = finishType === null || finishType === void 0 ? void 0 : finishType.includes(SHOWALL);
        if (!tmpFinishVal && queryParams.has("skuId")) {
            const skuId = queryParams.get("skuId");
            finishVal = finishTypeFromSkuId(skuId, colorDetails, colorFinishTypeDetails);
            finishVal = isShowAll ? SHOWALL : finishVal;
            setFinishSelectedValue(finishVal);
        } else if (!tmpFinishVal && !queryParams.has("skuId")) {
            var ref1, ref2;
            const skuId1 = props === null || props === void 0 ? void 0 : (ref1 = props.colorDetails) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.split("|")[2];
            finishVal = finishTypeFromSkuId(skuId1, colorDetails, colorFinishTypeDetails);
            finishVal = isShowAll ? SHOWALL : finishVal;
            setFinishSelectedValue(finishVal);
        } else {
            finishVal = tmpFinishVal;
        }
        const updatedFinishVal = finishVal === null || finishVal === void 0 ? void 0 : finishVal.replaceAll("+", " ");
        if ((updatedFinishVal === null || updatedFinishVal === void 0 ? void 0 : updatedFinishVal.toLowerCase()) === SHOWALL.toLowerCase()) {
            var ref3;
            const finalColorFamily = (props === null || props === void 0 ? void 0 : props.colorFamily) && props.colorFamily.length && ((ref3 = props.colorFamily) === null || ref3 === void 0 ? void 0 : ref3.reduce((acc, item)=>{
                const [name] = item.split("|");
                if (acc[name]) {
                    acc[name] += 1;
                } else acc[name] = 1;
                return acc;
            }, {}));
            const updatedColorFamilyCount = finalColorFamily ? Object.entries(finalColorFamily).map((param)=>{
                let [k, v] = param;
                return "".concat(k, "|").concat(v);
            }) : [];
            SetColorFamilyCount(updatedColorFamilyCount);
            setColorFamily(props === null || props === void 0 ? void 0 : props.colorFamily);
            return props === null || props === void 0 ? void 0 : props.colorDetails;
        }
        (props === null || props === void 0 ? void 0 : (ref = props.colorFinishTypeDetails) === null || ref === void 0 ? void 0 : ref.length) > 0 && updatedFinishVal ? props === null || props === void 0 ? void 0 : props.colorFinishTypeDetails.map((item)=>{
            let tmpColorFinish = item.split("|");
            if (tmpColorFinish[0] === updatedFinishVal) {
                var ref, ref1;
                let tempColor = tmpColorFinish[1];
                (props === null || props === void 0 ? void 0 : (ref = props.colorDetails) === null || ref === void 0 ? void 0 : ref.length) > 0 && (props === null || props === void 0 ? void 0 : props.colorDetails.filter((list)=>{
                    const colorDetail = list.split("|");
                    const colorDetailLength = colorDetail.length;
                    const listFinish = colorDetail[colorDetailLength - 1];
                    if (list.indexOf(tempColor) > -1 && tmpColorFinish[0] === listFinish && !finalList.includes(list)) {
                        finalList.push(list);
                        return true;
                    }
                }));
                (props === null || props === void 0 ? void 0 : (ref1 = props.colorFamily) === null || ref1 === void 0 ? void 0 : ref1.length) && (props === null || props === void 0 ? void 0 : props.colorFamily.some((list)=>{
                    if (list.indexOf(tempColor) > -1 && !finalColorFamilyList.includes(list)) {
                        finalColorFamilyList.push(list);
                        return true;
                    }
                }));
            }
            return "";
        }) : "";
        const finalColorFamily1 = finalColorFamilyList.reduce((acc, item)=>{
            const [name] = item.split("|");
            if (acc[name]) {
                acc[name] += 1;
            } else acc[name] = 1;
            return acc;
        }, {});
        const updatedColorFamilyCount1 = Object.entries(finalColorFamily1).map((param)=>{
            let [k, v] = param;
            return "".concat(k, "|").concat(v);
        });
        SetColorFamilyCount(updatedColorFamilyCount1);
        setColorFamily(finalColorFamilyList);
        return finalList;
    };
    (0,react.useEffect)(()=>{
        setTimeout(()=>{
            setTooltipData(props.selectMoreTooltipData);
        }, 3000);
    }, [
        props === null || props === void 0 ? void 0 : props.selectMoreTooltipData
    ]);
    (0,react.useEffect)(()=>{
        setDiscontinuedColors(colorDiscontinuedVarients);
    }, [
        colorDiscontinuedVarients
    ]);
    (0,react.useEffect)(()=>{
        if (colors.length === 0) {
            let colorBaseFinish = getColorBasedFinish("");
            setColorDefaultDetails(colorBaseFinish);
            let tmpColorInfo = colorBaseFinish.length > 0 ? modifyColorData(colorBaseFinish, 1, "") : "";
            let colorDataDetails = [
                ...tmpColorInfo
            ];
            if (colorDataDetails && (colorDataDetails === null || colorDataDetails === void 0 ? void 0 : colorDataDetails.length) > 0) {
                let chkIsActiveColor = colorDataDetails.some((item)=>{
                    return item["isActive"] === true;
                });
                if (chkIsActiveColor === false) {
                    colorDataDetails[0]["isActive"] = true;
                    setColorHeading("".concat(colorDataDetails[0]["name"], " ").concat(colorDataDetails[0]["finishName"] !== NO_FINISH_TYPE ? " - ".concat(colorDataDetails[0]["finishName"]) : ""));
                }
            }
            setColorsPopUp(colorDataDetails);
            setColors(colorDataDetails);
            const skuId = queryParams.has("skuId") ? queryParams.get("skuId") : "";
            const colorsItem = (colorDataDetails === null || colorDataDetails === void 0 ? void 0 : colorDataDetails.find((colorDetail)=>colorDetail["skuId"] === skuId)) || {};
            skuId && getNewVarients(colorsItem["skuId"] ? colorsItem["skuId"] : "", colorsItem);
        } else if (colors && (colors === null || colors === void 0 ? void 0 : colors.length) > 0) {
            let chkIsActiveColor1 = colors.some((item)=>{
                return item["isActive"] === true;
            });
            if (chkIsActiveColor1 === false) {
                colors[0]["isActive"] = true;
                setColors(colors);
            }
            const skuId1 = queryParams.has("skuId") ? queryParams.get("skuId") : "";
            const colorsItem1 = (colors === null || colors === void 0 ? void 0 : colors.find((colorDetail)=>colorDetail["skuId"] === skuId1)) || {};
            skuId1 && getNewVarients(colorsItem1["skuId"] ? colorsItem1["skuId"] : "", colorsItem1);
        }
        let colorFinishdata = [];
        if ((props === null || props === void 0 ? void 0 : props.finishPopUpData) !== undefined && finish.length === 0) {
            let i;
            for(i = 0; i < (props === null || props === void 0 ? void 0 : props.finishPopUpData.length); i = i + 1){
                if ((props === null || props === void 0 ? void 0 : props.finishPopUpData[i].indexOf("|")) > -1) {
                    let getFinishArray = props === null || props === void 0 ? void 0 : props.finishPopUpData[i].split("|");
                    let tmpData = {
                        name: getFinishArray[0],
                        count: getFinishArray[1]
                    };
                    colorFinishdata.push(tmpData);
                }
            }
            setFinish(colorFinishdata);
        }
        let imagedata = [];
        if (updatedImageDetails !== undefined) {
            for(let i1 = 0; i1 < (updatedImageDetails === null || updatedImageDetails === void 0 ? void 0 : updatedImageDetails.length); i1++){
                if (updatedImageDetails[i1].indexOf("|") > -1) {
                    let getDetailsArray = updatedImageDetails[i1].split("|");
                    let isActiveNew = ProductDescriptionDetail === getDetailsArray[0] ? true : !(props === null || props === void 0 ? void 0 : props.ProductDescriptionDetail_s) && i1 === 0 ? true : false;
                    !(props === null || props === void 0 ? void 0 : props.ProductDescriptionDetail_s) && i1 === 0 ? setShapeHeading(getDetailsArray[0]) : "";
                    isActiveNew === true ? setShapeHeading(getDetailsArray[0]) : "";
                    let tmpData1 = {
                        name: getDetailsArray[0],
                        src: getDetailsArray[1],
                        count: imageDetails[i1 + 1],
                        isActive: isActiveNew
                    };
                    imagedata.push(tmpData1);
                }
            }
            setImage(imagedata);
        }
        let availableColorsData = [];
        let getColorsName = false;
        let availableColors = props === null || props === void 0 ? void 0 : props.availableColors;
        if (availableColors !== undefined && (availableColors === null || availableColors === void 0 ? void 0 : availableColors.length) > 0 && getColorsName === false && isColorDiscontinued && !isDiscontinued) {
            for(let i2 = 0; i2 < availableColors.length && getColorsName === false; i2 = i2 + 1){
                if (availableColors[i2]["discontinuedColor"] !== undefined && !availableColors[i2]["discontinuedColor"]) {
                    let tmpSkuId = availableColors[i2]["id"];
                    let colorInfoTmp = props === null || props === void 0 ? void 0 : props.colorDetails;
                    if (colorInfoTmp !== undefined && (colorInfoTmp === null || colorInfoTmp === void 0 ? void 0 : colorInfoTmp.length) > 0) {
                        for(let k = 0; k < colorInfoTmp.length && getColorsName === false; k = k + 1){
                            if (colorInfoTmp[k].indexOf("|") > -1) {
                                let getColorArray = colorInfoTmp[k].split("|");
                                if (getColorArray[2] === tmpSkuId && getColorArray[0] === availableColors[i2]["label"]) {
                                    let tmpData2 = {
                                        skuId: getColorArray[2],
                                        colorName: getColorArray[0]
                                    };
                                    availableColorsData.push(tmpData2);
                                    getColorsName = true;
                                }
                            }
                        }
                    }
                }
            }
            setAvailableColors(availableColorsData);
        }
    }, [
        imageDetails,
        updatedImageDetails,
        props === null || props === void 0 ? void 0 : props.colorDetails,
        props === null || props === void 0 ? void 0 : props.finishPopUpData,
        props === null || props === void 0 ? void 0 : props.availableColors,
        ProductDescriptionDetail,
        currentSku
    ]);
    const selectStyleTooltipHandler = (shareTooltip, colorTooltip, finishTooltip, vanityTooltip, msg)=>{
        setSelectStyleTooltip({
            shareTooltip,
            colorTooltip,
            finishTooltip,
            vanityTooltip
        });
        analytics_addDataLayer({
            title: "info icon mouseover",
            productInfo: props === null || props === void 0 ? void 0 : props.analyticsProductInfo,
            toolTipProps: {
                isToolTip: true,
                toolTipValue: msg === null || msg === void 0 ? void 0 : msg.toLowerCase()
            }
        });
    };
    const modifyColorData = (dataList, indexIncreaseBy, newSku)=>{
        let colorsData = [];
        if (dataList !== undefined && dataList.length > 0) {
            let i;
            for(i = 0; i < dataList.length; i = i + indexIncreaseBy){
                if (dataList[i].indexOf("|") > -1) {
                    let getColorArray = dataList[i].split("|");
                    let colorExpiredDate;
                    const expirationDateStr = getColorArray[4];
                    const currentDate = new Date();
                    if (expirationDateStr && !isNaN(Date.parse(expirationDateStr))) {
                        const expiredDate = new Date(expirationDateStr);
                        colorExpiredDate = expiredDate <= currentDate ? true : false;
                    }
                    if (expirationDateStr === "false" || !colorExpiredDate) {
                        let skuActive = newSku ? getColorArray[2] && newSku === getColorArray[2] ? true : false : false;
                        let chkIsActive = skuActive ? true : false;
                        chkIsActive ? setColorHeading("".concat(getColorArray[0], " ").concat(getColorArray[6] !== NO_FINISH_TYPE ? " - ".concat(getColorArray[6]) : "")) : "";
                        let tmpColorsData = {
                            name: getColorArray[0],
                            src: getColorArray[1],
                            skuId: getColorArray[2],
                            isActive: chkIsActive,
                            finishName: getColorArray[6]
                        };
                        colorsData.push(tmpColorsData);
                    }
                }
            }
        }
        return colorsData;
    };
    const openModal = (checkType)=>{
        checkType === "shape" ? setModalShape(true) : setModalShape(false);
        checkType === "color" ? setModalColor(true) : setModalColor(false);
        setShowModal(true);
        document.body.classList.add("modal-open");
        document.body.classList.add("gbh-of-scroll");
    };
    const closeModal = ()=>{
        setShowModal(false);
        document.body.classList.remove("modal-open");
        document.body.classList.remove("gbh-of-scroll");
    };
    const openFilter = ()=>{
        if (showFilter) {
            setModalFilter(false);
        } else {
            setModalFilter(true);
        }
    };
    const updateLabelHeading = (id, currentVal)=>{
        const item = document.getElementById(id);
        if (item && (currentVal === null || currentVal === void 0 ? void 0 : currentVal.length) >= 0) {
            item.innerHTML = currentVal;
        }
    };
    const updateShapeImagePreview = (currentVal)=>{
        const item = document.getElementById("product-select-style__modal-image-preview");
        if (item && (currentVal === null || currentVal === void 0 ? void 0 : currentVal.length) >= 0) {
            item.src = currentVal;
        }
    };
    const applySelectedShape = (index)=>{
        handleShapeSizeSelectChange(image[index]["name"], image[index]["src"], true);
        closeModal();
    };
    const applyBtn = ()=>{
        handleShapeSizeSelectChange(image[tempIndex]["name"], image[tempIndex]["src"], true);
        closeModal();
    };
    const showActivePreview = (currNodeRef, className, isShape, itemIndex)=>{
        let allNodeRef = document.querySelectorAll("." + className);
        setTempIndex(itemIndex);
        try {
            let i;
            for(i = 0; i < allNodeRef.length; i++){
                if (allNodeRef[i] && allNodeRef[i].classList && allNodeRef[i].classList.contains(className + "-active")) {
                    allNodeRef[i].classList.remove(className + "-active");
                }
            }
            document.getElementById(currNodeRef).classList.add(className + "-active");
            if (document.getElementById(currNodeRef) && Number(window.outerWidth) < 1024) {
                var ref, ref1;
                let tmpSrc = (ref1 = (ref = document.getElementById(currNodeRef)) === null || ref === void 0 ? void 0 : ref.getElementsByTagName("img")[0]) === null || ref1 === void 0 ? void 0 : ref1.getAttribute("src");
                if (isShape) {
                    tmpSrc && tmpSrc !== undefined ? document.getElementById("product-select-style__modal-image-preview") ? document.getElementById("product-select-style__modal-color-image-preview").src = tmpSrc : "" : "";
                } else {
                    tmpSrc && tmpSrc !== undefined ? document.getElementById("product-select-style__modal-color-image-preview") ? document.getElementById("product-select-style__modal-color-image-preview").src = tmpSrc : "" : "";
                }
            }
        } catch (error) {
            console.error(error);
        }
    };
    const getNewVarients = async function(filterVal) {
        let colorsItem = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, isClicked = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        var ref, ref1;
        if (filterVal) {
            let finishSelectedOption = finishSelectedValue ? finishSelectedValue : "";
            setSkuVariant(filterVal, finishSelectedOption);
            setActiveSku(filterVal);
        }
        const allList = filterVal && priceData[filterVal];
        const pList = (allList && Object.keys(allList).length && selectedCategoriesForStandaloneListprice.includes(ProductLocalCategory) ? allList === null || allList === void 0 ? void 0 : allList.ctStandaloneGstPersona : allList === null || allList === void 0 ? void 0 : allList.ctPricelistGstPersona) || (priceData === null || priceData === void 0 ? void 0 : priceData.lwAnyPrice);
        filterVal && dispatch((0,pdpSlice/* updateVariantSkuInTabDetails */.Bm)({
            sku: filterVal,
            listPrice: pList && pList.toFixed(2) || 0
        }));
        const selecetedProductinfo = JSON.parse(props === null || props === void 0 ? void 0 : props.analyticsProductInfo);
        selecetedProductinfo.defaultImageName = "".concat(props === null || props === void 0 ? void 0 : props.swatchUrl).concat(colorsItem === null || colorsItem === void 0 ? void 0 : colorsItem.src);
        selecetedProductinfo.productColor = colorsItem === null || colorsItem === void 0 ? void 0 : colorsItem.name;
        selecetedProductinfo.productID = colorsItem === null || colorsItem === void 0 ? void 0 : colorsItem.skuId;
        if (!(authorData === null || authorData === void 0 ? void 0 : authorData.disableEcommerce)) {
            var ref2;
            (ref2 = (0,utils_cart/* getStock */.K5)(colorsItem === null || colorsItem === void 0 ? void 0 : colorsItem.skuId)) === null || ref2 === void 0 ? void 0 : ref2.then((qty)=>{
                selecetedProductinfo.productStatus = qty > 0 ? "in stock" : "out of stock";
            });
        } else {
            selecetedProductinfo.productStatus = "n/a";
        }
        isClicked && analytics_addDataLayer({
            title: "color selection",
            colorVal: (ref = "".concat(colorsItem === null || colorsItem === void 0 ? void 0 : colorsItem.name, " - ").concat(colorsItem === null || colorsItem === void 0 ? void 0 : colorsItem.finishName)) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
            productInfo: (ref1 = JSON.stringify(selecetedProductinfo)) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()
        });
    };
    const modalColorApplyBtn = (className, indexName, colorFinishName, imageSrc)=>{
        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
        let tagSelected = document.querySelector("." + className);
        let skuId = tagSelected === null || tagSelected === void 0 ? void 0 : tagSelected.getAttribute(indexName);
        const colorFinishValue = (ref = tagSelected === null || tagSelected === void 0 ? void 0 : tagSelected.getAttribute(colorFinishName)) === null || ref === void 0 ? void 0 : ref.toLowerCase();
        const colorValue = (ref1 = colorFinishValue === null || colorFinishValue === void 0 ? void 0 : colorFinishValue.split("-")) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.trim();
        const imageItemSrc = (ref3 = tagSelected === null || tagSelected === void 0 ? void 0 : tagSelected.getAttribute(imageSrc)) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase();
        const selecetedProductinfo = JSON.parse(props === null || props === void 0 ? void 0 : props.analyticsProductInfo);
        selecetedProductinfo.defaultImageName = "".concat(props === null || props === void 0 ? void 0 : props.swatchUrl).concat(imageItemSrc);
        selecetedProductinfo.productColor = colorValue;
        selecetedProductinfo.productID = skuId;
        analytics_addDataLayer({
            sysOverlayObj: {
                overlayTitle: "select your style overlay",
                overlayType: (ref4 = "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.productSelectStyleModalColorTitle, ":")) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase(),
                sysVal: colorFinishValue
            },
            title: i18n === null || i18n === void 0 ? void 0 : (ref5 = i18n.productSelectStyleShapeApplyBtn) === null || ref5 === void 0 ? void 0 : ref5.toLowerCase(),
            productInfo: (ref6 = JSON.stringify(selecetedProductinfo)) === null || ref6 === void 0 ? void 0 : ref6.toLowerCase()
        });
        if (skuId !== "" && skuId !== undefined) {
            let finishSelectedOption = finishSelectedValue ? finishSelectedValue : "";
            setSkuVariant(skuId, finishSelectedOption);
            closeModal();
        } else {
            return "";
        }
    };
    (0,react.useEffect)(()=>{
        let skuIdParam = "";
        let finishParam = "";
        window.location.search.slice(1).split("&").forEach((getElement)=>{
            if (getElement === "") return;
            let newParam = getElement.split("=");
            if (newParam.length >= 2) {
                if (newParam[0] === "skuId") {
                    skuIdParam = decodeURIComponent(newParam[1]);
                }
                if (newParam[0] === "finish") {
                    finishParam = decodeURIComponent(newParam[1]);
                }
            }
        });
        let urlSku = skuIdParam ? skuIdParam : "";
        let finish = finishParam ? finishParam : "";
        if (urlSku) {
            const updatedFinish = finish === null || finish === void 0 ? void 0 : finish.replaceAll("+", " ");
            finish && setFinishSelectedValue(updatedFinish);
            let colorBaseFinish = getColorBasedFinish(finish);
            let tmpColorData = (colorBaseFinish === null || colorBaseFinish === void 0 ? void 0 : colorBaseFinish.length) > 0 ? modifyColorData(colorBaseFinish, 1, urlSku) : "";
            setColors(tmpColorData);
            setColorsPopUp(tmpColorData);
        }
    }, [
        currentSku,
        props === null || props === void 0 ? void 0 : props.finishType
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "product-select-style__main-container ".concat(!isDiscontinued && !isColorDiscontinued && (image.length || (finishType === null || finishType === void 0 ? void 0 : finishType.length) || colors.length) ? "product-select-style__devider--block" : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: props.comboSkuDetails && props.comboSkuDetails.length > 0 ? "product-select-style curated-style" : "product-select-style",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectYourStyle_view, {
                handleShapeSizeSelectChange: handleShapeSizeSelectChange,
                descriptionDetail: descriptionDetail,
                ProductDescriptionDetail: ProductDescriptionDetail,
                descriptionDetails: descriptionDetails_,
                selectStyleTooltipHandler: selectStyleTooltipHandler,
                finishFilterChange: finishFilterChange,
                styleTooltip: styleTooltip,
                setSelectStyleTooltip: setSelectStyleTooltip,
                finishType: finishType,
                finishSelectedValue: finishSelectedValue,
                tooltip: tooltip_new,
                i18n: i18n,
                tooltipdata: tooltipdata,
                colorHeading: colorHeading,
                notallowFinishValue: notallowFinishValue,
                authorData: authorData,
                colors: colors,
                getNewVarients: getNewVarients,
                swatchUrl: props === null || props === void 0 ? void 0 : props.swatchUrl,
                updateLabelHeading: updateLabelHeading,
                openModal: openModal,
                colorFamily: colorFamily,
                colorFamilyCount: colorFamilyCount,
                productTitle: productTitle,
                isDiscontinued: isDiscontinued,
                isColorDiscontinued: isColorDiscontinued,
                isShape: isShape,
                image: image,
                imageDetails: imageDetails,
                shapeSizeDesignImageDescription: shapeSizeDesignImageDescription,
                showModal: showModal,
                isColor: isColor,
                colorsPopUp: colorsPopUp,
                ProductLocalCategory: ProductLocalCategory,
                showActivePreview: showActivePreview,
                updateShapeImagePreview: updateShapeImagePreview,
                closeModal: closeModal,
                modalColorApplyBtn: modalColorApplyBtn,
                openFilter: openFilter,
                applyBtn: applyBtn,
                showFilter: showFilter,
                allowMaxColor: allowMaxColor,
                colorsDiscontinuedVarients: colorsDiscontinuedVarients,
                currentSku: currentSku,
                finalAvailableColors: finalAvailableColors,
                shapeHeading: shapeHeading,
                descripritionWithImageDetail: descripritionWithImageDetail,
                comboSkuDetails: props.comboSkuDetails,
                productCategoryType: props.productCategoryType,
                NO_FINISH_TYPE: NO_FINISH_TYPE,
                activeSku: activeSku,
                isCollapsedPDP: isCollapsedPDP,
                discontinuedCTALink: discontinuedCTALink,
                presetConfig: props.presetConfig,
                accountName: props === null || props === void 0 ? void 0 : props.accountName,
                productImages: productImages,
                applySelectedShape: applySelectedShape,
                styleOptionsNotPresent: styleOptionsNotPresent
            })
        })
    });
};
/* harmony default export */ var v1_SelectYourStyle = (SelectYourStyle);

// EXTERNAL MODULE: ./src/components/core/Toaster/Toaster.jsx
var Toaster = __webpack_require__(10512);
;// CONCATENATED MODULE: ./public/icons/info.svg
/* harmony default export */ var info = ({"src":"/_next/static/media/info.7d3d3a1b.svg","height":17,"width":16});
;// CONCATENATED MODULE: ./components/ProductDetail/v1/TrimCalculator/TrimCalculator.jsx







const TrimCalculator = (props)=>{
    var ref, ref1;
    let tempVal = (props === null || props === void 0 ? void 0 : props.RegionUOM) !== "FT2" ? true : false;
    let soldVal = !tempVal ? props.soldByBox : props.soldByUom;
    const [linerLF, setLinerLF] = (0,react.useState)(props.totalNeeded ? props.totalNeeded : "");
    const [overage, setOverage] = (0,react.useState)(props.overage ? props.overage : 15);
    const [customOverage, setCustomOverage] = (0,react.useState)("");
    const [totalOverage, setTotalOverage] = (0,react.useState)(0);
    const [totalLF, setTotalLF] = (0,react.useState)(0);
    const [pises, setPises] = (0,react.useState)(0);
    const [price, setPrice] = (0,react.useState)(0);
    const [displayPrice, setDisplayPrice] = (0,react.useState)(0);
    const [totalSFValue, setTotalSFValue] = (0,react.useState)(0);
    const [addToCartButtonDisable, setAddToCartButtonDisable] = (0,react.useState)(true);
    const overageList = typeof (props === null || props === void 0 ? void 0 : (ref = props.customLabel) === null || ref === void 0 ? void 0 : ref.overage) === "object" && props.customLabel.overage.length > 0 ? props.customLabel.overage : [
        0,
        5,
        10,
        15,
        20,
        "Custom"
    ];
    const [trimTooltip, setTrimTooltip] = (0,react.useState)({
        sqFeetTooltip: false,
        overageTooltip: false,
        totalCoverageTooltip: false
    });
    const trimCalculationMainBlockElementRef = (0,react.useRef)(null);
    const [totalsoldValue, setTotalSoldValue] = (0,react.useState)(0);
    const [stockValue, setStockValue] = (0,react.useState)(0);
    const pricePerUnit = (ref1 = Number(props.price).toFixed(2)) === null || ref1 === void 0 ? void 0 : ref1.toLocaleString();
    (0,react.useEffect)(()=>{
        var ref, ref1;
        let tmpTiletotalSoldValue = props.soldByBox / props.soldByUom;
        let tmpTrimtotalSoldValue = 1 / props.soldByUom;
        setTotalSoldValue(!tempVal ? tmpTiletotalSoldValue : tmpTrimtotalSoldValue);
        setTotalSFValue((ref1 = (ref = Number((props === null || props === void 0 ? void 0 : props.priceByBox) !== undefined && (props === null || props === void 0 ? void 0 : props.priceByBox) > 0 ? (props === null || props === void 0 ? void 0 : props.priceByBox) / tmpTiletotalSoldValue : 0)) === null || ref === void 0 ? void 0 : ref.toFixed(2)) === null || ref1 === void 0 ? void 0 : ref1.toLocaleString());
    }, [
        props.soldByBox,
        props.soldByUom
    ]);
    (0,react.useEffect)(()=>{
        if (!props.disableEcommerce) {
            (0,utils_cart/* getStock */.K5)(props.sku).then((stock)=>{
                var ref, ref1;
                if (stock) {
                    setStockValue(stock);
                }
                var ref2;
                const cartItem = (ref2 = props === null || props === void 0 ? void 0 : (ref = props.cart) === null || ref === void 0 ? void 0 : (ref1 = ref.lineItems) === null || ref1 === void 0 ? void 0 : ref1.find((item)=>{
                    var ref;
                    return (item === null || item === void 0 ? void 0 : (ref = item.variant) === null || ref === void 0 ? void 0 : ref.sku) === (props === null || props === void 0 ? void 0 : props.sku);
                })) !== null && ref2 !== void 0 ? ref2 : {};
                var ref3;
                const cartQuantity = (ref3 = cartItem === null || cartItem === void 0 ? void 0 : cartItem.quantity) !== null && ref3 !== void 0 ? ref3 : 0;
                if (cartQuantity > 0 && stock <= cartQuantity) {
                    props.setOnChangeStockAlert({
                        show: true,
                        mssg: props.t("kf.pdp.label.noItemsToShip")
                    });
                } else if (stock < pises) {
                    props.setOnChangeStockAlert({
                        show: true,
                        mssg: props.t("kf.pdp.label.availableToShip", {
                            qty: stock
                        })
                    });
                } else {
                    props.setOnChangeStockAlert({
                        show: false,
                        mssg: ""
                    });
                }
            });
        }
    }, [
        pises
    ]);
    const onChangeHandler = (value)=>{
        if (!value) {
            setTotalLF(0);
            setTotalOverage(0);
            setPises(0);
            setPrice(0);
            localStorage.setItem("itemFinalPrice", 0);
            setDisplayPrice(0);
            setLinerLF("");
            return false;
        }
        if (value < 0) {
            document.getElementById("txt_prod_price").value = 0;
            setLinerLF(0);
            return false;
        }
        document.getElementById("txt_prod_price").focus();
        const arr = value.split(".");
        if (value.length <= 5) {
            setLinerLF(value);
        } else if (arr.length <= 2 && arr[1].length <= 2) {
            setLinerLF(value);
        }
    };
    const trimTooltipHandler = (sqFeetTooltip, overageTooltip, totalCoverageTooltip, msg)=>{
        setTrimTooltip({
            sqFeetTooltip: sqFeetTooltip,
            overageTooltip: overageTooltip,
            totalCoverageTooltip: totalCoverageTooltip
        });
        analytics_addDataLayer({
            title: "calculate footage info icon mouseover",
            productInfo: props === null || props === void 0 ? void 0 : props.analyticsProductInfo,
            toolTipProps: {
                isToolTip: true,
                toolTipValue: msg.toLowerCase()
            }
        });
    };
    const onChangeCustomOverage = (custVal)=>{
        if (custVal < 0) {
            document.getElementById("trim-calculator__overage-input-box").value = 0;
            setCustomOverage(0);
            return false;
        }
        let dot = custVal.split(".");
        if (dot.length === 2 || dot[0] === "") {
            setCustomOverage("");
        }
        if (dot.length !== 2 && dot[0] !== "" && custVal.length <= 2) {
            setCustomOverage(custVal);
        }
    };
    const onChangeOverage = (value)=>{
        var ref;
        let res = 0;
        setOverage(value);
        let tmpOverageVal = typeof value === "string" && value.toLowerCase() === "custom" ? 1 : value;
        res = Number(linerLF) * Number(tmpOverageVal) / 100;
        let total = res + Number(linerLF);
        let pres = soldVal !== undefined && soldVal > 0 ? Math.ceil(total) * soldVal : 0;
        let boxPeice = soldVal !== undefined && soldVal > 0 ? props.soldByUom * Math.ceil(total) / props.soldByBox : 0;
        setPises(!tempVal ? Math.ceil(boxPeice) : Math.ceil(pres));
        let finalPrice = 0;
        if (!props.disableEcommerce) {
            finalPrice = (props === null || props === void 0 ? void 0 : props.priceByBox) !== undefined && (props === null || props === void 0 ? void 0 : props.priceByBox) > 0 ? (!tempVal ? stockValue < Math.ceil(boxPeice) ? stockValue : Math.ceil(boxPeice) : stockValue < Math.ceil(pres) ? stockValue : Math.ceil(pres)) * props.priceByBox : 0;
        } else {
            finalPrice = (props === null || props === void 0 ? void 0 : props.priceByBox) !== undefined && (props === null || props === void 0 ? void 0 : props.priceByBox) > 0 ? (!tempVal ? Math.ceil(boxPeice) : Math.ceil(pres)) * props.priceByBox : 0;
        }
        if (props.SKUInventoryStatus) {
            finalPrice = props.price * Math.ceil(total);
        }
        setPrice(finalPrice);
        localStorage.setItem("itemFinalPrice", finalPrice);
        setDisplayPrice((ref = Number(finalPrice)) === null || ref === void 0 ? void 0 : ref.toFixed(2).toLocaleString());
        let tOverage = 0;
        if (!props.disableEcommerce) {
            tOverage = soldVal !== undefined && soldVal > 0 ? stockValue < Math.ceil(pres) ? stockValue / soldVal : Math.ceil(pres) / soldVal : 0;
        } else {
            tOverage = soldVal !== undefined && soldVal > 0 ? Math.ceil(pres) / soldVal : 0;
        }
        let tileOverage = 0;
        if (!props.disableEcommerce) {
            tileOverage = soldVal !== undefined && soldVal > 0 ? props.soldByBox / props.soldByUom * (stockValue < Math.ceil(boxPeice) ? stockValue : Math.ceil(boxPeice)) : 0;
        } else {
            tileOverage = soldVal !== undefined && soldVal > 0 ? props.soldByBox / props.soldByUom * Math.ceil(boxPeice) : 0;
        }
        setTotalOverage(!tempVal ? tileOverage : tOverage);
        setTotalLF(Math.ceil(total));
        analytics_addDataLayer({
            title: (props.customLabel && props.customLabel.overagename ? props.customLabel.overagename : props.staticTexts.overage).toLowerCase(),
            productInfo: props === null || props === void 0 ? void 0 : props.analyticsProductInfo,
            calculated_Values: JSON.stringify({
                squareFeetNeeded: Number(linerLF),
                overage: typeof value === "string" && value.toLowerCase() === "custom" ? "custom" : Number(value),
                totalSquareFeet: Number(Math.ceil(total).toFixed(3)),
                totalCoverage: Number(tOverage.toFixed(3)),
                totalBoxes: Math.ceil(pres),
                totalPrice: Number(finalPrice.toFixed(3))
            })
        });
    };
    const onBlurHandler = (value)=>{
        let addToCartRef = document.querySelector(".add-to-cart__main-button");
        let stickyHeaderRef = document.querySelector(".sticky-header__main-button");
        if (addToCartRef) {
            if (Number(linerLF) && Number(pises) > 0 || Number(value) > 0) {
                addToCartRef.classList.remove("disabled");
                setAddToCartButtonDisable(false);
                stickyHeaderRef ? stickyHeaderRef.classList.remove("disabled") : "";
            } else {
                addToCartRef.classList.add("disabled");
                setAddToCartButtonDisable(true);
                stickyHeaderRef ? stickyHeaderRef.classList.add("disabled") : "";
            }
        }
        if (linerLF) {
            var ref, ref1;
            let res = 0;
            let finalOverage = overage === "custom" || overage === "Custom" ? customOverage : overage;
            res = Number(linerLF) * Number(finalOverage) / 100;
            let total = res + Number(linerLF);
            let pres = soldVal !== undefined && soldVal > 0 ? Math.ceil(total) * soldVal : 0;
            let boxPeice = soldVal !== undefined && soldVal > 0 ? props.soldByUom * Math.ceil(total) / props.soldByBox : 0;
            setPises(!tempVal ? Math.ceil(boxPeice) : Math.ceil(pres));
            let finalPrice = 0;
            if (!props.disableEcommerce) {
                finalPrice = (props === null || props === void 0 ? void 0 : props.priceByBox) !== undefined && (props === null || props === void 0 ? void 0 : props.priceByBox) > 0 ? (!tempVal ? stockValue < Math.ceil(boxPeice) ? stockValue : Math.ceil(boxPeice) : stockValue < Math.ceil(pres) ? stockValue : Math.ceil(pres)) * props.priceByBox : 0;
            } else {
                finalPrice = (props === null || props === void 0 ? void 0 : props.priceByBox) !== undefined && (props === null || props === void 0 ? void 0 : props.priceByBox) > 0 ? (!tempVal ? Math.ceil(boxPeice) : Math.ceil(pres)) * props.priceByBox : 0;
            }
            if (props.SKUInventoryStatus) {
                finalPrice = props.price * Math.ceil(total);
            }
            setPrice(finalPrice);
            localStorage.setItem("itemFinalPrice", finalPrice);
            setDisplayPrice((ref1 = (ref = Number(finalPrice)) === null || ref === void 0 ? void 0 : ref.toFixed(2)) === null || ref1 === void 0 ? void 0 : ref1.toLocaleString());
            let tOverage = 0;
            if (!props.disableEcommerce) {
                tOverage = soldVal !== undefined && soldVal > 0 ? stockValue < Math.ceil(pres) ? stockValue / soldVal : Math.ceil(pres) / soldVal : 0;
            } else {
                tOverage = soldVal !== undefined && soldVal > 0 ? Math.ceil(pres) / soldVal : 0;
            }
            let tileOverage = 0;
            if (!props.disableEcommerce) {
                tileOverage = soldVal !== undefined && soldVal > 0 ? props.soldByBox / props.soldByUom * (stockValue < Math.ceil(boxPeice) ? stockValue : Math.ceil(boxPeice)) : 0;
            } else {
                tileOverage = soldVal !== undefined && soldVal > 0 ? props.soldByBox / props.soldByUom * Math.ceil(boxPeice) : 0;
            }
            setTotalOverage(!tempVal ? tileOverage : tOverage);
            setTotalLF(Math.ceil(total));
            analytics_addDataLayer({
                title: (props.customLabel && props.customLabel.footage ? props.customLabel.footage : props.staticTexts.calculateFootage).toLowerCase(),
                productInfo: props === null || props === void 0 ? void 0 : props.analyticsProductInfo,
                calculated_Values: JSON.stringify({
                    squareFeetNeeded: Number(value),
                    overage: Number(finalOverage),
                    totalSquareFeet: Number(Math.ceil(total).toFixed(3)),
                    totalCoverage: Number(tOverage.toFixed(3)),
                    totalBoxes: Math.ceil(pres),
                    totalPrice: Number(finalPrice.toFixed(3))
                })
            });
        }
    };
    const onCustomOverageBlur = ()=>{
        onBlurHandler(linerLF);
    };
    (0,react.useEffect)(()=>{
        if (props.shwoInModal || linerLF > 0 || linerLF !== "") {
            onBlurHandler(linerLF);
        }
    }, [
        props.priceByBox
    ]);
    (0,react.useEffect)(()=>{
        trimCalculationMainBlockElementRef.current.classList.toggle("remove-while-print", addToCartButtonDisable);
    }, [
        addToCartButtonDisable
    ]);
    const onKeyDownHandler = (e)=>{
        if (e.which === 69) e.preventDefault();
        if (e.key === "Enter") {
            onBlurHandler(e.target.value);
        }
    };
    const getVerbiageforPrice = ()=>{
        switch(props === null || props === void 0 ? void 0 : props.RegionUOM){
            case "EA":
                var ref;
                return props === null || props === void 0 ? void 0 : (ref = props.staticTexts) === null || ref === void 0 ? void 0 : ref.each;
            case "FT":
                var ref1;
                return props === null || props === void 0 ? void 0 : (ref1 = props.staticTexts) === null || ref1 === void 0 ? void 0 : ref1.LinearF;
            case "FT2":
                var ref2, ref3;
                return (props === null || props === void 0 ? void 0 : props.SKUInventoryStatus) ? props === null || props === void 0 ? void 0 : (ref2 = props.staticTexts) === null || ref2 === void 0 ? void 0 : ref2.SquareF : props === null || props === void 0 ? void 0 : (ref3 = props.staticTexts) === null || ref3 === void 0 ? void 0 : ref3.perSF;
            default:
                return "";
        }
    };
    const getPerVerbiage = ()=>{
        switch(props === null || props === void 0 ? void 0 : props.RegionUOM){
            case "EA":
                var ref;
                return props === null || props === void 0 ? void 0 : (ref = props.staticTexts) === null || ref === void 0 ? void 0 : ref.perEach;
            case "FT":
                var ref1;
                return props === null || props === void 0 ? void 0 : (ref1 = props.staticTexts) === null || ref1 === void 0 ? void 0 : ref1.perLF;
            case "FT2":
                var ref2, ref3;
                return (props === null || props === void 0 ? void 0 : props.SKUInventoryStatus) ? props === null || props === void 0 ? void 0 : (ref2 = props.staticTexts) === null || ref2 === void 0 ? void 0 : ref2.perSF : props === null || props === void 0 ? void 0 : (ref3 = props.staticTexts) === null || ref3 === void 0 ? void 0 : ref3.perBox;
            default:
                return "";
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "trim-calculator_main-block",
        ref: trimCalculationMainBlockElementRef,
        className: "trimWrapper trim-calculator_main-block",
        totalOverage: totalOverage.toFixed(3),
        totalPeices: pises,
        soldByUom: props.soldByUom ? props.soldByUom : "",
        soldByBox: props.soldByBox ? props.soldByBox : "",
        templateType: props.templateType ? props.templateType : "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "header",
                children: props.customLabel && props.customLabel.footage ? props.customLabel.footage : props.staticTexts.calculateFootage
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "inputWrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "inputBox",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "inputBoxLabel",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        htmlFor: "txt_prod_price",
                                        className: "inputLabel",
                                        children: tempVal ? (props === null || props === void 0 ? void 0 : props.SKUInventoryStatus) ? props.staticTexts.squareFtNeeded : props.staticTexts.linearFtNeeded : props.staticTexts.squareFtNeeded
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: info === null || info === void 0 ? void 0 : info.src,
                                        role: "tooltip",
                                        tabIndex: 0,
                                        onMouseOver: ()=>{
                                            return trimTooltipHandler(true, false, false, props.customLabel && props.customLabel.ftneededToolTip ? props.customLabel.ftneededToolTip : tempVal ? (props === null || props === void 0 ? void 0 : props.SKUInventoryStatus) ? props.staticTexts.squareFtNeeded : props.staticTexts.linearFtNeeded : props.staticTexts.squareFtNeeded);
                                        },
                                        onMouseLeave: ()=>setTrimTooltip({
                                                sqFeetTooltip: false,
                                                overageTooltip: false,
                                                totalCoverageTooltip: false
                                            }),
                                        onFocus: ()=>{
                                            return trimTooltipHandler(true, false, false, props.customLabel && props.customLabel.ftneededToolTip ? props.customLabel.ftneededToolTip : tempVal ? (props === null || props === void 0 ? void 0 : props.SKUInventoryStatus) ? props.staticTexts.squareFtNeeded : props.staticTexts.linearFtNeeded : props.staticTexts.squareFtNeeded);
                                        },
                                        onBlur: ()=>setTrimTooltip({
                                                sqFeetTooltip: false,
                                                overageTooltip: false,
                                                totalCoverageTooltip: false
                                            }),
                                        className: "trimCalculatorTooltipIcon"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "trim-calculator__list-tooltip".concat(trimTooltip.sqFeetTooltip ? "--show" : "--hide"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "trim-calculator__list-tooltip-wrapper",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolTip/* default */.Z, {
                                                message: props.customLabel && props.customLabel.ftneededToolTip ? props.customLabel.ftneededToolTip : tempVal ? (props === null || props === void 0 ? void 0 : props.SKUInventoryStatus) ? props.staticTexts.squareFtNeeded : props.staticTexts.linearFtNeeded : props.staticTexts.squareFtNeeded
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "number",
                                className: "trim-calculator__square-ft-value",
                                id: "txt_prod_price",
                                placeholder: "0.000",
                                value: linerLF,
                                onChange: (e)=>onChangeHandler(e.target.value),
                                onBlur: (e)=>onBlurHandler(e.target.value),
                                onKeyDown: (e)=>onKeyDownHandler(e),
                                label: tempVal ? (props === null || props === void 0 ? void 0 : props.SKUInventoryStatus) ? props.staticTexts.squareFtNeeded : props.staticTexts.linearFtNeeded : props.staticTexts.squareFtNeeded,
                                for: tempVal ? props.staticTexts.linearFtNeeded : props.staticTexts.squareFtNeeded
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "labelLF",
                                children: tempVal ? (props === null || props === void 0 ? void 0 : props.SKUInventoryStatus) ? props.staticTexts.sf : props.staticTexts.lf : props.staticTexts.sf
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "inputBox",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "inputBoxLabel",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        htmlFor: "trim-calculator__overage-value",
                                        className: "inputLabel",
                                        children: props.customLabel && props.customLabel.overagename ? props.customLabel.overagename : props.staticTexts.overage
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: info === null || info === void 0 ? void 0 : info.src,
                                        role: "tooltip",
                                        tabIndex: 0,
                                        onMouseOver: ()=>trimTooltipHandler(false, true, false, props.customLabel && props.customLabel.overageNameToolTip ? props.customLabel.overageNameToolTip : props.staticTexts.overage),
                                        onMouseLeave: ()=>setTrimTooltip({
                                                sqFeetTooltip: false,
                                                overageTooltip: false,
                                                totalCoverageTooltip: false
                                            }),
                                        onFocus: ()=>trimTooltipHandler(false, true, false, props.customLabel && props.customLabel.overageNameToolTip ? props.customLabel.overageNameToolTip : props.staticTexts.overage),
                                        onBlur: ()=>setTrimTooltip({
                                                sqFeetTooltip: false,
                                                overageTooltip: false,
                                                totalCoverageTooltip: false
                                            }),
                                        className: "trimCalculatorTooltipIcon"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "trim-calculator__list-tooltip".concat(trimTooltip.overageTooltip ? "--show" : "--hide"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "trim-calculator__list-tooltip-wrapper",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolTip/* default */.Z, {
                                                message: props.customLabel && props.customLabel.overageNameToolTip ? props.customLabel.overageNameToolTip : props.staticTexts.overage
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                                id: "trim-calculator__overage-value",
                                data: overageList,
                                value: overage,
                                onChange: (selectedValue)=>onChangeOverage(selectedValue),
                                label: "overage"
                            }),
                            (overage === "custom" || overage === "Custom") && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "custom-overage",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "number",
                                        value: customOverage,
                                        placeholder: "0\xa0\xa0\xa0\xa0%",
                                        onChange: (e)=>onChangeCustomOverage(e.target.value),
                                        onBlur: onCustomOverageBlur,
                                        onKeyDown: (e)=>onKeyDownHandler(e),
                                        id: "trim-calculator__overage-input-box",
                                        className: "".concat(customOverage !== "" ? "overage-sign" : ""),
                                        min: "0",
                                        inputmode: "numeric",
                                        pattern: "[0-9]*"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "percentage-sign",
                                        children: "%"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "totalLFWrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "labelText",
                        children: tempVal ? (props === null || props === void 0 ? void 0 : props.SKUInventoryStatus) ? props.staticTexts.totalSF : props.staticTexts.totalLF : props.staticTexts.totalSF
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "valText",
                        id: "trim-calculator__totalSquareFeet",
                        value: totalLF.toFixed(2),
                        children: [
                            totalLF.toFixed(2),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text",
                                children: tempVal ? (props === null || props === void 0 ? void 0 : props.SKUInventoryStatus) ? props.staticTexts.sf : props.staticTexts.lf : props.staticTexts.sf
                            })
                        ]
                    })
                ]
            }),
            !(props === null || props === void 0 ? void 0 : props.SKUInventoryStatus) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "totalBox",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "leftBox",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: props.staticTexts.totalCoverage
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                        children: [
                                            props.staticTexts.whatYouWillReceive,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: info === null || info === void 0 ? void 0 : info.src,
                                                role: "tooltip",
                                                tabIndex: 0,
                                                onMouseOver: ()=>trimTooltipHandler(false, false, true, props.customLabel && props.customLabel.totalCoverageToolTip ? props.customLabel.totalCoverageToolTip : props.staticTexts.totalCoverage),
                                                onMouseLeave: ()=>setTrimTooltip({
                                                        sqFeetTooltip: false,
                                                        overageTooltip: false,
                                                        totalCoverageTooltip: false
                                                    }),
                                                onFocus: ()=>trimTooltipHandler(false, false, true, props.customLabel && props.customLabel.totalCoverageToolTip ? props.customLabel.totalCoverageToolTip : props.staticTexts.totalCoverage),
                                                onBlur: ()=>setTrimTooltip({
                                                        sqFeetTooltip: false,
                                                        overageTooltip: false,
                                                        totalCoverageTooltip: false
                                                    }),
                                                className: "trimCalculatorTooltipIcon"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "trim-calculator__list-tooltip".concat(trimTooltip.totalCoverageTooltip ? "--show" : "--hide"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "trim-calculator__list-tooltip-wrapper",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolTip/* default */.Z, {
                                                        message: props.customLabel && props.customLabel.totalCoverageToolTip ? props.customLabel.totalCoverageToolTip : props.staticTexts.totalCoverage
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "rightBox",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "valText",
                                    id: "trim-calculator__totalCoverage",
                                    value: totalOverage.toFixed(2),
                                    children: [
                                        totalOverage.toFixed(2),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text",
                                            children: tempVal ? (props === null || props === void 0 ? void 0 : props.SKUInventoryStatus) ? props.staticTexts.sf : props.staticTexts.lf : props.staticTexts.sf
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "totalBox",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "leftBox",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: tempVal ? props.staticTexts.totalPieces : props.staticTexts.totalBoxes
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        children: "Product sold by the ".concat(tempVal ? "Piece" : "Box", " (").concat(props === null || props === void 0 ? void 0 : props.currencySign, " ").concat(totalsoldValue.toFixed(2), " ").concat(tempVal ? "LF / Piece" : "SF / Box", ")")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "rightBox",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "valText",
                                    id: "trim-calculator__totalBoxes",
                                    value: !props.disableEcommerce ? stockValue < pises ? stockValue : pises : pises,
                                    children: [
                                        !props.disableEcommerce ? stockValue < pises ? stockValue : pises : pises,
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text",
                                            children: tempVal ? props.staticTexts.pieces : props.staticTexts.boxes
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "totalBox",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "leftBox",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Total Price"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                children: (props === null || props === void 0 ? void 0 : props.RegionUOM) !== "" ? "Price per ".concat(getVerbiageforPrice(), " (").concat(props === null || props === void 0 ? void 0 : props.currencySign, " ").concat(pricePerUnit, " ").concat(getPerVerbiage(), ") ") : null
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "rightBox",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "finalTotal",
                            id: "trim-calculator__finalTotal",
                            price: price.toFixed(2),
                            children: "$".concat(displayPrice)
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var TrimCalculator_TrimCalculator = (TrimCalculator);

;// CONCATENATED MODULE: ./components/ProductDetail/v1/ProductDetailView/PdpGroutChart.jsx



const PdpGroutChart = (props)=>{
    const data = props.authorData ? props.authorData : props.componentProp ? JSON.parse(props.componentProp.staticText) : {};
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "pdp-grout-chart-main",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "pdp-grout-chart",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pdp-grout-chart__container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pdp-grout-chart__close-icon",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: close_dark_new/* default.src */.Z.src,
                            alt: "close",
                            onClick: ()=>props.closePopup()
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-6 col-lg-6 col-md-6 col-sm-12 pdp-grout-chart__left-column",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "pdp-grout-chart__need",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "pdp-grout-chart__need-title",
                                    children: (data === null || data === void 0 ? void 0 : data.primarytitle) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        dangerouslySetInnerHTML: {
                                            __html: DOMPurify.sanitize(data === null || data === void 0 ? void 0 : data.primarytitle)
                                        }
                                    }) : ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "pdp-grout-chart__need-details",
                                    children: (data === null || data === void 0 ? void 0 : data.primarydescription) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        dangerouslySetInnerHTML: {
                                            __html: DOMPurify.sanitize(data === null || data === void 0 ? void 0 : data.primarydescription)
                                        }
                                    }) : ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "pdp-grout-chart__instruction-title",
                                    children: (data === null || data === void 0 ? void 0 : data.secondarytitle) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        dangerouslySetInnerHTML: {
                                            __html: DOMPurify.sanitize(data === null || data === void 0 ? void 0 : data.secondarytitle)
                                        }
                                    }) : ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "pdp-grout-chart__instruction-details",
                                    children: (data === null || data === void 0 ? void 0 : data.secondarydescription) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        dangerouslySetInnerHTML: {
                                            __html: DOMPurify.sanitize(data === null || data === void 0 ? void 0 : data.secondarydescription)
                                        }
                                    }) : ""
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-6 col-lg-6 col-md-6 col-sm-12 pdp-grout-chart__right-column",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "pdp-grout-chart__table",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "pdp-grout-chart__coverage-title",
                                    children: (data === null || data === void 0 ? void 0 : data.primarytitletable) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        dangerouslySetInnerHTML: {
                                            __html: DOMPurify.sanitize(data === null || data === void 0 ? void 0 : data.primarytitletable)
                                        }
                                    }) : ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "pdp-grout-chart__coverage-desc",
                                    children: (data === null || data === void 0 ? void 0 : data.primarydescriptiontable) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        dangerouslySetInnerHTML: {
                                            __html: DOMPurify.sanitize(data === null || data === void 0 ? void 0 : data.primarydescriptiontable)
                                        }
                                    }) : ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "pdp-grout-chart_table-data",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                        className: "table table-bordered",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            className: "pdp-grout-chart__table-tile",
                                                            children: data.tablecontent1 ? data.tablecontent1 : ""
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            className: "pdp-grout-chart__table-width",
                                                            colSpan: "6",
                                                            children: data.tablecontent2 ? data.tablecontent2 : ""
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                                children: data.globalItems && data.globalItems.length > 0 && data.globalItems.map((e)=>Object.values(e)).slice(0).map((e, key)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                                        children: e.map((b, key)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                children: b
                                                            }, key))
                                                    }, key))
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "pdp-grout-chart__coverage-warning",
                                    children: (data === null || data === void 0 ? void 0 : data.copyrighttext) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        dangerouslySetInnerHTML: {
                                            __html: DOMPurify.sanitize(data === null || data === void 0 ? void 0 : data.copyrighttext)
                                        }
                                    }) : ""
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var ProductDetailView_PdpGroutChart = (PdpGroutChart);

// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var dist_es = __webpack_require__(67421);
// EXTERNAL MODULE: ./public/icons/filter.svg
var filter = __webpack_require__(24495);
// EXTERNAL MODULE: ./public/icons/arrow-down.svg
var arrow_down = __webpack_require__(32873);
// EXTERNAL MODULE: ./public/icons/warning.svg
var warning = __webpack_require__(10502);
// EXTERNAL MODULE: ./src/components/core/Checkbox/Checkbox.jsx
var Checkbox = __webpack_require__(55511);
;// CONCATENATED MODULE: ./components/ProductDetail/v1/OrderSample.jsx












const OrderSample = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    const { showToaster , config  } = props;
    const [showMobileFilter, setMobileFilter] = (0,react.useState)(false);
    const [activeCol, setActiveCol] = (0,react.useState)([]);
    const [colorList, setColorList] = (0,react.useState)([]);
    const [total, setTotal] = (0,react.useState)(0);
    const [orderData, setOrderData] = (0,react.useState)([]);
    const [showFilter, setShowFilter] = (0,react.useState)(true);
    const [sort, setSort] = (0,react.useState)("Sort By");
    const [showSortDrop, setShowSortDrop] = (0,react.useState)(false);
    const [quantity, setQuantity] = (0,react.useState)(0);
    const sortByVal = [
        "A - Z",
        "Z - A",
        "Price: High - Low",
        "Price: Low - High"
    ];
    const [viewColorList, setViewColorList] = (0,react.useState)(false);
    const [hideColorList, setHideColorList] = (0,react.useState)(false);
    const [colorListDefault, setColorListDefault] = (0,react.useState)([]);
    const [chkColorItems, setChkColorItems] = (0,react.useState)(false);
    const [sampleInfo, setSampleInfo] = (0,react.useState)([]);
    const [scroll, setScroll] = (0,react.useState)(false);
    const [availableQuantity, setAvailableQuantity] = (0,react.useState)([]);
    const divRef = react.useRef();
    var ref14;
    const brandName = (ref14 = (ref = config.general) === null || ref === void 0 ? void 0 : ref.brandName) !== null && ref14 !== void 0 ? ref14 : "";
    var ref15;
    const lwAppName = (ref15 = (ref1 = config.general) === null || ref1 === void 0 ? void 0 : ref1.lwAppName) !== null && ref15 !== void 0 ? ref15 : "";
    let os = Object.values(props.orderSample);
    const enableaddtocart = props === null || props === void 0 ? void 0 : props.enableaddtocart;
    const [enableAddToCart, setEnableAddToCart] = (0,react.useState)(enableaddtocart);
    let osData = props.orderSample["SKUBadgeInfo_ss"] === "";
    let SKU_S;
    let SKU_SS;
    if (osData) {
        SKU_SS = os[1].map((item)=>'"'.concat(item, '"')).join(" OR ");
    } else {
        SKU_S = props.orderSample["SKUBadgeInfo_ss"];
    }
    let SKU_SID = osData ? SKU_SS : SKU_S;
    let fl = [
        "productName_s",
        "id",
        "variantList.sku_ss",
        "productImages.url_ss",
        "slug_s",
        "ProductNewProduct_s",
        "ProductExclusive_s",
        "priceList.".concat(props.persona, ".finalPrice_d"),
        "priceList.".concat(props.persona, ".price_d"),
        "Color_Finish_Family",
        "ProductDescriptionProductShort_s",
        "Product_Category",
        "Color.SKU.Details_ss",
        "category1_s",
        "ProductPriceSpiderIncluded_s",
        "productRegionAllVariantDiscontinued_b",
        "ProductProductRecommendedAccessories_ss",
        "priceList.".concat(props.persona, ".saleOffer_s"),
        "priceList.".concat(props.persona, ".discountedPrice_d"),
        "ProductExclusive_s",
        "RegionReleaseforShipment_dt",
        "RegionLaunchDate_dt",
        "ProductBusinessUnit_ss",
        "sku_s",
        "productInStock_b",
        "colorFinishFamilyList_ss",
        "productDiscontinued_b",
        "RegionSoldOnline_s",
        "ProductPriceSpiderIncluded_s",
        "ProductProductRecommendedAccessories_ss"
    ];
    const onPageLoad = ()=>{
        api/* apim.get */.TH.get("search/plp", {
            params: {
                q: "*:*",
                profilename: "profile_".concat(lwAppName.toLowerCase(), "_PLP"),
                collections: lwAppName.toLowerCase(),
                fq: 'variantList.sku_ss:("'.concat(SKU_SID, '")'),
                fl: fl.join(","),
                rows: 20
            },
            paramsSerializer: (params)=>{
                return lib_default().stringify(params, {
                    arrayFormat: "repeat",
                    encode: false
                });
            }
        }).then((res)=>{
            var ref, ref1;
            setOrderData(res.data.response.docs);
            setSampleAnalyticsInfo(res.data.response.docs);
            getColor((ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.facet_counts) === null || ref1 === void 0 ? void 0 : ref1.facet_fields["colorFinishFamilyList_ss"]);
        });
    };
    const inventoryStock = async ()=>{
        const skuValues = orderData.map((skus)=>skus.sku_s);
        try {
            const res = await api/* apim.get */.TH.get("catalog/inventory?sku=".concat(skuValues.join(",")));
            var _results;
            const response = (_results = res.data.results) !== null && _results !== void 0 ? _results : [];
            setAvailableQuantity(response);
        } catch (err) {
            log.error("Fetching data failed", err);
        }
    };
    (0,react.useEffect)(()=>{
        onPageLoad();
    }, []);
    (0,react.useEffect)(()=>{
        inventoryStock();
    }, [
        orderData
    ]);
    const imageBoxToggler = (index, isActive)=>{
        analytics_addDataLayer({
            title: (isActive ? "sample unselect" : "sample select").toLowerCase(),
            isSampleOverlay: true,
            productInfo: JSON.stringify(sampleInfo[index])
        });
        let updatedArr = [];
        let cardTotal = 0;
        updatedArr = orderData.map((a)=>{
            if (orderData.indexOf(a) === index && (a.index === null || a.index === undefined)) {
                a.index = index;
            }
            if (orderData.indexOf(a) === index && a.isActive === undefined) {
                return {
                    ...a,
                    isActive: true
                };
            } else if (orderData.indexOf(a) === index && a.isActive === false) {
                return {
                    ...a,
                    isActive: true
                };
            } else if (orderData.indexOf(a) !== index && a.isActive === true) {
                return {
                    ...a,
                    isActive: true
                };
            } else {
                return {
                    ...a,
                    isActive: false
                };
            }
        });
        cardTotal = updatedArr.reduce((acc, curr)=>{
            if (curr.isActive) {
                return acc + curr["priceList.".concat(props.persona, ".price_d")];
            }
            return acc;
        }, 0);
        setTotal(cardTotal);
        setQuantity(updatedArr.filter((item)=>{
            return item.isActive;
        }).length);
        return setOrderData(updatedArr);
    };
    const setSampleAnalyticsInfo = (obj)=>{
        let infoObj = [];
        obj.map((a)=>{
            var ref, ref1;
            const productInfo = {
                description: a.ProductDescriptionProductShort_s || "n/a",
                frequency: "n/a",
                globalPromotionPrice: a["priceList.".concat(props.persona, ".finalPrice_d")] || "n/a",
                isRecommended: "n/a",
                isSendNow: "n/a",
                isSubscription: "n/a",
                priceState: "regular price",
                productBasePrice: a["priceList.".concat(props.persona, ".finalPrice_d")] || "n/a",
                productCategory: a.Product_Category || "n/a",
                productColor: a.colorFinishFamilyList_ss[0] || "n/a",
                productCoupondiscount: a["priceList.".concat(props.persona, ".discountedPrice_d")] || 0,
                productCouponCode: "n/a",
                productID: "".concat(a["variantList.sku_ss"][0]) || "n/a",
                productName: a.productName_s || "n/a",
                productPartnerBuyNow: (a === null || a === void 0 ? void 0 : a.ProductPriceSpiderIncluded_s) || (a === null || a === void 0 ? void 0 : a.productDiscontinued_b) || (a === null || a === void 0 ? void 0 : a.RegionSoldOnline_s) === "false" ? (a === null || a === void 0 ? void 0 : a.ProductPriceSpiderIncluded_s) ? true : false : false,
                productRoom: a.category1_s || "n/a",
                productSalePrice: a["priceList.".concat(props.persona, ".discountedPrice_d")] ? a["priceList.".concat(props.persona, ".discountedPrice_d")] : a["priceList.".concat(props.persona, ".finalPrice_d")],
                productSaleable: (a === null || a === void 0 ? void 0 : a.productDiscontinued_b) || (a === null || a === void 0 ? void 0 : a.RegionSoldOnline_s) === "false" ? false : true,
                productStatus: "later",
                productSuperSku: false,
                productTileName: a.productName_s,
                quantity: 1,
                defaultImageName: a["productImages.url_ss"] === undefined ? image_missing/* default */.Z : a["productImages.url_ss"],
                ratings: "n/a",
                numberOfReviews: "n/a",
                pdpType: (0,helper/* pdpTypeFormat */.V4r)({
                    businessUnitName: a.category1_s,
                    ProductPriceSpiderIncluded_s: a === null || a === void 0 ? void 0 : a.ProductPriceSpiderIncluded_s,
                    discontinuedProductb: a.productDiscontinued_b,
                    ProductRequiredAccessoriesGroupsList: (a === null || a === void 0 ? void 0 : a.ProductProductRecommendedAccessories_ss) ? a === null || a === void 0 ? void 0 : a.ProductProductRecommendedAccessories_ss : [],
                    superSku: false
                }),
                productFindingMethod: "n/a",
                productCollectionsName: a.Product_Category || "n/a",
                productBrand: (ref = config.general) === null || ref === void 0 ? void 0 : (ref1 = ref.siteName) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase(),
                globalOffer: a["priceList.".concat(props.persona, ".saleOffer_s")] || "n/a",
                globalDiscount: a["priceList.".concat(props.persona, ".discountedPrice_d")] ? a["priceList.".concat(props.persona, ".discountedPrice_d")] : 0,
                itemType: (0,helper/* getCartItemType */.Nth)(a.Product_Category, a.category1_s)
            };
            infoObj.push(productInfo);
        });
        setSampleInfo(infoObj);
    };
    const sortHandler = (val)=>{
        analytics_addDataLayer({
            title: val.toLowerCase(),
            isSampleOverlay: true,
            isSort: true
        });
        setSort(val);
        switch(val){
            case "A - Z":
                return orderData.sort((a, b)=>a.productName_s < b.productName_s ? -1 : 0);
            case "Z - A":
                return orderData.sort((a, b)=>a.productName_s > b.productName_s ? -1 : 0);
            case "Price: High - Low":
                return orderData.sort((a, b)=>a["priceList.".concat(props.persona, ".price_d")] > b["priceList.".concat(props.persona, ".price_d")] ? -1 : 0);
            case "Price: Low - High":
                return orderData.sort((a, b)=>a["priceList.".concat(props.persona, ".price_d")] < b["priceList.".concat(props.persona, ".price_d")] ? -1 : 0);
            default:
                return false;
        }
    };
    (0,react.useEffect)(()=>{
        const handleResize = ()=>{
            if (window.innerWidth > 767) setShowFilter(true);
            else setShowFilter(false);
        };
        window.addEventListener("resize", handleResize);
        handleResize();
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    const filterHandler = ()=>{
        analytics_addDataLayer({
            title: (showFilter ? "Hide Filters" : "Show Filters").toLowerCase(),
            isSampleOverlay: true,
            filterProps: {
                isFilter: true
            }
        });
        return setShowFilter(!showFilter);
    };
    const mobileFilterHandler = ()=>{
        setMobileFilter(!showMobileFilter);
    };
    const sortToggle = ()=>{
        setShowSortDrop(!showSortDrop);
    };
    const filterText = showFilter ? "Hide Filter" : "Show Filter";
    const getAppliedColorsForAnalytics = (appliedColors)=>{
        let filterArray = [];
        appliedColors.forEach((color)=>{
            color.isActive && filterArray.push("color:".concat(color.name.toLowerCase()));
        });
        return filterArray.length ? filterArray.join("|") : "";
    };
    const onColorHandler = (index, activeCol, colorName)=>{
        let updateCol = [];
        let atCol = [];
        updateCol = colorList.map((b)=>{
            if (colorList.indexOf(b) === index && b.isActive === undefined) {
                return {
                    ...b,
                    isActive: true
                };
            } else if (colorList.indexOf(b) === index && b.isActive === false) {
                return {
                    ...b,
                    isActive: true
                };
            } else if (colorList.indexOf(b) !== index && b.isActive === true) {
                return {
                    ...b,
                    isActive: true
                };
            } else {
                return {
                    ...b,
                    isActive: false
                };
            }
        });
        atCol = updateCol.filter((a)=>{
            return a.isActive === true;
        });
        let x = updateCol.map((item)=>{
            let a = "";
            if (item.isActive === true) {
                a += item.name;
            }
            return a;
        });
        let d = x.filter((c)=>"".concat(c)).map((e)=>'"'.concat(e, '"')).join(" OR ");
        d ? onFiterChange(d) : onPageLoad();
        (atCol === null || atCol === void 0 ? void 0 : atCol.length) > 0 ? setChkColorItems(true) : setChkColorItems(false);
        setColorList(updateCol);
        setActiveCol(atCol);
        analytics_addDataLayer({
            title: !activeCol ? "filter applied" : "filter removed",
            isSampleOverlay: true,
            filterProps: {
                isFilter: true,
                appliedFilters: getAppliedColorsForAnalytics(atCol),
                filterName: colorName.toLowerCase()
            }
        });
    };
    // on Filter change API call
    const onFiterChange = (d)=>{
        api/* apim.get */.TH.get("search/plp", {
            params: {
                q: "*:*",
                profilename: "profile_".concat(lwAppName.toLowerCase(), "_PLP"),
                collections: lwAppName.toLowerCase(),
                fq: [
                    'variantList.sku_ss:("'.concat(SKU_SID, '")'),
                    '{!tag="colorFinishFamilyList_ss"}colorFinishFamilyList_ss:('.concat(d, ")")
                ],
                fl: fl.join(","),
                rows: 20
            },
            paramsSerializer: (params)=>{
                return lib_default().stringify(params, {
                    arrayFormat: "repeat",
                    encode: false
                });
            }
        }).then((res)=>setOrderData(res.data.response.docs));
    };
    const getColor = (arr)=>{
        let colObj = [];
        for(let i = 0; i < arr.length; i = i + 2){
            colObj.push({
                name: arr[i],
                count: arr[i + 1]
            });
        }
        const size = (colObj === null || colObj === void 0 ? void 0 : colObj.length) > 3 ? 3 : colObj === null || colObj === void 0 ? void 0 : colObj.length;
        if ((colObj === null || colObj === void 0 ? void 0 : colObj.length) > size) setViewColorList(true);
        handleColorsList(size, colObj);
        return setColorListDefault(colObj);
    };
    const handleColorsList = (size, colorDetails)=>{
        if ((colorDetails === null || colorDetails === void 0 ? void 0 : colorDetails.length) > 0) {
            let list = [];
            colorDetails.map((item, i)=>{
                if (i < size) list.push(item);
            });
            setColorList(list);
        }
    };
    const handleOrderSampleListView = (show, title)=>{
        analytics_addDataLayer({
            title: title.toLowerCase(),
            isSampleOverlay: true,
            filterProps: {
                isFilter: true
            }
        });
        if (show) {
            handleColorsList(Number(colorListDefault === null || colorListDefault === void 0 ? void 0 : colorListDefault.length), colorListDefault);
            setViewColorList(false);
            setHideColorList(true);
        } else {
            handleColorsList(3, colorListDefault);
            setHideColorList(false);
            setViewColorList(true);
        }
    };
    //Remove filter item
    const removeCol = (val)=>{
        let arrC = [];
        let arrD = [];
        arrC = activeCol.map((item)=>{
            if (item.name === val && item.isActive) {
                return {
                    ...item,
                    isActive: false
                };
            } else if (item.name !== val && !item.isActive) {
                return {
                    ...item,
                    isActive: false
                };
            } else if (item.name !== val && item.isActive) {
                return {
                    ...item,
                    isActive: true
                };
            } else {
                return {
                    ...item,
                    isActive: false
                };
            }
        });
        arrD = colorList.map((col)=>{
            if (col.name === val && col.isActive) {
                return {
                    ...col,
                    isActive: false
                };
            } else if (col.name !== val && !col.isActive) {
                return {
                    ...col,
                    isActive: false
                };
            } else if (col.name !== val && col.isActive) {
                return {
                    ...col,
                    isActive: true
                };
            } else {
                return {
                    ...col,
                    isActive: false
                };
            }
        });
        let x = arrC.map((item)=>{
            let a = "";
            if (item.isActive === true) {
                a += item.name;
            }
            return a;
        });
        let hideClearAll = false;
        if (arrC !== undefined && arrC.length > 0) {
            for(let k = 0; k < arrC.length; k = k + 1){
                if (arrC[k]["isActive"] === true) {
                    hideClearAll = true;
                }
            }
        }
        hideClearAll ? setChkColorItems(true) : setChkColorItems(false);
        let d = x.filter((c)=>"".concat(c)).map((e)=>'"'.concat(e, '"')).join(" OR ");
        d ? onFiterChange(d) : onPageLoad();
        setActiveCol(arrC);
        setColorList(arrD);
        analytics_addDataLayer({
            title: "filter cancel",
            isSampleOverlay: true,
            filterProps: {
                isFilter: true,
                appliedFilters: getAppliedColorsForAnalytics(arrC),
                filterName: val.toLowerCase()
            }
        });
    };
    const clearAllCol = ()=>{
        var ref;
        let clerarCol = [];
        let clerar = colorList.map((item)=>{
            return {
                ...item,
                isActive: false
            };
        });
        setChkColorItems(false);
        setActiveCol(clerarCol);
        setColorList(clerar);
        analytics_addDataLayer({
            title: props === null || props === void 0 ? void 0 : (ref = props.staticTexts) === null || ref === void 0 ? void 0 : ref.clearAll.toLowerCase(),
            isSampleOverlay: true,
            filterProps: {
                isFilter: true
            }
        });
        onPageLoad();
    };
    const selectedAnalyticsData = (data)=>{
        let itemAnalyticsArray = [];
        data.map((obj)=>{
            itemAnalyticsArray.push({
                productInfo: sampleInfo[obj.index],
                quantity: sampleInfo[obj.index].quantity
            });
        });
        return itemAnalyticsArray;
    };
    const handleAddToCart = ()=>{
        const selectedData = orderData.filter((item)=>{
            return item.isActive;
        });
        const itemAnalyticsArray = selectedAnalyticsData(selectedData);
        let chartItems = [];
        selectedData.map((item)=>{
            var ref;
            let Vskus = ((ref = item["variantList.sku_ss"]) === null || ref === void 0 ? void 0 : ref.length) > 0 ? item["variantList.sku_ss"][0] : "";
            if (Vskus) {
                chartItems.push({
                    sku: Vskus,
                    quantity: 1,
                    brand: brandName.toLowerCase()
                });
            }
        });
        props.onAddToCart(chartItems, (params)=>{
            var ref;
            analytics_addDataLayer({
                title: (props === null || props === void 0 ? void 0 : (ref = props.staticTexts) === null || ref === void 0 ? void 0 : ref.addToCart).toLowerCase(),
                isSampleOverlay: true,
                isAddtoCart: true,
                cartData: params.data,
                productArray: JSON.stringify({
                    item: itemAnalyticsArray
                })
            });
        });
        props.closePopup();
        showToaster(selectedData);
    };
    const handleCloseOverlay = ()=>{
        props.closePopup();
        analytics_addDataLayer({
            title: "close",
            isSampleOverlay: true
        });
    };
    const closeSortOn = ()=>{
        if (showSortDrop) {
            setShowSortDrop(false);
        }
    };
    const handleScroll = (e)=>{
        const scrolledFromTop = divRef.current.scrollTop;
        setScroll(scrolledFromTop > 10);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "orderOverlay",
        onScroll: handleScroll,
        ref: divRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "orderSampleWrapper",
            onClick: closeSortOn,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "order-sample-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: handleCloseOverlay,
                        className: "closeBtn",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            onError: (e)=>{
                                return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                            },
                            src: close_dark_new/* default */.Z === null || close_dark_new/* default */.Z === void 0 ? void 0 : close_dark_new/* default.src */.Z.src
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "osHeader",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: props.productSummaryData["ProductBrandName_s"] ? props.productSummaryData["ProductBrandName_s"] : props.staticTexts.orderASample
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: props.productSummaryData["ProductDescriptionSmall_s"] ? props.productSummaryData["ProductDescriptionSmall_s"] : ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "optionWrapper",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                        children: props === null || props === void 0 ? void 0 : (ref2 = props.staticTexts) === null || ref2 === void 0 ? void 0 : ref2.color
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            " ",
                                            "".concat(orderData.length, " options")
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "order-sample-wrapper ".concat(scroll ? "filterStickyHeader" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "stickyHeader",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    className: "filter",
                                    onClick: filterHandler,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            onError: (e)=>{
                                                return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                                            },
                                            src: filter/* default */.Z
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "".concat(filterText, " ").concat(activeCol.length > 0 ? "(".concat(activeCol.length, ")") : "")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    className: "filterMobile",
                                    onClick: mobileFilterHandler,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            onError: (e)=>{
                                                return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                                            },
                                            src: filter/* default */.Z
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "".concat(props === null || props === void 0 ? void 0 : (ref3 = props.staticTexts) === null || ref3 === void 0 ? void 0 : ref3.filter, " ").concat(activeCol.length > 0 ? "(".concat(activeCol.length, ")") : "")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "sortWrapper",
                                    onClick: sortToggle,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            className: "sort",
                                            children: [
                                                sort,
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    onError: (e)=>{
                                                        return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                                                    },
                                                    className: showSortDrop ? "upArro" : "downArro",
                                                    src: arrow_down/* default */.Z
                                                })
                                            ]
                                        }),
                                        showSortDrop && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            className: "sortList",
                                            children: sortByVal.map((item, key)=>{
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    onClick: ()=>sortHandler(item),
                                                    children: item
                                                }, "sortList_" + key);
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mainWrapper",
                        children: [
                            showFilter && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "filterWrapper",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "activeColor",
                                        children: activeCol.length > 0 && activeCol.map((item)=>{
                                            return item.isActive && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                value: item.name,
                                                onClick: ()=>removeCol(item.name),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "".concat(item.name)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            onError: (e)=>{
                                                                return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                                                            },
                                                            src: close_dark_new/* default */.Z
                                                        })
                                                    })
                                                ]
                                            });
                                        })
                                    }),
                                    chkColorItems === true && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "clearAll",
                                        onClick: clearAllCol,
                                        children: props === null || props === void 0 ? void 0 : (ref4 = props.staticTexts) === null || ref4 === void 0 ? void 0 : ref4.clearAll
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        children: colorList.length > 0 && colorList.map((col, index)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "checkboxWrapper",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                    value: "".concat(col.name, " (").concat(col.count, ")"),
                                                    onChange: ()=>onColorHandler(index, col.isActive, col.name),
                                                    checked: col.isActive
                                                })
                                            }, "checkboxWrapper_" + index);
                                        })
                                    }),
                                    viewColorList && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "orderSampleWrapper__view_more",
                                        onClick: ()=>{
                                            var ref;
                                            return handleOrderSampleListView(true, props === null || props === void 0 ? void 0 : (ref = props.staticTexts) === null || ref === void 0 ? void 0 : ref.sampleViewMore);
                                        },
                                        children: props === null || props === void 0 ? void 0 : (ref5 = props.staticTexts) === null || ref5 === void 0 ? void 0 : ref5.sampleViewMore
                                    }),
                                    hideColorList && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "orderSampleWrapper__view_more",
                                        onClick: ()=>{
                                            var ref;
                                            return handleOrderSampleListView(false, props === null || props === void 0 ? void 0 : (ref = props.staticTexts) === null || ref === void 0 ? void 0 : ref.sampleViewLess);
                                        },
                                        children: props === null || props === void 0 ? void 0 : (ref6 = props.staticTexts) === null || ref6 === void 0 ? void 0 : ref6.sampleViewLess
                                    })
                                ]
                            }),
                            showMobileFilter && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "filterWrapperMobile",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mobileFilterHead",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                className: "filterMobile",
                                                onClick: mobileFilterHandler,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        onError: (e)=>{
                                                            return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                                                        },
                                                        src: filter/* default */.Z
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "".concat(props === null || props === void 0 ? void 0 : (ref7 = props.staticTexts) === null || ref7 === void 0 ? void 0 : ref7.filter, " ").concat(activeCol.length > 0 ? "(".concat(activeCol.length, ")") : "")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                onClick: mobileFilterHandler,
                                                className: "mobleCloseBtn",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    onError: (e)=>{
                                                        return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                                                    },
                                                    src: close_dark_new/* default */.Z
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "activeColor",
                                        children: activeCol.length > 0 && activeCol.map((item, index)=>{
                                            return item.isActive && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                value: item.name,
                                                onClick: ()=>removeCol(item.name),
                                                children: "".concat(item.name, " X")
                                            }, "activeColor" + index);
                                        })
                                    }),
                                    chkColorItems === true && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "clearAll",
                                        onClick: clearAllCol,
                                        children: props === null || props === void 0 ? void 0 : (ref8 = props.staticTexts) === null || ref8 === void 0 ? void 0 : ref8.clearAll
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mob-colorlist-filter",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                className: chkColorItems === true ? "clearcolor-availability" : "",
                                                children: colorList.map((col, index)=>{
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: "checkboxWrapper",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                            value: col.name,
                                                            count: col.count,
                                                            onChange: ()=>onColorHandler(index, col.isActive, col.name),
                                                            checked: col.isActive
                                                        })
                                                    }, "checkboxWrapper2_" + index);
                                                })
                                            }),
                                            viewColorList && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "orderSampleWrapper__view_more",
                                                onClick: ()=>{
                                                    var ref;
                                                    return handleOrderSampleListView(true, props === null || props === void 0 ? void 0 : (ref = props.staticTexts) === null || ref === void 0 ? void 0 : ref.sampleViewMore);
                                                },
                                                children: props === null || props === void 0 ? void 0 : (ref9 = props.staticTexts) === null || ref9 === void 0 ? void 0 : ref9.sampleViewMore
                                            }),
                                            hideColorList && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "orderSampleWrapper__view_more",
                                                onClick: ()=>{
                                                    var ref;
                                                    return handleOrderSampleListView(false, props === null || props === void 0 ? void 0 : (ref = props.staticTexts) === null || ref === void 0 ? void 0 : ref.sampleViewLess);
                                                },
                                                children: props === null || props === void 0 ? void 0 : (ref10 = props.staticTexts) === null || ref10 === void 0 ? void 0 : ref10.sampleViewLess
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "filterFooter",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "applyBtn",
                                            onClick: mobileFilterHandler,
                                            children: props === null || props === void 0 ? void 0 : (ref11 = props.staticTexts) === null || ref11 === void 0 ? void 0 : ref11.apply
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "listWrapper",
                                children: orderData.length > 0 && orderData.map((item, index)=>{
                                    var ref, ref1, ref2;
                                    let qtyCheck = (ref = availableQuantity.find((qty)=>qty.sku === item.sku_s)) === null || ref === void 0 ? void 0 : ref.availableQuantity;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: qtyCheck > 0 ? "cardWrapper" : "cardWrapper disabled",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "imgBox ".concat(item.isActive === true ? "active" : ""),
                                                onClick: ()=>imageBoxToggler(index, item.isActive),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "tag",
                                                        children: props === null || props === void 0 ? void 0 : (ref1 = props.staticTexts) === null || ref1 === void 0 ? void 0 : ref1.newLabel
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        onError: (e)=>{
                                                            return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                                                        },
                                                        src: item["productImages.url_ss"] === undefined ? image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src : item["productImages.url_ss"]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "cardFooter",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "cardTitle",
                                                        children: item.productName_s
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: "$".concat((ref2 = item["priceList.".concat(props.persona, ".price_d")]) === null || ref2 === void 0 ? void 0 : ref2.toFixed(2))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: qtyCheck > 0 ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "out_of_stock",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "icon",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: warning/* default */.Z === null || warning/* default */.Z === void 0 ? void 0 : warning/* default.src */.Z.src,
                                                                    alt: props.staticTexts.outOfStockInfo
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "text",
                                                                children: props.staticTexts.outOfStockInfo
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }, item.id);
                                })
                            })
                        ]
                    }),
                    enableAddToCart && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "orderFooter",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "addToCartWrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "priceWrapper",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: props === null || props === void 0 ? void 0 : (ref12 = props.staticTexts) === null || ref12 === void 0 ? void 0 : ref12.subtotal
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "cartPrice",
                                            children: "$".concat(total ? total.toFixed(2) : 0.0)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: quantity > 0 ? "addToCartBtn" : "addToCartBtn disabled",
                                    onClick: handleAddToCart,
                                    children: props === null || props === void 0 ? void 0 : (ref13 = props.staticTexts) === null || ref13 === void 0 ? void 0 : ref13.addToCart
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var v1_OrderSample = (OrderSample);

// EXTERNAL MODULE: ./public/icons/tooltip.svg
var tooltip = __webpack_require__(7033);
;// CONCATENATED MODULE: ./components/ProductDetail/v1/ProductSummary/index.jsx















const discounts = [
    50,
    60,
    65,
    70,
    75,
    80
];
const ProductSummary = (props)=>{
    var ref, ref1, ref2;
    const productSummaryData = props.productSummaryDetails;
    const [showOrderSample, setShowOrderSample] = (0,react.useState)(false);
    const [badgeDetailsTooltip, setbadgeDetailsTooltip] = (0,react.useState)("");
    const { t  } = (0,dist_es/* useTranslation */.$G)();
    const [config, setConfig] = (0,react.useState)({});
    const { disableEcommerce  } = props;
    const dispatch = (0,es/* useDispatch */.I0)();
    const { general ={}  } = config;
    const { cartLandingPagePath  } = general;
    const cartUrl = (0,helper/* getShortenedUrlwithGeneral */.vu1)(cartLandingPagePath !== null && cartLandingPagePath !== void 0 ? cartLandingPagePath : "", general);
    const [toaster, setToaster] = (0,react.useState)({
        show: false,
        message: null
    });
    const [selectedItem, setSelectedItem] = (0,react.useState)([]);
    const [showShippingTooltip, setShowShippingTooltip] = (0,react.useState)(false);
    const leadTimeDescription = productSummaryData["ProductASLeadTimeCopy_s"];
    const shippingInfoTooltip = productSummaryData["SKUAnnSacksNonStock_b"] ? props === null || props === void 0 ? void 0 : (ref = props.authorData) === null || ref === void 0 ? void 0 : ref.nonStockShippingInfo : props === null || props === void 0 ? void 0 : (ref1 = props.authorData) === null || ref1 === void 0 ? void 0 : ref1.inStockShippingInfo;
    const showToaster = (selectedData)=>{
        setSelectedItem(selectedData);
        setToaster({
            ...toaster,
            show: true,
            message: ToasterMsg()
        });
        setTimeout(()=>setToaster({
                ...toaster,
                show: false,
                message: null
            }), 3000);
    };
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            setConfig(config);
        });
    }, []);
    (0,react.useEffect)(()=>{
        dispatch((0,pdpSlice/* setLeadTimeTab */.Fs)({
            leadTimeDescription,
            shippingInfoTooltip
        }));
    }, [
        leadTimeDescription,
        shippingInfoTooltip
    ]);
    var _productCategoryType;
    const productCategoryType = (_productCategoryType = props.productCategoryType) !== null && _productCategoryType !== void 0 ? _productCategoryType : "";
    const isSamplesPdp = productCategoryType.toLowerCase() === "samples";
    let itemCountMessage = "".concat(t("kf.pdp.label.itemAdded"), " ");
    const selecteditemCount = selectedItem.length;
    const ToasterMsg = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                selecteditemCount,
                " ",
                itemCountMessage,
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: cartUrl,
                    children: t("kf.pdp.label.yourCart")
                }),
                "."
            ]
        });
    const badgeDetailsTooltipHandler = (data, i)=>{
        setbadgeDetailsTooltip("tooltip_" + i);
        analytics_addDataLayer({
            title: "sutable for:icons mouseover",
            productInfo: props === null || props === void 0 ? void 0 : props.analyticsProductInfo,
            toolTipProps: {
                isToolTip: true,
                toolTipValue: "sutable for:".concat(data.badge_name.toLowerCase())
            }
        });
    };
    const onShowOrderSample = ()=>{
        var ref;
        analytics_addDataLayer({
            title: props === null || props === void 0 ? void 0 : (ref = props.staticTexts) === null || ref === void 0 ? void 0 : ref.orderSample.toLowerCase(),
            productInfo: props === null || props === void 0 ? void 0 : props.analyticsProductInfo
        });
        toggleOrderSample();
    };
    const toggleOrderSample = ()=>{
        setShowOrderSample(!showOrderSample);
    };
    if (showOrderSample) {
        document.getElementsByTagName("BODY")[0].style.overflow = "hidden";
    } else {
        document.getElementsByTagName("BODY")[0].removeAttribute("style");
    }
    let badgeDescription = [];
    let totalBadgeInfoLength = props.productSummaryDetails["SKUBadgeInfo_ss"] ? props.productSummaryDetails["SKUBadgeInfo_ss"].length : 0;
    if (totalBadgeInfoLength > 0) {
        let getBadgeInfo = "";
        let getBadgeArray = [];
        let badgeDescriptionTmp = [];
        let i;
        for(i = 0; i < props.productSummaryDetails["SKUBadgeInfo_ss"].length; i++){
            if (props.productSummaryDetails["SKUBadgeInfo_ss"][i] !== "") {
                getBadgeInfo = "";
                getBadgeArray = [];
                badgeDescriptionTmp = [];
                getBadgeInfo = props.productSummaryDetails["SKUBadgeInfo_ss"][i];
                getBadgeArray = getBadgeInfo.indexOf("|") > -1 ? getBadgeInfo.split("|") : "";
                if (getBadgeArray.length > 0) {
                    badgeDescriptionTmp["badge_name"] = getBadgeArray[0] ? getBadgeArray[0] : "";
                    badgeDescriptionTmp["badge_description"] = getBadgeArray[1] ? getBadgeArray[1] : "";
                    badgeDescriptionTmp["badge_url"] = getBadgeArray[2] ? getBadgeArray[2] : "";
                    badgeDescription[i] = badgeDescriptionTmp;
                }
            }
        }
    }
    var _pdpProductCustomerFacingName;
    let title = (_pdpProductCustomerFacingName = props.pdpProductCustomerFacingName) !== null && _pdpProductCustomerFacingName !== void 0 ? _pdpProductCustomerFacingName : "";
    if (productSummaryData["productName_s"]) {
        title = productSummaryData["productName_s"];
    }
    const getDesignByTitle = ()=>{
        let productDesignerS = productSummaryData["ProductDesigner_s"], productDesignerByText = "";
        if (productDesignerS && title.toLowerCase().indexOf(productDesignerS.toLowerCase()) === -1) {
            var ref;
            productDesignerByText = productDesignerS ? (props === null || props === void 0 ? void 0 : (ref = props.staticTexts) === null || ref === void 0 ? void 0 : ref.by) + " " + productDesignerS : "";
        }
        return productDesignerByText;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-12 product-summary__product-summary-block p-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "product-summary",
                    id: "product-summary-wrapper",
                    children: [
                        productSummaryData["ProductPageTitle_s"] && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product-summary__title",
                            children: productSummaryData["ProductPageTitle_s"]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "product-summary__desc",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                    className: "product-summary__desc",
                                    children: [
                                        title,
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "product-summary__desc",
                                    children: getDesignByTitle()
                                })
                            ]
                        }),
                        !isSamplesPdp && !props.isDiscontinued && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                props.price > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "product-summary__price",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "sr-only",
                                            children: "".concat(props.discountedPrice ? "Discounted" : "Current", " price ").concat(props.currencySign, " ").concat(props.discountedPrice > 0 ? props.discountedPrice : props.price)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "product-summary__price-first",
                                            "aria-hidden": "true",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                value: props.discountedPrice > 0 ? props.discountedPrice : props.price,
                                                displayType: "text",
                                                thousandSeparator: true,
                                                prefix: props.currencySign,
                                                decimalScale: 2,
                                                fixedDecimalScale: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "product-summary__price-sec",
                                            children: props === null || props === void 0 ? void 0 : props.priceTag
                                        })
                                    ]
                                }),
                                props.discountedPrice > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "product-summary__discount",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "sr-only",
                                            children: "Original price ".concat(props.currencySign, " ").concat(props.price)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "product-summary__discount-price",
                                            "aria-hidden": true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                value: props.price,
                                                displayType: "text",
                                                thousandSeparator: true,
                                                prefix: props.currencySign,
                                                decimalScale: 2,
                                                fixedDecimalScale: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "product-summary__price-sec",
                                            children: props === null || props === void 0 ? void 0 : props.priceTag
                                        }),
                                        props.discountPercent > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "product-summary__percent-off",
                                            children: props.isType === "absolute" ? props.currencySign + props.discountPercent + props.staticTexts.percentOff : props.discountPercent + "% " + props.staticTexts.percentOff
                                        }) : props.discountedPrice > 0 && props.isType === "relative" && discounts.includes(Math.round(Number((100 - props.discountedPrice / props.price * 100).toFixed(0)))) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "product-summary__percent-off",
                                            children: [
                                                Math.round(Number((100 - props.discountedPrice / props.price * 100).toFixed(0))) + "%",
                                                " ",
                                                props.staticTexts.percentOff
                                            ]
                                        }) : null
                                    ]
                                })
                            ]
                        }),
                        !productSummaryData["noBadge_b"] && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "product-summary__shipping",
                            children: [
                                productSummaryData["SKUAnnSacksNonStock_b"] ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "product-summary__shipping-status",
                                            children: constants.SPECIAL_ORDER_LABEL + ": "
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "product-summary__shipping-time",
                                            children: constants.SHIPS_IN_LABEL + " " + productSummaryData["LeadTimeRange_s"]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "product-summary__shipping-status",
                                    children: constants.READY_TO_SHIP_LABEL
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "product-summary__shipping-time-block",
                                    onMouseEnter: ()=>setShowShippingTooltip(true),
                                    onMouseLeave: ()=>setShowShippingTooltip(false),
                                    onFocus: ()=>setShowShippingTooltip(true),
                                    onBlur: ()=>setShowShippingTooltip(false),
                                    tabIndex: 0,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: tooltip/* default */.Z === null || tooltip/* default */.Z === void 0 ? void 0 : tooltip/* default.src */.Z.src,
                                            role: "tooltip",
                                            tabIndex: 0,
                                            className: "shipingtooltip",
                                            alt: "Shipping Info",
                                            "aria-hidden": "true"
                                        }),
                                        showShippingTooltip && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            id: "shipping-tooltip",
                                            className: "tooltipWrapper",
                                            role: "tooltip",
                                            tabIndex: -1,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "tooltip__container",
                                                dangerouslySetInnerHTML: {
                                                    __html: shippingInfoTooltip
                                                }
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product-summary__details",
                            children: productSummaryData["ProductDescriptionSmall_s"] ? productSummaryData["ProductDescriptionSmall_s"] : ""
                        }),
                        !disableEcommerce && !props.isDiscontinued && productSummaryData["SKUSamples_ss"] && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product-summary__button-block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "kf-react-button product-summary__button",
                                type: "button",
                                onClick: onShowOrderSample,
                                children: props === null || props === void 0 ? void 0 : (ref2 = props.staticTexts) === null || ref2 === void 0 ? void 0 : ref2.orderSample
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product-summary__icons-block",
                            children: badgeDescription !== "" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product-summary__icons-part-first",
                                children: badgeDescription.map((badgeDetails, i)=>{
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "product-details__list-text",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    onError: (e)=>{
                                                        return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                                                    },
                                                    src: badgeDetails.badge_url,
                                                    className: "product-summary__icons",
                                                    onMouseOver: ()=>badgeDetailsTooltipHandler(badgeDetails, i),
                                                    onMouseLeave: ()=>setbadgeDetailsTooltip("")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "product-details__tooltip-main-block product-details__list-tooltip".concat(badgeDetailsTooltip === "tooltip_" + i ? "--show" : "--hide"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "product-details__list-tooltip-wrapper",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolTip/* default */.Z, {
                                                        label: "Suitable For",
                                                        message: badgeDetails.badge_name
                                                    })
                                                })
                                            })
                                        ]
                                    }, "badgeDetails-".concat(i));
                                })
                            }) : ""
                        })
                    ]
                })
            }),
            toaster.show && /*#__PURE__*/ (0,jsx_runtime.jsx)(Toaster["default"], {
                message: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToasterMsg, {})
            }),
            !props.isDiscontinued && showOrderSample && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_OrderSample, {
                closePopup: toggleOrderSample,
                productSummaryData: productSummaryData,
                showToaster: showToaster,
                config: config,
                ...props
            })
        ]
    });
};
/* harmony default export */ var v1_ProductSummary = (ProductSummary);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./public/icons/down-arrow.svg
var down_arrow = __webpack_require__(80779);
// EXTERNAL MODULE: ./src/components/VideoWrapper/VideoWrapper.jsx + 1 modules
var VideoWrapper = __webpack_require__(38279);
// EXTERNAL MODULE: ./src/hooks/useWindowResize.js
var useWindowResize = __webpack_require__(18216);
;// CONCATENATED MODULE: ./components/ProductDetail/v1/ProductGalleryView/ProductGalleryViewer.jsx








const ProductGalleryViewer = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    let imageListLength = props === null || props === void 0 ? void 0 : (ref = props.data) === null || ref === void 0 ? void 0 : ref.length;
    const viewMoreLink = imageListLength > 8 ? true : false;
    const [selectedItem, setSelectedItem] = (0,react.useState)(0);
    const [width] = (0,useWindowResize/* default */.Z)();
    const [presetConfig] = (0,react.useState)(props.presetConfigObject);
    const [imageData, setImageData] = (0,react.useState)(props.data && {
        ...props.data[selectedItem],
        url: (0,helper/* getPDPPresetUrl */.AJ0)(props.swatchUrl, presetConfig, (ref1 = props.data[selectedItem]) === null || ref1 === void 0 ? void 0 : ref1.url, width, (ref2 = props.data[selectedItem]) === null || ref2 === void 0 ? void 0 : ref2.template, props.accountName)
    });
    (0,react.useLayoutEffect)((0,helper/* debounce */.DsO)(()=>{
        var ref, ref1;
        const tempImageData = props.data && {
            ...props.data[selectedItem],
            url: (0,helper/* getPDPPresetUrl */.AJ0)(props === null || props === void 0 ? void 0 : props.swatchUrl, presetConfig, (ref = props.data[selectedItem]) === null || ref === void 0 ? void 0 : ref.url, width, (ref1 = props.data[selectedItem]) === null || ref1 === void 0 ? void 0 : ref1.template, props.accountName)
        };
        setImageData(tempImageData);
    }), [
        width,
        props.data,
        selectedItem
    ]);
    (0,react.useEffect)(()=>{
        setSelectedItem(0);
    }, [
        props.data
    ]);
    let resourceTmpCredits = props && props.productGalleryLabel && props.productGalleryLabel.resourceCredit_s && props.productGalleryLabel.resourceCredit_s.match("http") == null ? props.productGalleryLabel.resourceCredit_s : "";
    let showSku = props && props.productData && props.productData.category.match("Samples") !== null ? "SKU: " + props.productData.sku : "";
    let resourceCredits = showSku ? showSku : resourceTmpCredits;
    let productDetailsForImage = props === null || props === void 0 ? void 0 : props.productDetailsForImage;
    const handleChange = function(index) {
        let resourceCredits = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        setSelectedItem(index);
        if (!showSku) {
            let resourceCreditsTxt = resourceCredits && resourceCredits.match("http") == null ? resourceCredits : "";
            document.querySelector(".image-reel__photo-credit").innerHTML = resourceCreditsTxt;
        }
    };
    let badgeList = [];
    if (props === null || props === void 0 ? void 0 : props.showSaleBadge) badgeList.push(props === null || props === void 0 ? void 0 : (ref3 = props.staticTexts) === null || ref3 === void 0 ? void 0 : ref3.saleLabel);
    if (props === null || props === void 0 ? void 0 : (ref4 = props.productGalleryLabel) === null || ref4 === void 0 ? void 0 : ref4.newTag) badgeList.push(props === null || props === void 0 ? void 0 : (ref5 = props.staticTexts) === null || ref5 === void 0 ? void 0 : ref5.newLabel);
    if (props === null || props === void 0 ? void 0 : (ref6 = props.productGalleryLabel) === null || ref6 === void 0 ? void 0 : ref6.productExclusive) badgeList.push(props === null || props === void 0 ? void 0 : (ref7 = props.staticTexts) === null || ref7 === void 0 ? void 0 : ref7.exclusiveLebel);
    let pdpBadgeName = badgeList.join(" & ");
    let imageList = props === null || props === void 0 ? void 0 : props.data;
    let placeHolder = false;
    if (props.data && props.data[0]) {
        if (!props.data[0].template) {
            if (props.placeholderImage) {
                imageList.url = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                placeHolder = true;
            }
        }
    }
    let reelImageList = imageData;
    if (imageData) {
        if (!imageData.template) {
            if (props.placeholderImage) {
                reelImageList.url = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                placeHolder = true;
            }
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat(resourceCredits ? "image-reel row resourcecredits" : "image-reel row"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "image-reel__image-thumb-view no-print",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: "pl-0 ml-0 image-reel__image-thumb-view-ul",
                        children: [
                            imageList && imageList.slice(0, 8).map((el, i)=>{
                                const urlParts = el.url.split("/");
                                const id = urlParts[urlParts.length - 1];
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "image-reel__image-list",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "image-reel_".concat(selectedItem === i ? "_thumbSelected" : "_image-thumb"),
                                        onClick: ()=>{
                                            handleChange(i, el.resourceCredits);
                                        },
                                        onKeyDown: (e)=>{
                                            if (e.key === "Enter") {
                                                handleChange(i, el.resourceCredits);
                                            }
                                        },
                                        children: el.type ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoWrapper/* default */.Z, {
                                            thumb: true,
                                            videoId: el.url
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            onError: (e)=>{
                                                return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                                            },
                                            src: placeHolder ? el.url : (0,helper/* getAsPDPThumbnail */.wN4)(props.swatchUrl, props.presetConfig, id, props.accountName),
                                            alt: "Product image variation ".concat(i + 1),
                                            "aria-label": "Product image variation ".concat(i + 1),
                                            "aria-live": "polite",
                                            className: "img-fluid",
                                            tabIndex: "0",
                                            role: "button"
                                        })
                                    })
                                }, i);
                            }),
                            viewMoreLink && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "image-reel__image-view",
                                onClick: ()=>props.handlePopup(),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "image-reel__link-more gbh-data-layer",
                                        "data-gbh-data-layer": '{"eventAction":"pdp:product details:view gallery","eventName":"pdp:product details:view gallery","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"view gallery","internalLinkPosition":"pdp","internalLinkType":"pdp:navigation","internalLinkZoneName":"pdp:product details","internalLinkURL":"n/a","clickInternalLinks":"true"}',
                                        children: props.staticTexts.viewLink
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: down_arrow/* default */.Z === null || down_arrow/* default */.Z === void 0 ? void 0 : down_arrow/* default.src */.Z.src,
                                        alt: "down-arrow"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "image-reel__image-stack-view",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "image-reel__image-stack-view-block",
                            children: [
                                pdpBadgeName && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "product-gallery__badge",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "product-gallery__new",
                                        children: pdpBadgeName
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "pl-0 list-inline image-reel__image-stack-list",
                                    children: reelImageList && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: !reelImageList.type ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            onError: (e)=>{
                                                return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                                            },
                                            src: reelImageList === null || reelImageList === void 0 ? void 0 : reelImageList.url,
                                            alt: "Product image variation ".concat(selectedItem + 1),
                                            fetchpriority: "high",
                                            className: "".concat(selectedItem === 0 ? "image-reel__stack-list-image print" : "image-reel__stack-list-image no-print"),
                                            role: "button",
                                            tabIndex: "0"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoWrapper/* default */.Z, {
                                            videoId: reelImageList.url,
                                            height: "350"
                                        })
                                    })
                                })
                            ]
                        }),
                        productDetailsForImage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "image-reel__product-details",
                            children: [
                                productDetailsForImage,
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "image-reel__photo-credit",
                            children: resourceCredits
                        })
                    ]
                })
            ]
        })
    });
};
ProductGalleryViewer.defaultProps = {
    data: [],
    staticTexts: {}
};
ProductGalleryViewer.propTypes = {
    data: prop_types_default().arrayOf((prop_types_default()).any).isRequired,
    staticTexts: (prop_types_default()).object
};
/* harmony default export */ var ProductGalleryView_ProductGalleryViewer = (ProductGalleryViewer);

// EXTERNAL MODULE: ./src/components/core/Modal/Modal.jsx + 2 modules
var Modal_Modal = __webpack_require__(2583);
// EXTERNAL MODULE: ./public/icons/arrow-left.svg
var arrow_left = __webpack_require__(71623);
// EXTERNAL MODULE: ./public/icons/arrow-right.svg
var arrow_right = __webpack_require__(29157);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
;// CONCATENATED MODULE: ./components/ProductDetail/v1/ProductDetailView/ImageGallery/ImageGalleryHorizontal.jsx












const ImageGalleryHorizontal = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    let { productInfo , presetConfigObject ={} , imageClickCounter , updateImageClickCounter , swatchUrl , assetAccountName  } = props;
    let imageListLength = props.data.length;
    const [select, setSelected] = (0,react.useState)(0);
    const viewMoreLink = imageListLength > 10 ? true : false;
    const imageList = props.isPopup ? props.data : props.data.slice(0, 10);
    const showArrowFlag = imageListLength > 20 && !dist_lib/* isMobile */.tq ? true : false;
    const showSliderArrow = imageListLength > 3 && !dist_lib/* isMobile */.tq ? true : false;
    const [width] = (0,useWindowResize/* default */.Z)();
    let productDetailsForImage = props === null || props === void 0 ? void 0 : props.productDetailsForImage;
    let resourceCredits = props && props.productGalleryLabel && props.productGalleryLabel.resourceCredit_s && props.productGalleryLabel.resourceCredit_s.match("http") == null ? props.productGalleryLabel.resourceCredit_s : props.resourceCredits ? props.resourceCredits : "";
    const handleChange = function(element, id, type) {
        let resourceCredits = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
        const getOverAllImage = document.querySelectorAll("#".concat(props.galleryStackId));
        const defImageOffset = getOverAllImage[0].childNodes[0].offsetLeft;
        const eleOffset = getOverAllImage[0].childNodes[element].offsetLeft;
        const scrollValue = eleOffset - defImageOffset;
        let isAlreadyChecked = false;
        if (select === element) {
            isAlreadyChecked = true;
        }
        slideView(scrollValue, element);
        if (window.adobeDataLayer && !isAlreadyChecked) {
            if (!id && imageList[element]) {
                // find matching if from imageList
                id = imageList[element].assetId || imageList[element].url;
            }
            const { adobeDataLayer: { getState  } = {}  } = window;
            const page = getState && getState("page") || {};
            const eventInfo = getEventInfo(type, id);
            const pI = productInfo ? JSON.parse(productInfo).productInfo : null;
            window.adobeDataLayer.push({
                event: "cmp:click",
                page,
                eventInfo,
                productInfo: pI
            });
            updateImageClickCounter && updateImageClickCounter();
        }
        let resourceCreditsTxt = resourceCredits && (resourceCredits === null || resourceCredits === void 0 ? void 0 : resourceCredits.match("http")) == null ? resourceCredits : "";
        const imageGalleryContainer = document.querySelector(".image-gallery-container") || null;
        if (imageGalleryContainer) {
            const resourceCreditElement = imageGalleryContainer.querySelector(".image-reel__photo-credit");
            if (resourceCreditElement) {
                resourceCreditElement.innerHTML = resourceCreditsTxt;
            }
        } else {
            const resourceCreditElement1 = document.querySelector(".image-reel__photo-credit");
            if (resourceCreditElement1) {
                resourceCreditElement1.innerHTML = resourceCreditsTxt;
            }
        }
    };
    const getEventInfo = (type, id)=>{
        const eventInfo = {
            eventAction: "pdp:modal:gallery:".concat(type || "image or video"),
            eventName: "pdp:modal:gallery:".concat(type || "image or video"),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: type || id,
            internalLinkPosition: "pdp",
            internalLinkType: "pdp:".concat(type || "navigation"),
            internalLinkZoneName: "pdp:modal:gallery",
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
        if (imageClickCounter && type !== "carousel") {
            eventInfo.imageSequence = imageClickCounter + 1;
        }
        return eventInfo;
    };
    function slideView(scrollValue, ele) {
        const getImageView = document.getElementById("".concat(props.galleryStackId));
        window.isCustomScroll = true;
        getImageView.scrollTo({
            top: 0,
            left: "".concat(scrollValue),
            behavior: "smooth"
        });
        setSelected(ele);
    }
    const onScroll = lodash_debounce_default()(()=>{
        if (!window.isCustomScroll) {
            const { adobeDataLayer: { getState  } = {}  } = window;
            const page = getState && getState("page") || {};
            const eventInfo = getEventInfo("carousel");
            const pI = productInfo ? JSON.parse(productInfo).productInfo : null;
            window.adobeDataLayer.push({
                event: "cmp:click",
                page,
                eventInfo,
                productInfo: pI
            });
        } else {
            window.isCustomScroll = false;
        }
    }, 2000);
    (0,react.useEffect)(()=>{
        const getImageView = document.getElementById("".concat(props.galleryStackId));
        getImageView.removeEventListener("scroll", onScroll);
        getImageView.addEventListener("scroll", onScroll, {
            passive: true
        });
        return ()=>{
            delete window.isCustomScroll;
            getImageView && getImageView.removeEventListener("scroll", onScroll);
        };
    }, [
        imageListLength
    ]);
    let pdpBadgeName = (props === null || props === void 0 ? void 0 : (ref = props.productGalleryLabel) === null || ref === void 0 ? void 0 : ref.isSale) ? props === null || props === void 0 ? void 0 : (ref1 = props.staticTexts) === null || ref1 === void 0 ? void 0 : ref1.saleLabel : (props === null || props === void 0 ? void 0 : (ref2 = props.productGalleryLabel) === null || ref2 === void 0 ? void 0 : ref2.newTag) && (props === null || props === void 0 ? void 0 : (ref3 = props.productGalleryLabel) === null || ref3 === void 0 ? void 0 : ref3.productExclusive) ? (props === null || props === void 0 ? void 0 : (ref4 = props.staticTexts) === null || ref4 === void 0 ? void 0 : ref4.newLabel) + "+" + (props === null || props === void 0 ? void 0 : (ref5 = props.staticTexts) === null || ref5 === void 0 ? void 0 : ref5.exclusiveLebel) : (props === null || props === void 0 ? void 0 : (ref6 = props.productGalleryLabel) === null || ref6 === void 0 ? void 0 : ref6.newTag) ? props === null || props === void 0 ? void 0 : (ref7 = props.staticTexts) === null || ref7 === void 0 ? void 0 : ref7.newLebel : (props === null || props === void 0 ? void 0 : (ref8 = props.productGalleryLabel) === null || ref8 === void 0 ? void 0 : ref8.productExclusive) ? props === null || props === void 0 ? void 0 : (ref9 = props.staticTexts) === null || ref9 === void 0 ? void 0 : ref9.exclusiveLebel : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "image-gallery",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "image-gallery__stack",
                    children: [
                        (props === null || props === void 0 ? void 0 : props.showBadges) && pdpBadgeName && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product-gallery__badge",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "product-gallery__new",
                                children: pdpBadgeName
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "image-gallery__image-stack-view",
                            id: props.galleryStackId,
                            children: imageList.map((element, i)=>{
                                const imageData = element.url.split("/");
                                const assetId = imageData[imageData.length - 1];
                                var _assetId;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    id: i,
                                    className: "image-gallery__image-stack-list",
                                    children: !element.type ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        onError: (e)=>{
                                            return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                                        },
                                        src: (0,helper/* appendPresetToUrl */.QCk)(swatchUrl, (_assetId = element.assetId) !== null && _assetId !== void 0 ? _assetId : assetId, width, presetConfigObject, props.isPopup, props.accountName),
                                        alt: element.label,
                                        onClick: ()=>{
                                            (props === null || props === void 0 ? void 0 : props.enablePresets) ? handleChange(i, element.assetId || element.url, "", element === null || element === void 0 ? void 0 : element.resourceCredits) : handleChange(i, element.assetId || element.url);
                                        },
                                        onKeyPress: (event)=>{
                                            if (event.key === "Enter") (props === null || props === void 0 ? void 0 : props.enablePresets) ? handleChange(i, element.assetId || element.url, "", element === null || element === void 0 ? void 0 : element.resourceCredits) : handleChange(i, element.assetId || element.url);
                                        }
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoWrapper/* default */.Z, {
                                        height: "100%",
                                        videoId: element.url,
                                        onClick: ()=>{
                                            handleChange(i, element.url);
                                        }
                                    })
                                }, i);
                            })
                        }),
                        showSliderArrow && imageList.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: select === 0 ? "previous-image" : "previous-image-dark",
                                    onClick: ()=>{
                                        let pos = select > 0 ? select - 1 : select;
                                        handleChange(pos);
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: select === imageList.length - 1 ? "next-image" : "next-image-dark",
                                    onClick: ()=>{
                                        let position = imageList.length - 1 > select ? select + 1 : select;
                                        handleChange(position);
                                    }
                                })
                            ]
                        })
                    ]
                }),
                productDetailsForImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "image-reel__product-details",
                    children: productDetailsForImage
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "image-reel__photo-credit",
                    children: resourceCredits
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "image-gallery__thumb",
                    children: [
                        showArrowFlag && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: arrow_left/* default */.Z,
                                alt: "leftArrow",
                                className: "image-gallery__left-arrow"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "image-gallery__image-thumb-view",
                            id: "image-gallery__image-thumb-view",
                            children: [
                                imageList.map((element, i)=>{
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                        className: "image-gallery__image-thumb-list",
                                        id: "image-gallery__image-thumb-list",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "image-gallery_".concat(select === i ? "_image-thumbSelected" : "_image-thumb"),
                                            onClick: ()=>{
                                                (props === null || props === void 0 ? void 0 : props.enablePresets) ? handleChange(i, element.assetId || element.url, "", element === null || element === void 0 ? void 0 : element.resourceCredits) : handleChange(i, element.assetId || element.url);
                                            },
                                            onKeyPress: (event)=>{
                                                if (event.key === "Enter") (props === null || props === void 0 ? void 0 : props.enablePresets) ? handleChange(i, element.assetId || element.url, "", element === null || element === void 0 ? void 0 : element.resourceCredits) : handleChange(i, element.assetId || element.url);
                                            },
                                            children: element.type ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoWrapper/* default */.Z, {
                                                thumb: true,
                                                videoId: element.url
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                role: "button",
                                                onError: (e)=>{
                                                    return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                                                },
                                                src: (props === null || props === void 0 ? void 0 : props.enablePresets) ? element.url : (0,utils/* getPresetThumbnailUrl */.BB)(swatchUrl, element.assetId, presetConfigObject, assetAccountName),
                                                alt: element.label,
                                                tabIndex: 0
                                            })
                                        })
                                    }, i);
                                }),
                                !props.isPopup && viewMoreLink && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "image-gallery__image-thumb-list",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        role: "button",
                                        tabIndex: 0,
                                        className: "image-gallery__link-more viewmore-mobile",
                                        onClick: ()=>props.handlePopup(),
                                        children: props.staticTexts.viewMore
                                    })
                                })
                            ]
                        }),
                        showArrowFlag && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: arrow_right/* default */.Z,
                                alt: "rightArrow",
                                className: "image-gallery__right-arrow"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
ImageGalleryHorizontal.defaultProps = {
    data: [],
    staticTexts: {},
    productInfo: "",
    imageClickCounter: 0
};
ImageGalleryHorizontal.propTypes = {
    data: prop_types_default().arrayOf((prop_types_default()).any).isRequired,
    staticTexts: (prop_types_default()).object,
    productInfo: (prop_types_default()).string,
    imageClickCounter: (prop_types_default()).number,
    updateImageClickCounter: (prop_types_default()).func
};
/* harmony default export */ var ImageGallery_ImageGalleryHorizontal = (ImageGalleryHorizontal);

;// CONCATENATED MODULE: ./components/ProductDetail/v1/ProductGalleryView/index.jsx






const ProductGalleryView = (props)=>{
    const [showModal, setShowModal] = (0,react.useState)(false);
    const presetConfigObject = typeof props.presetConfig === "string" ? JSON.parse(props.presetConfig) : props.presetConfig;
    const handleModalPopup = ()=>{
        setShowModal(true);
        document.body.classList.add("image-gallery-modal-opened");
    };
    const { pdpData  } = props;
    const pdpDetails = pdpData !== null && pdpData !== void 0 ? pdpData : {};
    const { pdpDesktopImage  } = pdpDetails;
    let placeholderImage = [];
    if (pdpDesktopImage) {
        placeholderImage[0] = {
            label: " ",
            template: "LandscapeCategory",
            url: pdpDesktopImage
        };
    }
    const onModalClose = ()=>{
        setShowModal(false);
        document.body.classList.remove("image-gallery-modal-opened");
        document.body.classList.remove("scroll-lock");
        (0,helper/* preventBodyScroll */.MVu)(false);
    };
    const isMobileDevice = window.innerWidth < 840;
    let resourceTmpCredits = props && props.productGalleryLabel && props.productGalleryLabel.resourceCredit_s && props.productGalleryLabel.resourceCredit_s.match("http") == null ? props.productGalleryLabel.resourceCredit_s : "";
    let showSku = props && props.productData && props.productData.category.match("Samples") !== null ? "SKU: " + props.productData.sku : "";
    let resourceCredits = showSku ? showSku : resourceTmpCredits;
    const queryParams = new URLSearchParams(window.location.search);
    const productDetailsForImage = props.productData && props.productData.name + " " + props.productData.desc + " " + "in" + " " + props.imageColorDetails;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            isMobileDevice ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mobile-gallery",
                id: "imageGallery",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageGallery_ImageGalleryHorizontal, {
                    ...props,
                    placeholderImage: placeholderImage,
                    presetConfigObject: presetConfigObject,
                    isPopup: false,
                    handlePopup: handleModalPopup,
                    galleryStackId: "image-gallery__image-stack-gallery",
                    showBadges: true,
                    showPhotoCredit: "1",
                    resourceCredits: resourceCredits,
                    productDetailsForImage: productDetailsForImage
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductGalleryView_ProductGalleryViewer, {
                ...props,
                presetConfigObject: presetConfigObject,
                handlePopup: handleModalPopup,
                placeholderImage: placeholderImage,
                productDetailsForImage: productDetailsForImage
            }),
            showModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_Modal["default"], {
                onModalClose: onModalClose,
                showModal: showModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "image-gallery-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageGallery_ImageGalleryHorizontal, {
                        ...props,
                        presetConfigObject: presetConfigObject,
                        isPopup: true,
                        galleryStackId: "image-gallery__image-stack-kohler",
                        placeholderImage: placeholderImage
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var v1_ProductGalleryView = (ProductGalleryView);

// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
;// CONCATENATED MODULE: ./public/icons/tooltip-red.svg
/* harmony default export */ var tooltip_red = ({"src":"/_next/static/media/tooltip-red.3be5ed6c.svg","height":30,"width":30});
;// CONCATENATED MODULE: ./public/icons/favorites-empty-annsacks.svg
/* harmony default export */ var favorites_empty_annsacks = ({"src":"/_next/static/media/favorites-empty-annsacks.54cd777a.svg","height":14,"width":15});
;// CONCATENATED MODULE: ./public/icons/favorites-filled-annsacks.svg
/* harmony default export */ var favorites_filled_annsacks = ({"src":"/_next/static/media/favorites-filled-annsacks.10cdd75e.svg","height":14,"width":15});
;// CONCATENATED MODULE: ./public/icons/print-annsacks.svg
/* harmony default export */ var print_annsacks = ({"src":"/_next/static/media/print-annsacks.82c27adc.svg","height":17,"width":17});
;// CONCATENATED MODULE: ./public/icons/share-annsacks.svg
/* harmony default export */ var share_annsacks = ({"src":"/_next/static/media/share-annsacks.4593d784.svg","height":17,"width":14});
// EXTERNAL MODULE: ./public/icons/email.svg
var email = __webpack_require__(39306);
// EXTERNAL MODULE: ./public/icons/phone-icon.svg
var phone_icon = __webpack_require__(52324);
// EXTERNAL MODULE: ./src/js/helperV2.js
var helperV2 = __webpack_require__(41162);
// EXTERNAL MODULE: ./src/components/core/ReCaptcha/ReCaptcha.jsx + 1 modules
var ReCaptcha = __webpack_require__(15740);
;// CONCATENATED MODULE: ./components/ProductDetail/v1/ProductDetailView/AddToCart/MadeToOrder.jsx










const MadetoOrder = (param)=>{
    let { showModal , closeModal , activeTab , setActiveTab , config , ...props } = param;
    const { t  } = (0,dist_es/* useTranslation */.$G)();
    const staticTexts = {
        talktous: t("annsacks.annsacksPdp.talktous"),
        talktousatfreetime: t("annsacks.annsacksPdp.talktousatfreetime"),
        contactuslabel: t("kf.contactus.label.contactUsDisplayName"),
        chatwithus: t("annsacks.annsacksPdp.chatwithus"),
        chatwithusdescription: t("annsacks.annsacksPdp.chachatwithusdescription"),
        contactnumber: t("annsacks.annsacksPdp.contactnumber"),
        emaildescription: t("annsacks.annsacksPdp.emaildescription"),
        emailus: t("annsacks.annsacksPdp.emailus"),
        letuscontactyou: t("annsacks.annsacksPdp.letuscontactyou"),
        requiredFields: t("kf.checkout.label.requiredFields"),
        contactme: t("annsacks.annsacksPdp.contactme"),
        firstname: t("kf.contactus.label.firstName"),
        lastname: t("kf.contactus.label.lastName"),
        emailAddress: t("kf.contactus.label.emailAddress"),
        email: t("kf.reqAppointment.label.email"),
        phone: t("kf.checkout.label.phone"),
        preferenceTitle: t("annsacks.annsacksPdp.preferenceTitle"),
        privacyPolicy: t("kf.friendsandfamily.label.privacyPolicy"),
        subjectAccessRequest: t("kf.associatemembership.label.subjectAccessRequest"),
        termsOfService: t("kf.friendsandfamily.label.termsOfService"),
        firstnameError: t("kf.contactus.error.fnameError"),
        lastnameError: t("kf.contactus.error.lnameError"),
        validEmail: t("kf.contactus.error.validEmail"),
        noEmailError: t("kf.checkout.error.noEmailError"),
        noPhoneError: t("kf.contactus.error.noPhoneError"),
        validPhone: t("kf.checkout.error.validPhone"),
        sucessmsgTitle: t("annsacks.annsacksPdp.emailSent"),
        contactShortly: t("annsacks.annsacksPdp.contactShortly"),
        continueShopping: t("kf.compare.label.continueShopping"),
        goodtimetalk: t("annsacks.annsacksPdp.goodTimeTalk"),
        anyTime: t("annsacks.annsacksPdp.anyTime"),
        weekdays: t("annsacks.annsacksPdp.weekdays"),
        weekends: t("annsacks.annsacksPdp.weekends"),
        weekdaysMidDays: t("annsacks.annsacksPdp.weekdaysMidDays"),
        continue: t("kf.global.label.continue"),
        SFerrormessage: t("annsacks.annsacksPdp.SFerrormessage")
    };
    const { legalPageData: { legalPageLinks  } , general ={}  } = config;
    var ref;
    const homePagePath = (0,helper/* getShortenedUrlwithGeneral */.vu1)((ref = general === null || general === void 0 ? void 0 : general.homepageUrl) !== null && ref !== void 0 ? ref : "/", general);
    const [contactData, setContactData] = (0,react.useState)({
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        Preferred_Mode_of_Contact__c: staticTexts.email,
        Preferred_Day_Time_of_Contact__c: ""
    });
    const [preference, setPreference] = (0,react.useState)(staticTexts.email);
    const [talktime, setTalkTime] = (0,react.useState)(null);
    const [error, setError] = (0,react.useState)({});
    const [showSucessModal, setShowSucessModal] = (0,react.useState)(false);
    const [userErrormessage, setUserErrormessage] = (0,react.useState)(null);
    const { authorData  } = props;
    (0,react.useEffect)(()=>{
        if (showModal) {
            setPreference(staticTexts.email);
            setUserErrormessage(null);
        }
    }, [
        showModal
    ]);
    const handleTabClick = (tab)=>{
        setActiveTab(tab);
    };
    const onNameChange = (e)=>{
        const { id , value  } = e.target;
        const field = id.split("-");
        if (value === "" || (0,helper/* validateField */.OP$)("name", value)) {
            setContactData({
                ...contactData,
                [field[2]]: value
            });
        }
        setError({
            ...error,
            [field]: validateExist(field)
        });
    };
    const onInputChange = (e)=>{
        const { id , value  } = e.target;
        const field = id.split("-");
        setContactData({
            ...contactData,
            [field[2]]: value
        });
    };
    const radioKeyDown = (e)=>{
        const nextRadio = e.target.nextSibling;
        const previousRadio = e.target.previousSibling;
        if (e.key === "ArrowLeft" && previousRadio) {
            previousRadio.focus();
        } else if (e.key === "ArrowRight" && nextRadio) {
            nextRadio.focus();
        } else if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            e.target.click();
        }
    };
    const validateExist = (field)=>{
        switch(field){
            case "firstname":
            case "lastname":
                if (!contactData[field].trim() || !(0,helper/* validateField */.OP$)("name", contactData[field])) {
                    return field === "firstname" ? staticTexts.firstnameError : staticTexts.lastnameError;
                }
                break;
            case "email":
                if (!contactData[field]) return staticTexts.noEmailError;
                else if (!(0,helper/* validateField */.OP$)("email", contactData[field])) return staticTexts.validEmail;
                break;
            case "phone":
                if (!contactData.phone) return staticTexts.noPhoneError;
                else if (!(0,helper/* validatePhone */.a$Q)(contactData.phone)) return staticTexts.validPhone;
                break;
            default:
                return;
        }
    };
    const onBlurError = (field)=>{
        setError({
            ...error,
            [field]: validateExist(field)
        });
    };
    const getErrorList = ()=>{
        let errorList = {
            firstname: validateExist("firstname"),
            lastname: validateExist("lastname"),
            email: validateExist("email"),
            phone: validateExist("phone")
        };
        return errorList;
    };
    const onSubmit = ()=>{
        let errorDataList = [];
        const errorList = getErrorList();
        setError(errorList);
        if (errorList.firstname) {
            errorDataList.push("contact-user-firstname");
        } else if (errorList.lastname) {
            errorDataList.push("contact-user-lastname");
        } else if (errorList.email) {
            errorDataList.push("contact-user-email");
        } else if (errorList.phone) {
            errorDataList.push("contact-user-phone");
        }
        errorDataList.forEach((item, i)=>{
            if (i === 0) document.getElementById("".concat(item)).focus();
        });
        let body = {
            Interaction_Type__c: "Interaction",
            Preferred_Email__c: contactData.email,
            PreferredPhone: contactData.phone,
            BP_Number__c: "3558798",
            LastName__c: contactData.lastname,
            Preferred_Day_Time_of_Contact__c: contactData.Preferred_Day_Time_of_Contact__c,
            FirstName__c: contactData.firstname,
            Preferred_Mode_of_Contact__c: contactData.Preferred_Mode_of_Contact__c
        };
        (0,ReCaptcha/* validateRecaptcha */.L)().then((res)=>{
            if (res.success) {
                apim.post("crm/quote", body).then((res)=>{
                    if (res.data) {
                        if (errorDataList.length === 0) {
                            closeModal();
                            setShowSucessModal(true);
                            setContactData({
                                firstname: "",
                                lastname: "",
                                email: "",
                                phone: "",
                                Preferred_Mode_of_Contact__c: staticTexts.email,
                                Preferred_Day_Time_of_Contact__c: ""
                            });
                        }
                    }
                }).catch((error)=>{
                    console.error("Error in API call:", error);
                    setUserErrormessage(authorData.errorCodeForSf ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        dangerouslySetInnerHTML: {
                            __html: authorData.errorCodeForSf
                        }
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: staticTexts.SFerrormessage
                    }));
                });
            }
        });
    };
    let checkDisabled = (contactData)=>{
        if (contactData.firstname.trim() && contactData.lastname.trim() && contactData.email.trim() && contactData.phone) return false;
        return true;
    };
    let contactInfo = authorData.contactusdetails;
    const handleContactModeChange = (value)=>{
        setPreference(value);
        setTalkTime(value === staticTexts.email ? "" : staticTexts.anyTime);
        setContactData({
            ...contactData,
            Preferred_Mode_of_Contact__c: value,
            Preferred_Day_Time_of_Contact__c: value === staticTexts.email ? "" : staticTexts.anyTime
        });
    };
    const handleRadioClick = (value)=>{
        if (preference === staticTexts.phone) {
            setTalkTime(value);
            setContactData({
                ...contactData,
                Preferred_Day_Time_of_Contact__c: value
            });
        } else if (preference === staticTexts.email) {
            setContactData({
                ...contactData,
                Preferred_Day_Time_of_Contact__c: value
            });
        }
    };
    const sucesscloseModal = ()=>{
        setShowSucessModal(false);
    };
    const footerClickHandler = (e, type, link)=>{
        (0,helper/* getSiteWideModal */.Ure)(e, link);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                showModal: showModal,
                onModalClose: closeModal,
                className: "made-to-order",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "custom-order",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "custom-order-head",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "title",
                                    children: authorData.talktous ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        dangerouslySetInnerHTML: {
                                            __html: authorData.talktous
                                        }
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: staticTexts.talktous
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "desc",
                                    children: authorData.talktousatfreetime ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        dangerouslySetInnerHTML: {
                                            __html: authorData.talktousatfreetime
                                        }
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: staticTexts.talktousatfreetime
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "custom-order-body",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "custom-order-tab",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "order-tab-head",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    onClick: ()=>handleTabClick("contact"),
                                                    tabIndex: "0",
                                                    role: "button",
                                                    className: activeTab === "contact" ? "item active" : "item",
                                                    children: authorData.contactuslabel ? authorData.contactuslabel : staticTexts.contactuslabel
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    onClick: ()=>handleTabClick("connect"),
                                                    tabIndex: "0",
                                                    role: "button",
                                                    className: activeTab === "connect" ? "item active" : "item",
                                                    children: authorData.letuscontactyou ? authorData.letuscontactyou : staticTexts.letuscontactyou
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "order-tab-content",
                                        children: [
                                            activeTab === "contact" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "contact-info",
                                                children: contactInfo && contactInfo.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    children: contactInfo === null || contactInfo === void 0 ? void 0 : contactInfo.map((item, index)=>{
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "info",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                        children: item.title
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        children: item.description
                                                                    })
                                                                ]
                                                            })
                                                        }, index);
                                                    })
                                                })
                                            }),
                                            activeTab === "connect" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "connect-info contact-us-main",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "error-info-text",
                                                        children: staticTexts.requiredFields
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "letus-form",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "connect-row",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "connect-col",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                                                                    id: "contact-user-firstname",
                                                                                    type: "text",
                                                                                    value: contactData.firstname,
                                                                                    maxLength: 40,
                                                                                    placeholder: "".concat(staticTexts.firstname, "*"),
                                                                                    label: "".concat(staticTexts.firstname, "*"),
                                                                                    onChange: onNameChange,
                                                                                    showError: error.firstname,
                                                                                    errorMessage: error.firstname,
                                                                                    onBlur: ()=>onBlurError("firstname")
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "connect-col",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                                                                    id: "contact-user-lastname",
                                                                                    type: "text",
                                                                                    value: contactData.lastname,
                                                                                    maxLength: 40,
                                                                                    placeholder: "".concat(staticTexts.lastname, "*"),
                                                                                    label: "".concat(staticTexts.lastname, "*"),
                                                                                    onChange: onNameChange,
                                                                                    showError: error.lastname,
                                                                                    errorMessage: error.lastname,
                                                                                    onBlur: ()=>onBlurError("lastname")
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "connect-row connect-email",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                                                            id: "contact-user-email",
                                                                            type: "text",
                                                                            value: contactData.email,
                                                                            maxLength: 60,
                                                                            prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                src: email/* default */.Z,
                                                                                alt: "",
                                                                                "aria-hidden": "true"
                                                                            }),
                                                                            placeholder: "".concat(staticTexts.emailAddress, "*"),
                                                                            label: "".concat(staticTexts.emailAddress, "*"),
                                                                            onChange: onInputChange,
                                                                            showError: error.email,
                                                                            errorMessage: error.email,
                                                                            onBlur: ()=>onBlurError("email")
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "connect-row connect-phone",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                                                            id: "contact-user-phone",
                                                                            type: "text",
                                                                            value: contactData.phone,
                                                                            maxLength: 60,
                                                                            prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                src: phone_icon/* default */.Z,
                                                                                alt: "",
                                                                                "aria-hidden": "true"
                                                                            }),
                                                                            placeholder: "".concat(staticTexts.phone, "*"),
                                                                            label: "".concat(staticTexts.phone, "*"),
                                                                            onChange: (e)=>setContactData({
                                                                                    ...contactData,
                                                                                    phone: (0,helperV2/* convertToPhoneNumber */["in"])(e.target.value)
                                                                                }),
                                                                            showError: error.phone,
                                                                            errorMessage: error.phone,
                                                                            onBlur: ()=>onBlurError("phone")
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "preference",
                                                                role: "radiogroup",
                                                                "aria-labelledby": "preferencetitle-radio",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                        className: "title",
                                                                        id: "preferencetitle-radio",
                                                                        children: staticTexts.preferenceTitle
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "pref-option",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "option-col",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton, {
                                                                                    id: "email-preference",
                                                                                    name: "contact-user-preference",
                                                                                    value: staticTexts.email,
                                                                                    checked: preference == staticTexts.email,
                                                                                    onClick: ()=>handleContactModeChange(staticTexts.email),
                                                                                    onKeyDown: radioKeyDown
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "option-col",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton, {
                                                                                    id: "phone-preference",
                                                                                    name: "contact-user-preference",
                                                                                    value: staticTexts.phone,
                                                                                    checked: preference === staticTexts.phone,
                                                                                    onClick: ()=>handleContactModeChange(staticTexts.phone),
                                                                                    onKeydown: radioKeyDown,
                                                                                    tabIndex: 0
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            preference && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                children: preference === staticTexts.phone && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "preference phone-talk",
                                                                        role: "radiogroup",
                                                                        "aria-labelledby": "phonetalk-radio",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                                className: "title",
                                                                                id: "phonetalk-radio",
                                                                                children: staticTexts.goodtimetalk
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "pref-option",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: "option-col",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton, {
                                                                                            id: "anyTime",
                                                                                            name: "timeOption",
                                                                                            value: staticTexts.anyTime,
                                                                                            checked: talktime === staticTexts.anyTime,
                                                                                            onClick: ()=>handleRadioClick(staticTexts.anyTime),
                                                                                            onKeydown: radioKeyDown
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: "option-col",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton, {
                                                                                            id: "weekdays",
                                                                                            name: "timeOption",
                                                                                            value: staticTexts.weekdays,
                                                                                            checked: talktime === staticTexts.weekdays,
                                                                                            onClick: ()=>handleRadioClick(staticTexts.weekdays),
                                                                                            onKeydown: radioKeyDown,
                                                                                            tabIndex: 0
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: "option-col",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton, {
                                                                                            id: "weekends",
                                                                                            name: "timeOption",
                                                                                            value: staticTexts.weekends,
                                                                                            checked: talktime === staticTexts.weekdaysMidDays,
                                                                                            onClick: ()=>handleRadioClick(staticTexts.weekdaysMidDays),
                                                                                            onKeydown: radioKeyDown,
                                                                                            tabIndex: 0
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                                                role: "button",
                                                                label: authorData.contactme ? authorData.contactme : staticTexts.contactme,
                                                                size: "large",
                                                                type: "primary",
                                                                flexible: true,
                                                                className: "add-to-cart__main-button contact-me-btn",
                                                                id: "submit-contact-form-button",
                                                                disabled: checkDisabled(contactData),
                                                                onClick: ()=>onSubmit()
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "recaptcha-info",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReCaptcha/* default */.Z, {})
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "contact-us__policies",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                href: "#",
                                                                                rel: "noreferrer",
                                                                                onClick: (e)=>{
                                                                                    return footerClickHandler(e, "privacy policy", legalPageLinks === null || legalPageLinks === void 0 ? void 0 : legalPageLinks.privacyPolicy);
                                                                                },
                                                                                children: staticTexts.privacyPolicy
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                href: "#",
                                                                                rel: "noreferrer",
                                                                                onClick: (e)=>{
                                                                                    return footerClickHandler(e, "subject access request", legalPageLinks === null || legalPageLinks === void 0 ? void 0 : legalPageLinks.subjectAccessRequest);
                                                                                },
                                                                                children: staticTexts.subjectAccessRequest
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                href: "#",
                                                                                rel: "noreferrer",
                                                                                onClick: (e)=>{
                                                                                    return footerClickHandler(e, "terms of service", legalPageLinks === null || legalPageLinks === void 0 ? void 0 : legalPageLinks.termsOfService);
                                                                                },
                                                                                children: staticTexts.termsOfService
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    userErrormessage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "user-error",
                                                        children: [
                                                            " ",
                                                            userErrormessage
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "custom-order-product-info",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "order-product-img",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: props.productData.image,
                                        alt: props.productData.name
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "order-product-info",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "order-product-cnt",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    className: "title",
                                                    children: props.productSummaryDetails.productName_s
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "desc",
                                                    children: [
                                                        props.ProductDescriptionDetail_s,
                                                        ", ",
                                                        props.productData.color
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "order-product-price-info",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "price-lable",
                                                    children: props.staticTexts.startingAt
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "price",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberFormat, {
                                                            value: props.price,
                                                            displayType: "text",
                                                            thousandSeparator: true,
                                                            prefix: props.currencySign,
                                                            decimalScale: 2,
                                                            fixedDecimalScale: true
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: "range",
                                                            children: [
                                                                " ",
                                                                props.priceTag
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal, {
                showModal: showSucessModal,
                onModalClose: sucesscloseModal,
                className: "made-to-order email-modal",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "custom-order",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "custom-order-head",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "title",
                                    children: staticTexts.sucessmsgTitle
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "desc",
                                    children: staticTexts.contactShortly
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "custom-order-body",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "email-btn-block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                role: "button",
                                label: staticTexts.continueShopping,
                                size: "large",
                                type: "primary",
                                flexible: true,
                                className: "add-to-cart__main-button contact-email-btn",
                                id: "email-contact-form-button",
                                to: homePagePath
                            })
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/cart/QuantitySelector.jsx
var QuantitySelector = __webpack_require__(85721);
// EXTERNAL MODULE: ./store/features/favoritesSlice.js + 1 modules
var favoritesSlice = __webpack_require__(5702);
// EXTERNAL MODULE: ./components/SocialShare/v1/SocialShare.jsx + 1 modules
var SocialShare = __webpack_require__(24636);
// EXTERNAL MODULE: ./src/components/core/Input/Input.jsx
var Input_Input = __webpack_require__(27222);
// EXTERNAL MODULE: ./store/features/compareSlice.js
var compareSlice = __webpack_require__(39915);
;// CONCATENATED MODULE: ./components/ProductDetail/v1/ProductDetailView/AddToCart/index.jsx


























const AddToCart = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    const [loading, setLoading] = (0,react.useState)(false);
    const [quantity, setQuantity] = (0,react.useState)(1);
    const [isChecked, setIsChecked] = (0,react.useState)(false);
    const [errorMessage, setErrorMessage] = (0,react.useState)("");
    const [email, setEmail] = (0,react.useState)("");
    const [emailError, setEmailError] = (0,react.useState)({
        show: false,
        message: ""
    });
    const [showWelcome, setShowWelcome] = (0,react.useState)(false);
    var _productCategory;
    const productCategory = (_productCategory = props.productCategory) !== null && _productCategory !== void 0 ? _productCategory : "";
    const dispatch = (0,es/* useDispatch */.I0)();
    const [productStock, setProductStock] = (0,react.useState)(0);
    const enableFav = props.isDiscontinued || props.isColorDiscontinued ? true : false;
    const [enableNotify, setEnableNotify] = (0,react.useState)(false);
    const [showBuyBoxArea, setShowBuyBoxArea] = (0,react.useState)(true);
    const [stockAlert, setStockAlert] = (0,react.useState)({
        show: false,
        mssg: ""
    });
    const [showSocialLink, setShowSocialLink] = (0,react.useState)(false);
    var ref7;
    const brandName = (ref7 = (ref = props.general) === null || ref === void 0 ? void 0 : (ref1 = ref.siteName) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) !== null && ref7 !== void 0 ? ref7 : "";
    var ref8;
    let compareJsonPath = (ref8 = props === null || props === void 0 ? void 0 : (ref2 = props.general) === null || ref2 === void 0 ? void 0 : ref2.compareJsonPath) !== null && ref8 !== void 0 ? ref8 : "";
    const [categoryData, setCategoryData] = (0,react.useState)([]);
    const [showQuantitySelector, enableQuantity] = (0,react.useState)(false);
    const [showModal, setShowModal] = (0,react.useState)(false);
    const [activeTab, setActiveTab] = (0,react.useState)("contact");
    const madeToOrderStatus = "Made to Order";
    const router = (0,next_router.useRouter)();
    const shareImg = (0,react.useRef)(null);
    const { toaster ={}  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { category , comparedProducts  } = (0,es/* useSelector */.v9)(compareSlice/* compareState */.NP);
    const { disableEcommerce , replaceAddToCart , replaceAddToCartCtaLabel , replaceAddToCartCtaLink , linkNewTab  } = props.authorData;
    (0,react.useEffect)(()=>{
        setProductStock(props.productOnStock);
    }, [
        props.productOnStock
    ]);
    (0,react.useEffect)(()=>{
        var ref;
        (0,api/* aemAxiosInstance */.Gb)({
            url: constants.GLOBAL_CONFIGURATION_ENDPOINT,
            params: {
                path: props === null || props === void 0 ? void 0 : (ref = props.general) === null || ref === void 0 ? void 0 : ref.compareJsonPath
            }
        }).then((res)=>{
            var ref;
            if (res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.data) {
                var ref1;
                setCategoryData(res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.data);
            } else {
                setCategoryData([]);
            }
        }).catch((err)=>{
            console.error("Failed to get compare attributes JSON file", err);
        });
    }, [
        props.general
    ]);
    (0,react.useEffect)(()=>{
        const tempType = [
            "grout",
            "lighting",
            "samples",
            "accessories"
        ];
        enableQuantity(tempType.some((el)=>el === props.templateType));
    }, [
        props.templateType
    ]);
    (0,react.useEffect)(()=>{
        if (comparedProducts.find((prod)=>prod.compareSku === props.sku)) setIsChecked(true);
        else setIsChecked(false);
    }, [
        comparedProducts,
        props.sku
    ]);
    (0,react.useEffect)(()=>{
        if (showWelcome) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
            document.body.classList.remove("modal-open");
        }
    }, [
        showWelcome
    ]);
    (0,react.useEffect)(()=>{
        if (props.productIsRetail) {
            setShowBuyBoxArea(false);
        } else if (!props.price) {
            setShowBuyBoxArea(false);
        } else {
            setShowBuyBoxArea(true);
        }
    }, [
        props.productIsRetail,
        props.price
    ]);
    const handleChange = (qty)=>{
        var ref;
        setStockAlert({
            show: false,
            mssg: ""
        });
        if (props.backOrder === "Yes" || props.isParts) {
            setQuantity(qty);
            return;
        }
        setLoading(true);
        var ref1;
        const cartItem = (ref1 = (ref = props.cart.lineItems) === null || ref === void 0 ? void 0 : ref.find((item)=>item.variant.sku === props.sku)) !== null && ref1 !== void 0 ? ref1 : {};
        var _quantity;
        const cartQuantity = (_quantity = cartItem.quantity) !== null && _quantity !== void 0 ? _quantity : 0;
        if (qty && qty > 0) {
            setQuantity(qty);
            getStock(props.sku).then((stock)=>{
                if (cartQuantity > 0 && stock <= cartQuantity) {
                    setStockAlert({
                        show: true,
                        mssg: props.t("kf.pdp.label.noItemsToShip")
                    });
                } else if (stock >= qty + cartQuantity) {
                    props.onQtyChange(qty);
                } else {
                    setProductStock(stock);
                    if (stock > 0) {
                        setQuantity(stock - cartQuantity);
                        props.onQtyChange(stock - cartQuantity);
                        setStockAlert({
                            show: true,
                            mssg: props.t("kf.pdp.label.availableToShip", {
                                qty: stock
                            })
                        });
                    }
                }
                setLoading(false);
            }).catch(()=>setLoading(false));
        }
    };
    const isCategoryMatchWithCompareJSON = categoryData === null || categoryData === void 0 ? void 0 : categoryData.some((item)=>{
        return (item === null || item === void 0 ? void 0 : item.category) === productCategory;
    });
    const handleCompare = (e)=>{
        setIsChecked(!isChecked);
        if (e.target.checked) {
            if (comparedProducts.length < 4) {
                analytics_addDataLayer({
                    title: props.staticTexts.addToCompare.toLowerCase(),
                    productInfo: props === null || props === void 0 ? void 0 : props.analyticsProductInfo
                });
                let variantFlag = false;
                const allVariantSkus = comparedProducts === null || comparedProducts === void 0 ? void 0 : comparedProducts.map((a)=>{
                    const variantSkus = a["variantList.sku_ss"] || [];
                    return [
                        ...variantSkus,
                        a.masterSKU_s || a.sku_s
                    ].filter(Boolean);
                }).flat();
                if (allVariantSkus.includes(props.sku)) {
                    variantFlag = true;
                }
                if (!isCategoryMatchWithCompareJSON) {
                    setErrorMessage(props.staticTexts.sameVariants);
                    setTimeout(()=>{
                        setErrorMessage("");
                    }, 2000);
                    setIsChecked(false);
                    (0,helper/* removeFromCompareProduct */.Zjk)(props.sku);
                } else if (category !== "" && category !== productCategory) {
                    setErrorMessage(props.staticTexts.sameCategory);
                    setTimeout(()=>{
                        setErrorMessage("");
                    }, 2000);
                    setIsChecked(false);
                    props.onRemove(props.sku);
                } else if (variantFlag) {
                    setErrorMessage(props.staticTexts.sameVariants);
                    setTimeout(()=>{
                        setErrorMessage("");
                    }, 2000);
                    setIsChecked(false);
                    props.onRemove(props.sku);
                } else {
                    props.onAdd(props.sku);
                }
            } else {
                setErrorMessage(props.staticTexts.maxProduct);
                setTimeout(()=>{
                    setErrorMessage("");
                }, 2000);
                setIsChecked(false);
                props.onRemove(props.sku);
            }
        } else {
            analytics_addDataLayer({
                title: "remove compare",
                productInfo: props === null || props === void 0 ? void 0 : props.analyticsProductInfo
            });
            props.onRemove(props.sku);
        }
    };
    const handleAtcDatalayer = (params)=>{
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        const headerAtcIsClicked = (localStorage === null || localStorage === void 0 ? void 0 : (ref = localStorage.getItem) === null || ref === void 0 ? void 0 : ref.call(localStorage, "headerAtcIsClicked")) || false;
        var ref8, ref9, ref10, ref11, ref12, ref13, ref14;
        analytics_addDataLayer({
            title: (params === null || params === void 0 ? void 0 : params.title) || props.staticTexts.addToCart.toLowerCase(),
            productInfo: props === null || props === void 0 ? void 0 : props.analyticsProductInfo,
            isSticky: headerAtcIsClicked,
            cartData: params === null || params === void 0 ? void 0 : params.data,
            url: params === null || params === void 0 ? void 0 : params.link,
            calculated_Values: JSON.stringify({
                squareFeetNeeded: Number((ref8 = (ref1 = document.getElementById("txt_prod_price")) === null || ref1 === void 0 ? void 0 : ref1.getAttribute("value")) !== null && ref8 !== void 0 ? ref8 : "") || "n/a",
                overage: Number((ref9 = (ref2 = document.querySelector("#trim-calculator__overage-value-selected")) === null || ref2 === void 0 ? void 0 : ref2.innerText) !== null && ref9 !== void 0 ? ref9 : "") || Number((ref10 = (ref3 = document.getElementById("trim-calculator__overage-input-box")) === null || ref3 === void 0 ? void 0 : ref3.getAttribute("value")) !== null && ref10 !== void 0 ? ref10 : "") || "n/a",
                totalSquareFeet: Number((ref11 = (ref4 = document.getElementById("trim-calculator__totalSquareFeet")) === null || ref4 === void 0 ? void 0 : ref4.getAttribute("value")) !== null && ref11 !== void 0 ? ref11 : "") || "n/a",
                totalCoverage: Number((ref12 = (ref5 = document.getElementById("trim-calculator__totalCoverage")) === null || ref5 === void 0 ? void 0 : ref5.getAttribute("value")) !== null && ref12 !== void 0 ? ref12 : "") || "n/a",
                totalBoxes: Number((ref13 = (ref6 = document.getElementById("trim-calculator__totalBoxes")) === null || ref6 === void 0 ? void 0 : ref6.getAttribute("value")) !== null && ref13 !== void 0 ? ref13 : "") || "n/a",
                totalPrice: Number((ref14 = (ref7 = document.getElementById("trim-calculator__finalTotal")) === null || ref7 === void 0 ? void 0 : ref7.getAttribute("price")) !== null && ref14 !== void 0 ? ref14 : "") || "n/a"
            })
        });
        headerAtcIsClicked && localStorage.removeItem("headerAtcIsClicked");
    };
    const handleAddToCart = ()=>{
        var ref;
        let addToCartAttr = document.querySelector(".add-to-cart__main-button") && document.querySelector(".add-to-cart__main-button") !== null ? document.querySelector(".add-to-cart__main-button").getAttribute("templatetype") : "";
        var ref1;
        const cartItem = (ref1 = (ref = props.cart.lineItems) === null || ref === void 0 ? void 0 : ref.find((item)=>item.variant.sku === props.sku)) !== null && ref1 !== void 0 ? ref1 : {};
        var _quantity;
        const cartQuantity = (_quantity = cartItem.quantity) !== null && _quantity !== void 0 ? _quantity : 0;
        let additionalInfo = {};
        let customQuantity = 0;
        let totalOverage = "";
        let totalArea = 0;
        let totalNeeded = 0;
        let customQuantityTmp = "";
        let soldByBox = "";
        let soldByUom = "";
        let totalSFNeeded = "";
        if (addToCartAttr === "trim" || addToCartAttr === "tile") {
            var ref2, ref3;
            totalOverage = Number(document.querySelector("#trim-calculator__overage-value-selected") ? (ref2 = document.querySelector("#trim-calculator__overage-value-selected")) === null || ref2 === void 0 ? void 0 : ref2.innerText : "");
            var ref4;
            totalOverage = (ref4 = (ref3 = document.querySelector("#trim-calculator__overage-input-box")) === null || ref3 === void 0 ? void 0 : ref3.value) !== null && ref4 !== void 0 ? ref4 : totalOverage;
            if (document.querySelector(".trim-calculator_main-block")) {
                var ref5;
                customQuantityTmp = Number(document.querySelector(".trim-calculator_main-block").getAttribute("totalPeices"));
                soldByUom = Number(document.querySelector(".trim-calculator_main-block").getAttribute("soldByUom"));
                soldByBox = Number(document.querySelector(".trim-calculator_main-block").getAttribute("soldByBox"));
                totalArea = Number(document.querySelector(".trim-calculator_main-block").getAttribute("totalOverage"));
                totalNeeded = Number(document.querySelector(".trim-calculator__square-ft-value") ? document.querySelector(".trim-calculator__square-ft-value").value : "");
                totalSFNeeded = Number((ref5 = document.querySelector("#trim-calculator__totalSquareFeet")) === null || ref5 === void 0 ? void 0 : ref5.getAttribute("value"));
            }
            if (customQuantityTmp && customQuantityTmp > 0) {
                customQuantity = customQuantityTmp;
            }
            if (totalArea !== "" && totalArea > 0 || totalOverage !== "") {
                additionalInfo = {
                    roomInfo: [
                        '{"productType":"' + addToCartAttr + '","totalSFNeeded":"' + totalSFNeeded + '","totalNeeded":"' + totalNeeded + '","totalUserNeeded":"' + totalNeeded + '","totalSFUserNeeded":"' + totalSFNeeded + '","totalArea":"' + totalArea.toFixed(2) + '","soldByBox":"' + soldByBox + '","soldByUom":"' + soldByUom + '"}'
                    ],
                    customQuantity: soldByBox ? Number(customQuantity * soldByBox) : customQuantity,
                    overage: totalOverage.toString()
                };
            }
        }
        setStockAlert({
            show: false,
            mssg: ""
        });
        if (props.backOrder === "Yes" || props.isParts) {
            addToCartAttr === "trim" || addToCartAttr === "tile" ? props.onAddToCart([
                {
                    sku: props.sku,
                    quantity: quantity,
                    additionalInfo: additionalInfo,
                    isBundle: props.isComboSku,
                    brand: brandName
                }
            ], handleAtcDatalayer) : (cartItem === null || cartItem === void 0 ? void 0 : cartItem.id) ? props.updateRecalculateRoomInfo(cartItem === null || cartItem === void 0 ? void 0 : cartItem.id, {
                quantity: quantity + cartQuantity
            }, quantity, handleAtcDatalayer) : props.onAddToCart([
                {
                    sku: props.sku,
                    quantity: quantity,
                    isBundle: props.isComboSku,
                    brand: brandName,
                    additionalInfo: {
                        customQuantity: quantity
                    }
                }
            ], handleAtcDatalayer);
            return;
        }
        getStock(props.sku).then((stock)=>{
            setProductStock(stock);
            let totalQuantity = 0;
            totalQuantity = addToCartAttr === "trim" || addToCartAttr === "tile" ? cartQuantity + customQuantity : cartQuantity + quantity;
            if (totalQuantity > stock) {
                if (stock > cartQuantity) {
                    const totalPiecesNo = soldByBox ? Number(stock * soldByBox) : stock;
                    const totalCoverage = Number(soldByUom) > 0 && totalPiecesNo > 0 ? totalPiecesNo / Number(soldByUom) : 0;
                    const overagePercent = totalCoverage > 0 && totalOverage > 0 ? Math.ceil(totalCoverage) * totalOverage / 100 : 0;
                    const neededArea = Math.ceil(totalCoverage) - overagePercent;
                    if (cartItem === null || cartItem === void 0 ? void 0 : cartItem.id) {
                        if (addToCartAttr === "trim" || addToCartAttr === "tile") {
                            var ref, ref1;
                            //For tile and trim if already added to cart and added amount exceeds stock
                            const roomInfo = (cartItem === null || cartItem === void 0 ? void 0 : (ref = cartItem.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.roomInfo[0]) || "";
                            const parsedRoomInfo = roomInfo ? JSON.parse(roomInfo) : "";
                            const totalSFNeededFinal = (parsedRoomInfo === null || parsedRoomInfo === void 0 ? void 0 : parsedRoomInfo.totalSFNeeded) ? Number(parsedRoomInfo === null || parsedRoomInfo === void 0 ? void 0 : parsedRoomInfo.totalSFNeeded) + Number(totalSFNeeded) : Number(totalSFNeeded);
                            const updatedSf = totalSFNeededFinal * 100 / (100 + totalOverage);
                            props.updateRecalculateRoomInfo(cartItem === null || cartItem === void 0 ? void 0 : cartItem.id, {
                                productType: addToCartAttr,
                                totalSFNeeded: totalSFNeededFinal,
                                totalNeeded: Math.floor(updatedSf * 100) / 100,
                                totalArea: totalCoverage.toFixed(2),
                                soldByBox: Number(soldByBox),
                                soldByUom: Number(soldByUom),
                                customQuantity: stock,
                                overage: totalOverage.toString(),
                                roomInfo: true
                            }, stock, handleAtcDatalayer);
                        } else {
                            //For non tile and trim if already added to cart and added amount exceeds stock
                            props.updateRecalculateRoomInfo(cartItem === null || cartItem === void 0 ? void 0 : cartItem.id, {
                                quantity: stock
                            }, stock, handleAtcDatalayer);
                        }
                    } else {
                        if (addToCartAttr === "trim" || addToCartAttr === "tile") {
                            //For tile and trim if not already added to cart and added amount exceeds stock
                            props.onAddToCart([
                                {
                                    sku: props.sku,
                                    quantity: stock - cartQuantity,
                                    additionalInfo: {
                                        roomInfo: [
                                            '{"productType":"' + addToCartAttr + '","totalSFNeeded":"' + totalSFNeeded + '","totalNeeded":"' + totalNeeded + '","totalUserNeeded":"' + totalNeeded + '","totalSFUserNeeded":"' + totalSFNeeded + '","totalArea":"' + totalCoverage.toFixed(2) + '","soldByBox":"' + soldByBox + '","soldByUom":"' + soldByUom + '"}'
                                        ],
                                        customQuantity: stock,
                                        overage: totalOverage.toString()
                                    },
                                    isBundle: props.isComboSku,
                                    brand: brandName
                                }
                            ], handleAtcDatalayer);
                        } else {
                            //For non tile and trim if not already added to cart and added amount exceeds stock
                            props.onAddToCart([
                                {
                                    sku: props.sku,
                                    quantity: stock - cartQuantity,
                                    isBundle: props.isComboSku,
                                    brand: brandName,
                                    additionalInfo: {
                                        customQuantity: stock
                                    }
                                }
                            ], handleAtcDatalayer);
                        }
                    }
                    setStockAlert({
                        show: true,
                        mssg: props.t("kf.pdp.label.availableToShip", {
                            qty: stock
                        })
                    });
                } else {
                    setStockAlert({
                        show: true,
                        mssg: props.t("kf.pdp.label.noItemsToShip")
                    });
                }
            } else {
                if (cartItem === null || cartItem === void 0 ? void 0 : cartItem.id) {
                    if (addToCartAttr === "trim" || addToCartAttr === "tile") {
                        var ref2, ref3;
                        const totalPiecesNo1 = soldByBox ? Number(totalQuantity * soldByBox) : totalQuantity;
                        const totalCoverage1 = Number(soldByUom) > 0 && totalPiecesNo1 > 0 ? totalPiecesNo1 / Number(soldByUom) : 0;
                        const overagePercent1 = totalCoverage1 > 0 && totalOverage > 0 ? Math.ceil(totalCoverage1) * totalOverage / 100 : 0;
                        const neededArea1 = Math.ceil(totalCoverage1) - overagePercent1;
                        //For tile and trim if already added to cart and amount in stock
                        const roomInfo1 = (cartItem === null || cartItem === void 0 ? void 0 : (ref2 = cartItem.custom) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.fields) === null || ref3 === void 0 ? void 0 : ref3.roomInfo[0]) || "";
                        const parsedRoomInfo1 = roomInfo1 ? JSON.parse(roomInfo1) : "";
                        const totalSFNeededFinal1 = (parsedRoomInfo1 === null || parsedRoomInfo1 === void 0 ? void 0 : parsedRoomInfo1.totalSFNeeded) ? Number(parsedRoomInfo1 === null || parsedRoomInfo1 === void 0 ? void 0 : parsedRoomInfo1.totalSFNeeded) + Number(totalSFNeeded) : Number(totalSFNeeded);
                        const updatedSf1 = totalSFNeededFinal1 * 100 / (100 + totalOverage);
                        props.updateRecalculateRoomInfo(cartItem === null || cartItem === void 0 ? void 0 : cartItem.id, {
                            productType: addToCartAttr,
                            totalSFNeeded: totalSFNeededFinal1,
                            totalNeeded: Math.floor(updatedSf1 * 100) / 100,
                            totalArea: totalCoverage1.toFixed(2),
                            soldByBox: Number(soldByBox),
                            soldByUom: Number(soldByUom),
                            customQuantity: totalQuantity,
                            overage: totalOverage.toString(),
                            roomInfo: true
                        }, customQuantity, handleAtcDatalayer);
                    } else {
                        //For non tile and trim if already added to cart and added amount in stock
                        props.updateRecalculateRoomInfo(cartItem === null || cartItem === void 0 ? void 0 : cartItem.id, {
                            quantity: quantity + cartQuantity
                        }, quantity, handleAtcDatalayer);
                    }
                } else {
                    if (addToCartAttr === "trim" || addToCartAttr === "tile") {
                        //For tile and trim if not already added to cart and added amount in stock
                        props.onAddToCart([
                            {
                                sku: props.sku,
                                quantity: customQuantity,
                                isBundle: props.isComboSku,
                                additionalInfo: additionalInfo,
                                brand: brandName
                            }
                        ], handleAtcDatalayer);
                    } else {
                        //For non tile and trim if not already added to cart and added amount in stock
                        props.onAddToCart([
                            {
                                sku: props.sku,
                                quantity: quantity,
                                isBundle: props.isComboSku,
                                brand: brandName,
                                additionalInfo: {
                                    customQuantity: quantity
                                }
                            }
                        ], handleAtcDatalayer);
                    }
                }
            }
        });
    };
    const handleNotification = ()=>{
        analytics_addDataLayer({
            title: props.staticTexts.notifyMailCTA.toLowerCase(),
            productInfo: props === null || props === void 0 ? void 0 : props.analyticsProductInfo
        });
        if (email) {
            let body = {
                customer: {
                    id: "",
                    firstName: "",
                    lastName: "",
                    email: email
                },
                sku: props.sku,
                pdpURL: window.location.href
            };
            apim.post("catalog/product/oos/notify", body).then((res)=>{
                if (res) {
                    setShowWelcome(true);
                    setEmail("");
                }
            }).catch(()=>{
                setEmailError({
                    show: true,
                    message: props.staticTexts.outOfStockError
                });
            });
        }
    };
    const favoriteDatalayer = (status, msg, isAdd)=>{
        analytics_addDataLayer({
            title: isAdd ? props.staticTexts.favTxt.toLowerCase() : "favorite remove",
            productInfo: props === null || props === void 0 ? void 0 : props.analyticsProductInfo,
            eventMsg: msg,
            eventStatus: status
        });
    };
    const handleFavorite = (e)=>{
        e.preventDefault();
        if (props === null || props === void 0 ? void 0 : props.isFavorite) {
            var ref, ref1;
            props === null || props === void 0 ? void 0 : (ref = props.favItem) === null || ref === void 0 ? void 0 : (ref1 = ref.lineItems) === null || ref1 === void 0 ? void 0 : ref1.map((fav)=>{
                var ref;
                if ((fav === null || fav === void 0 ? void 0 : (ref = fav.variant) === null || ref === void 0 ? void 0 : ref.sku) === (props === null || props === void 0 ? void 0 : props.sku)) {
                    (0,helper/* isAuthenticated */.$8e)(()=>{
                        return dispatch((0,favoritesSlice/* removeItems */.Er)({
                            ids: [
                                fav === null || fav === void 0 ? void 0 : fav.id
                            ],
                            isDataLayerNeeded: false
                        })).unwrap().then(()=>{
                            var ref, ref1;
                            favoriteDatalayer("success", props === null || props === void 0 ? void 0 : (ref = props.staticTexts) === null || ref === void 0 ? void 0 : ref.removeItem, false);
                            dispatch((0,genericSlice/* showToast */.CF)({
                                message: (0,helper/* getShortenedUrlwithGeneral */.vu1)((toaster === null || toaster === void 0 ? void 0 : (ref1 = toaster.content) === null || ref1 === void 0 ? void 0 : ref1.unfavoriteSuccessMessage) || constants.REMOVE_FROM_FAVORITES_MSG, props === null || props === void 0 ? void 0 : props.general) || (texts === null || texts === void 0 ? void 0 : texts.removeItem),
                                isVisible: true
                            }));
                        }).catch((err)=>{
                            var ref, ref1;
                            dispatch((0,genericSlice/* showToast */.CF)({
                                message: props === null || props === void 0 ? void 0 : (ref = props.staticTexts) === null || ref === void 0 ? void 0 : ref.removeItemError,
                                isVisible: true
                            }));
                            favoriteDatalayer("failure", props === null || props === void 0 ? void 0 : (ref1 = props.staticTexts) === null || ref1 === void 0 ? void 0 : ref1.removeItemError, false);
                        });
                    });
                }
            });
        } else {
            (0,helper/* isAuthenticated */.$8e)(()=>{
                return dispatch((0,favoritesSlice/* addProduct */.gK)(props === null || props === void 0 ? void 0 : props.sku)).unwrap().then(()=>{
                    var ref, ref1;
                    dispatch((0,genericSlice/* showToast */.CF)({
                        message: (0,helper/* getShortenedUrlwithGeneral */.vu1)((toaster === null || toaster === void 0 ? void 0 : (ref = toaster.content) === null || ref === void 0 ? void 0 : ref.successMessage) || constants.ADD_TO_FAVORITES_MSG, props === null || props === void 0 ? void 0 : props.general) || (props === null || props === void 0 ? void 0 : (ref1 = props.staticTexts) === null || ref1 === void 0 ? void 0 : ref1.favSuccessMsg),
                        isVisible: true
                    }));
                }).catch((err)=>{
                    var ref, ref1;
                    dispatch((0,genericSlice/* showToast */.CF)({
                        message: props === null || props === void 0 ? void 0 : (ref = props.staticTexts) === null || ref === void 0 ? void 0 : ref.favErrorMsg,
                        isVisible: true
                    }));
                    favoriteDatalayer("failure", props === null || props === void 0 ? void 0 : (ref1 = props.staticTexts) === null || ref1 === void 0 ? void 0 : ref1.favErrorMsg, true);
                });
            });
        }
        document.body.classList.remove("modal-open");
        window.keyFocusCallBack = e.target.id;
    };
    const handleEmailChange = (val)=>{
        let inputValue = val.trim();
        setEmailError({
            show: false,
            message: ""
        });
        setEmail(inputValue);
        if (!/\S+@\S+\.\S+/.test(inputValue)) setEnableNotify(false);
        else setEnableNotify(true);
    };
    const printPDP = ()=>{
        analytics_addDataLayer({
            title: props.staticTexts.print.toLowerCase(),
            productInfo: props === null || props === void 0 ? void 0 : props.analyticsProductInfo
        });
        let printNoteLen = document.getElementsByClassName("product-details__print-note").length;
        if (printNoteLen === 0) {
            const printNote = "<div class='product-details__print-note'><div class='container'><div class='row'><div class='col-12'><h6>".concat(props.staticTexts.priceFootnoteTitle, "</h6><p>").concat(props.staticTexts.priceFootnote, "</p><h6>").concat(props.staticTexts.colorFootnoteTitle, "</h6> <p>").concat(props.staticTexts.colorFootnote, "</p></div></div></div></div>");
            let printNoteDiv = document.createElement("div");
            printNoteDiv.innerHTML = printNote;
            document.body.appendChild(printNoteDiv);
        }
        window.print();
    };
    const productAnalyticsData = props.productData || {};
    const handleMadetoOrder = ()=>{
        setShowModal(true);
        setActiveTab("contact");
    };
    const closeModal = ()=>{
        setShowModal(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "add-to-cart col-12",
        children: [
            !disableEcommerce && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: !props.price || props.price === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row pdp-annsacks-not-have-price",
                    children: props.customLabel && props.customLabel.zeroPrice ? props.customLabel.zeroPrice : props.staticTexts.priceNotDefinedTxt
                }) : showBuyBoxArea ? props.isDiscontinued ? props.isColorDiscontinued ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "product-details__available-color-section"
                }) : null : !(productStock > 0) ? props.specialOrder === "Yes" || props.backOrder === "Yes" && props.templateType !== "samples" || props.isParts ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        stockAlert.show && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "product-details__stock-alert",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: tooltip_red
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: stockAlert.mssg
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row quantity-selector-block",
                            children: [
                                showQuantitySelector && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-3 col-lg-2 col-md-3 quantity-selector-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantitySelector/* default */.Z, {
                                        value: quantity,
                                        onChange: handleChange,
                                        loading: loading
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: showQuantitySelector ? "col-9 col-lg-10 col-md-9 add-to-cart-container" : "col-12 add-to-cart-container add-to-cart-button-main-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        role: "button",
                                        className: "".concat(props.templateType === "tile" || props.templateType === "trim" ? "add-to-cart__main-button disabled" : "add-to-cart__main-button"),
                                        label: props.staticTexts.addToCart,
                                        onClick: debounce_default()(handleAddToCart, 500),
                                        size: "large",
                                        type: "primary",
                                        flexible: true,
                                        disabled: loading || !quantity || parseInt(quantity) < 1 || !props.price,
                                        tabIndex: !quantity ? -1 : 0,
                                        templateType: props.templateType
                                    })
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "out-of-stock-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "out-of-stock",
                            children: props.staticTexts.outOfStockMsg
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "out-of-stock-description",
                            children: props.staticTexts.notifyEmailTxt
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "email-address-field",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_Input/* default */.Z, {
                                id: "email",
                                className: "email_input ",
                                type: "text",
                                maxLength: 60,
                                value: email,
                                label: props.staticTexts.emailAddress,
                                onChange: (e)=>handleEmailChange(e.target.value),
                                showError: emailError.show,
                                errorMessage: emailError.message
                            })
                        }),
                        showWelcome && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "out-of-stock-success-popup",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                                showModal: showWelcome,
                                onModalClose: ()=>setShowWelcome(false),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessPopup, {
                                    staticTexts: props.staticTexts,
                                    closePopup: ()=>setShowWelcome(false)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "notify-btn",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                label: props.staticTexts.notifyMailCTA,
                                onClick: handleNotification,
                                size: "large",
                                type: "primary",
                                flexible: true,
                                disabled: !enableNotify
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        props.onChangeStockAlert.show ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "product-details__stock-alert",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: tooltip_red
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: props.onChangeStockAlert.mssg
                                })
                            ]
                        }) : stockAlert.show && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "product-details__stock-alert",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: tooltip_red
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: stockAlert.mssg
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row quantity-selector-block",
                            children: [
                                showQuantitySelector && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-3 col-lg-2 col-md-3 quantity-selector-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantitySelector/* default */.Z, {
                                        value: quantity,
                                        onChange: handleChange,
                                        loading: loading,
                                        productStock: productStock
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: showQuantitySelector ? "col-9 col-lg-10 col-md-9 add-to-cart-container" : "col-12 add-to-cart-container add-to-cart-button-main-container",
                                    children: props.SKUInventoryStatus === madeToOrderStatus ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                                role: "button",
                                                label: props.authorData.contactustoorder ? props.authorData.contactustoorder : props.staticTexts.contactUsOrder,
                                                size: "large",
                                                type: "primary",
                                                flexible: true,
                                                tabIndex: productStock < quantity || !quantity ? -1 : 0,
                                                className: "".concat(props.templateType === "tile" || props.templateType === "trim" ? "add-to-cart__main-button disabled" : "add-to-cart__main-button"),
                                                onClick: ()=>handleMadetoOrder(),
                                                disabled: productStock < quantity || !quantity || parseInt(quantity) < 1
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MadetoOrder, {
                                                showModal: showModal,
                                                closeModal: closeModal,
                                                ...props,
                                                activeTab: activeTab,
                                                setActiveTab: setActiveTab
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                            role: "button",
                                            className: "".concat(props.templateType === "tile" || props.templateType === "trim" ? "add-to-cart__main-button disabled" : "add-to-cart__main-button"),
                                            label: props.staticTexts.addToCart,
                                            tabIndex: productStock < quantity || !quantity ? -1 : 0,
                                            onClick: debounce_default()(handleAddToCart, 500),
                                            size: "large",
                                            type: "primary",
                                            flexible: true,
                                            disabled: productStock < quantity || !quantity || parseInt(quantity) < 1,
                                            templateType: props.templateType
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }) : null
            }),
            replaceAddToCart && !props.isDiscontinued && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row quantity-selector-block",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-12 add-to-cart-container add-to-cart-button-main-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        id: "ecommerce-cart-btn",
                        className: "ecommerce-cart__main-button",
                        label: replaceAddToCartCtaLabel,
                        size: "large",
                        type: "primary",
                        flexible: true,
                        tag: "anchor",
                        to: replaceAddToCartCtaLink ? (0,helper/* getShortenedUrlwithGeneral */.vu1)(replaceAddToCartCtaLink, props.general) : "javascript:void(0)",
                        target: linkNewTab === "true" ? "_blank" : "_self",
                        onClick: ()=>{
                            handleAtcDatalayer({
                                title: replaceAddToCartCtaLabel === null || replaceAddToCartCtaLabel === void 0 ? void 0 : replaceAddToCartCtaLabel.toLowerCase(),
                                link: "".concat(window.location.origin + (0,helper/* getShortenedUrlwithGeneral */.vu1)(replaceAddToCartCtaLink, props.general))
                            });
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bottom-section row ".concat(props.isDiscontinued ? "bottom-section-print-block" : ""),
                children: [
                    !props.isDiscontinued && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "add-to-compare",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                        value: props.staticTexts.compareTxt,
                                        checked: isChecked,
                                        onChange: (e)=>handleCompare(e),
                                        disabled: props.isEnable
                                    }),
                                    errorMessage !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolTip/* default */.Z, {
                                        message: errorMessage
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()({
                                    favorites: true,
                                    "favorites--discontinued": enableFav
                                }),
                                onClick: (e)=>handleFavorite(e),
                                role: "button",
                                tabIndex: "0",
                                "aria-label": props.staticTexts.favTxt,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: props.isFavorite ? favorites_filled_annsacks === null || favorites_filled_annsacks === void 0 ? void 0 : favorites_filled_annsacks.src : favorites_empty_annsacks === null || favorites_empty_annsacks === void 0 ? void 0 : favorites_empty_annsacks.src,
                                        alt: props.staticTexts.favTxt
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "text",
                                        children: [
                                            props.staticTexts.favTxt,
                                            " "
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "print-share-container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "print-and-share",
                                role: "list",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: "print-button",
                                        role: "button",
                                        tabIndex: 0,
                                        onClick: printPDP,
                                        "aria-label": props.staticTexts.print,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: print_annsacks === null || print_annsacks === void 0 ? void 0 : print_annsacks.src,
                                                alt: props.staticTexts.print,
                                                "aria-hidden": "true"
                                            }),
                                            props.staticTexts.print
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: "share-button",
                                        role: "button",
                                        tabIndex: 0,
                                        onClick: ()=>setShowSocialLink((prev)=>!prev),
                                        ref: shareImg,
                                        "aria-expanded": showSocialLink,
                                        "aria-controls": "social-links-panel",
                                        "aria-label": props.staticTexts.share,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: share_annsacks === null || share_annsacks === void 0 ? void 0 : share_annsacks.src,
                                                alt: props.staticTexts.share,
                                                "aria-hidden": "true"
                                            }),
                                            props.staticTexts.share,
                                            " "
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialShare/* default */.Z, {
                                showModal: showSocialLink,
                                id: "kf-product-detail",
                                onClose: ()=>{
                                    setShowSocialLink(false);
                                    shareImg === null || shareImg === void 0 ? void 0 : shareImg.current.focus();
                                },
                                shareBtn: shareImg,
                                url: "".concat(window.location.origin).concat(router === null || router === void 0 ? void 0 : router.asPath),
                                asset: props.imagesData[0] ? {
                                    url: (ref3 = props.imagesData[0]) === null || ref3 === void 0 ? void 0 : ref3.url
                                } : false,
                                analyticData: {
                                    eventAction: "pdp:product details:share",
                                    eventName: "pdp:product details:share",
                                    internalLinkPosition: "pdp",
                                    internalLinkType: "pdp:share",
                                    internalLinkZoneName: "pdp:product details",
                                    custom: JSON.stringify({
                                        productInfo: (ref5 = window === null || window === void 0 ? void 0 : (ref4 = window.adobeDataLayer) === null || ref4 === void 0 ? void 0 : ref4.getState("page")) === null || ref5 === void 0 ? void 0 : ref5.productInfo
                                    })
                                },
                                productName: props === null || props === void 0 ? void 0 : (ref6 = props.productSummaryDetails) === null || ref6 === void 0 ? void 0 : ref6.productName_s
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
AddToCart.propTypes = {
    staticTexts: (prop_types_default()).object
};
/* harmony default export */ var ProductDetailView_AddToCart = (AddToCart);
const SuccessPopup = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "success-popup",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "success-popup__title",
                children: props.staticTexts.successTxt
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "success-popup__message",
                children: props.staticTexts.successMsg
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "success-popup__done-cta",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    className: "doneCTA",
                    label: props.staticTexts.doneCTA,
                    size: "small",
                    type: "ghost",
                    onClick: props.closePopup
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/ProductDetail/v1/ProductDetailView/index.jsx




















const ProductDetailView = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23;
    let str = (props === null || props === void 0 ? void 0 : (ref = props.customLabel) === null || ref === void 0 ? void 0 : ref.pagePath) ? props.customLabel.pagePath.split("/") : "";
    let enablePresets = (props === null || props === void 0 ? void 0 : (ref1 = props.customLabel) === null || ref1 === void 0 ? void 0 : ref1.enablepresets) ? props.customLabel.enablepresets : "";
    let leadTimeRange = (props === null || props === void 0 ? void 0 : (ref2 = props.productSummaryDetails) === null || ref2 === void 0 ? void 0 : ref2.LeadTimeRange_s) || "";
    let strType = str ? str.pop() : "";
    const [templateType, setTemplateType] = (0,react.useState)("");
    const [showTrimCal, setshowTrimCal] = (0,react.useState)(false);
    const [showGroutModal, setShowGroutModal] = (0,react.useState)(false);
    const [priceTag, setPriceTag] = (0,react.useState)("");
    const [isGlobalPromotionPrice, setGlobalPromotionPrice] = (0,react.useState)(false);
    const [stickyHeightCalc, setStickyHeightCalc] = (0,react.useState)(0);
    const [onChangeStockAlert, setOnChangeStockAlert] = (0,react.useState)({
        show: false,
        mssg: ""
    });
    const { pdpData , config , RegionUOM =""  } = props;
    const pdpDetails = pdpData !== null && pdpData !== void 0 ? pdpData : {};
    const { pdpProductCustomerFacingName , pdpDesktopImage  } = pdpDetails;
    const { general ={} , plpServletPath =""  } = config;
    const { scene7AccountName: accountName = ""  } = general;
    const NO_FINISH_TYPE = "noFinishType";
    let imagesData = [];
    imagesData = props.imagesData;
    if (imagesData.length === 0 && pdpDesktopImage) {
        imagesData[0] = {
            label: " ",
            template: "LandscapeCategory",
            url: pdpDesktopImage
        };
    }
    const dispatch = (0,es/* useDispatch */.I0)();
    const openGroutChartModal = ()=>{
        !showGroutModal ? analytics_addDataLayer({
            title: "how much grout do i need",
            productInfo: JSON.stringify(productInfo)
        }) : analytics_addDataLayer({
            title: "close",
            productInfo: JSON.stringify(productInfo),
            isrecomendedProps: {
                isrecomended: true,
                type: "how much grout do i need modal"
            }
        });
        setShowGroutModal(!showGroutModal);
    };
    const setRegionUOM = (RegionUOMVal)=>{
        switch(RegionUOMVal){
            case "ft2":
            case "FT2":
                var ref;
                setPriceTag((ref = props.staticTexts) === null || ref === void 0 ? void 0 : ref.perSF);
                setshowTrimCal(true);
                break;
            case "ft":
            case "FT":
                setPriceTag(props.staticTexts.perLF);
                setshowTrimCal(true);
                break;
            case "ea":
            case "EA":
                setPriceTag(props.staticTexts.perEach);
                setshowTrimCal(true);
                break;
            default:
                setPriceTag("");
                setshowTrimCal(false);
                break;
        }
    };
    const getTempType = ()=>{
        switch(strType){
            case "tile-details":
                setTemplateType("tile");
                break;
            case "trim-details":
                setTemplateType("trim");
                break;
            case "grout-details":
                setTemplateType("grout");
                break;
            case "lighting-details":
                setTemplateType("lighting");
                break;
            case "samples-details":
                setTemplateType("samples");
                break;
            case "bathroom-accessories":
                setTemplateType("accessories");
                break;
        }
    };
    const [sticky, setSticky] = (0,react.useState)(false);
    const [navData, setNavData] = (0,react.useState)([]);
    const [currentQuantity, setCurrentQuantity] = (0,react.useState)(1);
    const [imageColorDetails, setImageColorDetails] = (0,react.useState)("");
    const convertToText = (id)=>{
        const parts = id.replace(/#/g, "").toLowerCase().split("-");
        parts.forEach((word, i)=>parts[i] = word.charAt(0).toUpperCase() + word.substring(1));
        return parts.join(" ");
    };
    (0,react.useEffect)(()=>{
        getTempType();
        setTimeout(()=>{
            let totalBlockList = [
                "product-main-overview",
                "product-details-tab-details",
                "pdp-as-grout-template",
                "pdp-as-tile-template",
                "pdp-as-trim-template",
                "pdp-you-may-like-it"
            ];
            const elements = [
                {
                    id: "#Overview"
                },
                {
                    id: "#Details"
                }
            ];
            let navDataSet = [];
            let finalId = "";
            elements.forEach((item, i)=>{
                let itemId = convertToText(item.id);
                if (itemId) {
                    for(let j = 0; j < totalBlockList.length; j++){
                        let splitItemsId = itemId ? itemId.split(" ") : "";
                        if (splitItemsId) {
                            for(let counter = 0; counter < splitItemsId.length; counter++){
                                if (totalBlockList[j].toLowerCase().includes(splitItemsId[counter].toLowerCase()) && finalId == "") {
                                    finalId = totalBlockList[j];
                                    break;
                                }
                            }
                        }
                    }
                    let countData = finalId && finalId.match(/overview/gi) !== null ? 1 : document.getElementById(finalId) && document.getElementById(finalId) !== null ? Number(document.getElementById(finalId).getAttribute("total")) : "";
                    if (countData > 0) {
                        navDataSet.push({
                            label: itemId,
                            elemId: item.id,
                            isActive: i === 0 ? true : false
                        });
                    }
                    finalId = "";
                }
            });
            setNavData(navDataSet);
        }, 5000);
    }, []);
    (0,react.useEffect)(()=>{
        setRegionUOM(RegionUOM.toLowerCase());
    }, [
        RegionUOM
    ]);
    let comparedProductsCount = Number(get_default()(props, "comparedProductsCount", 0));
    var _plpPagePath;
    const plpPagePath = (0,helper/* getShortenedUrlwithGeneral */.vu1)((_plpPagePath = general.plpPagePath) !== null && _plpPagePath !== void 0 ? _plpPagePath : "/", general);
    var _servicePartsLandingPath;
    const serviceLandingPath = (0,helper/* getShortenedUrlwithGeneral */.vu1)((_servicePartsLandingPath = general.servicePartsLandingPath) !== null && _servicePartsLandingPath !== void 0 ? _servicePartsLandingPath : "/", general);
    var _homepageUrl;
    const homePagePath = (0,helper/* getShortenedUrlwithGeneral */.vu1)((_homepageUrl = general.homepageUrl) !== null && _homepageUrl !== void 0 ? _homepageUrl : "/", general);
    const enableaddtocart = props === null || props === void 0 ? void 0 : (ref3 = props.customLabel) === null || ref3 === void 0 ? void 0 : ref3.enableaddtocart;
    const { disableEcommerce , replaceAddToCart , replaceAddToCartCtaLabel , replaceAddToCartCtaLink , linkNewTab  } = props.authorData;
    const enablecalculator = props === null || props === void 0 ? void 0 : (ref4 = props.customLabel) === null || ref4 === void 0 ? void 0 : ref4.enablecalculator;
    const enableselectstyle = props === null || props === void 0 ? void 0 : (ref5 = props.customLabel) === null || ref5 === void 0 ? void 0 : ref5.enableselectstyle;
    let plpUrl;
    if (props.productCategoryType && plpServletPath) {
        const path = plpServletPath.find((i)=>i.categories.includes(props.productCategoryType));
        if (path) {
            if (general.shortendPagePath === null || general.shortendPagePath === "") {
                plpUrl = "".concat(path.url, ".html");
            } else {
                const shortendPath = path.url.replace(general.shortendPagePath, "");
                plpUrl = "".concat(shortendPath);
            }
        } else {
            if (general.shortendPagePath === null || general.shortendPagePath === "") {
                plpUrl = "".concat(plpPagePath, "/").concat(props.productCategory.replace(/ +/g, "-").toLowerCase(), ".html");
            } else {
                plpUrl = "".concat(plpPagePath, "/").concat(props.productCategory.replace(/ +/g, "-").toLowerCase());
            }
        }
    } else {
        plpUrl = general.shortendPagePath === null || general.shortendPagePath === "" ? "".concat(serviceLandingPath, ".html") : "".concat(serviceLandingPath);
    }
    const discontinuedColor = Boolean(get_default()((ref6 = props.colorsData) === null || ref6 === void 0 ? void 0 : ref6.find((item)=>item.id === props.sku), "discontinuedColor", ""));
    let isDiscontinued = false;
    let isColorDiscontinued = false;
    if (props.discontinuedProduct) {
        isDiscontinued = true;
    } else if (discontinuedColor) {
        isDiscontinued = true;
        isColorDiscontinued = true;
    }
    const handleNavChange = (navActive)=>{
        const filteredNavData = navData.map((item, index)=>({
                ...item,
                isActive: index === navActive ? true : false
            }));
        setNavData(filteredNavData);
        modules/* scroller.scrollTo */.OK.scrollTo(filteredNavData[navActive].elemId, {
            duration: 400,
            delay: 0,
            smooth: "easeOutSine",
            offset: dist_lib/* isMobile */.tq ? -62 : -163
        });
    };
    const handleScrollNav = (navActive)=>{
        const filteredNavData = navData.map((item, index)=>({
                ...item,
                isActive: index === navActive ? true : false
            }));
        setNavData(filteredNavData);
    };
    const handleQuantityChange = (qty)=>{
        if (qty) {
            setCurrentQuantity(qty);
        }
    };
    const handleScroll = ()=>{
        modules/* scroller.scrollTo */.OK.scrollTo("buy-area", {
            duration: 1500,
            delay: 0,
            smooth: "easeInOutQuart"
        });
    };
    const recommendedListClickHandler = (title)=>{
        analytics_addDataLayer({
            title: title.toLowerCase(),
            productInfo: JSON.stringify(productInfo)
        });
    };
    const productAnalyticsData = {
        desc: props.desc,
        discountPrice: props.discountedPrice,
        unitPrice: props.price,
        category: props.productCategoryType,
        color: get_default()((ref7 = props.colorsData) === null || ref7 === void 0 ? void 0 : ref7.find((item)=>item.id === props.sku), "label", ""),
        sku: props.sku,
        name: props.name,
        quantity: currentQuantity,
        image: (ref8 = props.imagesData[0]) === null || ref8 === void 0 ? void 0 : ref8.url,
        stock: props.productOnStock,
        unitPrice: props.price,
        globalDiscount: props.globalDiscount || 0,
        discountPriceState: props.discountPercent > 0 ? "percentOff|" + props.discountPercent : "regular price",
        businessUnitName: (0,helper/* sanitizeTextForAnalytics */.T68)(props.businessUnitName),
        customerFacingSKU: (props === null || props === void 0 ? void 0 : props.customerFacingSKU) || (props === null || props === void 0 ? void 0 : props.sku) || "n/a",
        productSaleable: props.productSaleable,
        availability: disableEcommerce ? "n/a" : props.productOnStock > 0 ? "in stock" : "out of stock",
        superSku: props.superSku,
        productCollectionsName: (0,helper/* sanitizeTextForAnalytics */.T68)(props.productCollectionsName),
        brandName: general === null || general === void 0 ? void 0 : (ref9 = general.siteName) === null || ref9 === void 0 ? void 0 : ref9.toLowerCase(),
        discountName: (ref10 = props.badgesProps) === null || ref10 === void 0 ? void 0 : ref10.badgeVal,
        productPartnerBuyNow: props.productPartnerBuyNow,
        defaultImageDataId: props.imagesData.length ? props.imagesData[0].label.split("|")[0] : null
    };
    const { productCouponCode , productCoupondiscount  } = (0,helper/* getCurrentSkuCouponDiscounts */.mPk)({
        cart: props.cart,
        sku: productAnalyticsData.sku
    });
    const productInfo = {
        category: (productAnalyticsData.category || productAnalyticsData.businessUnitName || "n/a").toLowerCase(),
        description: productAnalyticsData.desc || "n/a",
        frequency: "n/a",
        globalPromotionPrice: productAnalyticsData.globalDiscount ? Number((productAnalyticsData.unitPrice - productAnalyticsData.globalDiscount).toFixed(2)) : Number(productAnalyticsData.unitPrice),
        isRecommended: "n/a",
        isSendNow: "n/a",
        isSubscription: "n/a",
        priceState: productAnalyticsData.discountPriceState,
        productBasePrice: productAnalyticsData.unitPrice || "n/a",
        productCategory: (productAnalyticsData.category || productAnalyticsData.businessUnitName || "n/a").toLowerCase(),
        productColor: ((ref11 = productAnalyticsData.color) === null || ref11 === void 0 ? void 0 : ref11.toLowerCase()) || "n/a",
        productCoupondiscount: productCoupondiscount,
        productCouponCode: productCouponCode.join("|") || "n/a",
        productID: productAnalyticsData.customerFacingSKU || "n/a",
        productName: ((ref12 = productAnalyticsData.name) === null || ref12 === void 0 ? void 0 : ref12.toLowerCase()) || "n/a",
        productPartnerBuyNow: productAnalyticsData.productPartnerBuyNow,
        productRoom: (ref13 = productAnalyticsData.businessUnitName || productAnalyticsData.category) === null || ref13 === void 0 ? void 0 : ref13.toLowerCase(),
        productSalePrice: productAnalyticsData.discountPrice ? productAnalyticsData.discountPrice : productAnalyticsData.unitPrice,
        productSaleable: productAnalyticsData.productSaleable,
        productStatus: productAnalyticsData.availability,
        productSuperSku: productAnalyticsData.superSku ? true : false,
        productTileName: ((ref14 = productAnalyticsData.name) === null || ref14 === void 0 ? void 0 : ref14.toLowerCase()) || "n/a",
        quantity: productAnalyticsData.quantity || "n/a",
        defaultImageName: productAnalyticsData.image || "n/a",
        ratings: "n/a",
        numberOfReviews: "n/a",
        pdpType: (0,helper/* pdpTypeFormat */.V4r)({
            businessUnitName: props.businessUnitName,
            ProductPriceSpiderIncluded_s: props.ProductPriceSpiderIncluded_s,
            discontinuedProductb: props.discontinuedProduct,
            ProductRequiredAccessoriesGroupsList: props.ProductRequiredAccessoriesGroupsList,
            superSku: props.superSku
        }),
        productFindingMethod: "n/a",
        productCollectionsName: (productAnalyticsData.productCollectionsName || productAnalyticsData.category || "n/a").toLowerCase(),
        productBrand: productAnalyticsData.brandName,
        globalOffer: productAnalyticsData.discountName || "n/a",
        globalDiscount: productAnalyticsData.discountPrice ? productAnalyticsData.globalDiscount : 0,
        itemType: (0,helper/* getCartItemType */.Nth)(productAnalyticsData.category, productAnalyticsData.businessUnitName)
    };
    (0,react.useEffect)(()=>{
        if ((productInfo === null || productInfo === void 0 ? void 0 : productInfo.globalPromotionPrice) !== null && (productInfo === null || productInfo === void 0 ? void 0 : productInfo.globalPromotionPrice) !== undefined) {
            setGlobalPromotionPrice(true);
        }
    }, [
        productInfo === null || productInfo === void 0 ? void 0 : productInfo.globalPromotionPrice
    ]);
    (0,react.useEffect)(()=>{
        if (window.pageObj && props.loadShowEvent && isGlobalPromotionPrice) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
            const page = (window === null || window === void 0 ? void 0 : (ref = window.adobeDataLayer) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.page) || (window === null || window === void 0 ? void 0 : window.pageObj) || {};
            const category = (page === null || page === void 0 ? void 0 : page.category) || {};
            const pageType = (page === null || page === void 0 ? void 0 : (ref2 = page.category) === null || ref2 === void 0 ? void 0 : ref2.pageType) || "";
            const siteName = productAnalyticsData.brandName;
            const pageInfo = (page === null || page === void 0 ? void 0 : page.pageInfo) || {};
            category["subCategory1"] = pageType + ":" + (productAnalyticsData === null || productAnalyticsData === void 0 ? void 0 : (ref3 = productAnalyticsData.category) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase());
            category["subCategoryName"] = pageType + ":" + (productAnalyticsData === null || productAnalyticsData === void 0 ? void 0 : (ref4 = productAnalyticsData.category) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase());
            category["subCategory2"] = pageType + ":" + (productAnalyticsData === null || productAnalyticsData === void 0 ? void 0 : (ref5 = productAnalyticsData.category) === null || ref5 === void 0 ? void 0 : ref5.toLowerCase()) + ":" + productAnalyticsData.customerFacingSKU;
            category["subCategoryID"] = productAnalyticsData.customerFacingSKU;
            category["room"] = productInfo === null || productInfo === void 0 ? void 0 : (ref6 = productInfo.productRoom) === null || ref6 === void 0 ? void 0 : ref6.toLowerCase();
            pageInfo["pageName"] = siteName + ":" + pageType + ":" + (productAnalyticsData === null || productAnalyticsData === void 0 ? void 0 : (ref7 = productAnalyticsData.category) === null || ref7 === void 0 ? void 0 : ref7.toLowerCase()) + ":" + productAnalyticsData.customerFacingSKU;
            pageInfo["defaultImage"] = props.imagesData.length ? productAnalyticsData.defaultImageDataId || props.imagesData[0].url : "n/a";
            page.category = category;
            if (!(0,helper/* isShowAnalyticsEventLoaded */.xJ2)()) {
                page.user = (0,helper/* getUserAnalyticsObject */.L7i)();
                page.productInfo = productInfo;
                if ((!page.user.gId || page.user.gId === "n/a") && (!page.user.commerceToolsID || page.user.commerceToolsID === "n/a")) {
                    page.pageInfo = pageInfo;
                    window.pageObj = page;
                    window.isShowAnalyticsEvent = true;
                } else {
                    window.adobeDataLayer.push({
                        event: "cmp:show",
                        pageInfo,
                        productInfo,
                        page
                    });
                    delete window.pageObj;
                    dispatch((0,pdpSlice/* setProductInfo */.CC)(productAnalyticsData.stringProductInfo));
                }
            }
        }
        return ()=>{
            dispatch((0,pdpSlice/* setProductInfo */.CC)(null));
        };
    }, [
        props.loadShowEvent,
        productInfo
    ]);
    (0,react.useEffect)(()=>{
        var ref;
        document.querySelector(".pdp-feature-image-top") !== null ? isDiscontinued ? document.querySelector(".pdp-feature-image-top").style.display = "none" : document.querySelector(".pdp-feature-image-top").style.display = "block" : "";
        const selectedColorInfo = (ref = props.colorsData) === null || ref === void 0 ? void 0 : ref.find((item)=>item.id === props.sku);
        if (selectedColorInfo) {
            setImageColorDetails("".concat(selectedColorInfo["label"], " ").concat(selectedColorInfo["finishName"] !== NO_FINISH_TYPE ? " - ".concat(selectedColorInfo["finishName"]) : ""));
        }
    }, [
        props.sku
    ]);
    (0,react.useEffect)(()=>{
        setTimeout(()=>{
            props.discontinuedProduct && document.querySelector(".pdp-main__replacement-suggestions") !== null ? document.querySelector(".pdp-main__replacement-suggestions").style.display = "block" : "";
            !props.discontinuedProduct && discontinuedColor && document.querySelector(".pdp-main__replacement-suggestions") !== null ? document.querySelector(".pdp-main__replacement-suggestions").style.display = "none" : "";
            (props.discontinuedProduct || discontinuedColor) && document.getElementById("pdp-as-grout-template") !== null ? document.getElementById("pdp-as-grout-template").style.display = "none" : "";
            (props.discontinuedProduct || discontinuedColor) && document.getElementById("pdp-as-trim-template") !== null ? document.getElementById("pdp-as-trim-template").style.display = "none" : "";
            (props.discontinuedProduct || discontinuedColor) && document.getElementById("pdp-as-tile-template") !== null ? document.getElementById("pdp-as-tile-template").style.display = "none" : "";
            (props.discontinuedProduct || discontinuedColor) && document.getElementById("pdp-you-may-like-it") !== null ? document.getElementById("pdp-you-may-like-it").style.display = "none" : "";
        }, 1500);
        const overviewBlock = document.querySelector(".product-details .kf-react-container");
        setStickyHeightCalc(Number(overviewBlock.offsetHeight)) //getting pdp overview block height and header height
        ;
    });
    const createMap = (productImages)=>{
        const newProductImages = (productImages === null || productImages === void 0 ? void 0 : productImages.map((item)=>({
                sku: item.split("|")[0],
                tag: item.split("|")[1]
            }))) || [];
        return newProductImages;
    };
    var ref24;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            showGroutModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetailView_PdpGroutChart, {
                authorData: props === null || props === void 0 ? void 0 : props.groutData,
                closePopup: ()=>openGroutChartModal()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((react_sticky_el_lib_default()), {
                topOffset: stickyHeightCalc,
                onFixedToggle: ()=>setSticky(!sticky),
                className: "product-details__sticky-wrapper",
                children: !isDiscontinued && sticky && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_StickyHeader, {
                    ...props.stickyHeaderProps,
                    currencySign: props.currencySign,
                    price: props.discountedPrice > 0 ? props.discountedPrice : props.price,
                    staticTexts: props.staticTexts,
                    imgUrl: (ref24 = (ref15 = props.imagesData[0]) === null || ref15 === void 0 ? void 0 : ref15.url) !== null && ref24 !== void 0 ? ref24 : "",
                    onAddToCart: (cartItemProduct)=>props.onAddToCart(cartItemProduct),
                    handleNavChange: (navActive)=>handleNavChange(navActive),
                    navData: navData,
                    isDiscontinued: isDiscontinued,
                    isColorDiscontinued: isColorDiscontinued,
                    specialOrder: (ref16 = props.addToCartProps) === null || ref16 === void 0 ? void 0 : ref16.specialOrder,
                    backOrder: (ref17 = props.addToCartProps) === null || ref17 === void 0 ? void 0 : ref17.backOrder,
                    productOnStock: props.productOnStock,
                    productStock: props.productOnStock,
                    leadTimeRange: leadTimeRange,
                    sku: props.sku,
                    isComboSku: props.isComboSku,
                    handleScroll: handleScroll,
                    onAvailableColor: ()=>props.onAvailableColor(),
                    handleScrollNav: handleScrollNav,
                    productIsRetail: props.productIsRetail,
                    templateType: templateType,
                    ProductDescriptionDetail_s: props.productSelectYourStyle["ProductDescriptionDetail_s"],
                    priceTag: priceTag,
                    analyticsProductInfo: JSON.stringify(productInfo),
                    isParts: props.isParts,
                    disableEcommerce: disableEcommerce,
                    replaceAddToCart: replaceAddToCart,
                    replaceAddToCartCtaLabel: replaceAddToCartCtaLabel,
                    replaceAddToCartCtaLink: replaceAddToCartCtaLink,
                    linkNewTab: linkNewTab,
                    productCategoryType: props.productCategoryType,
                    general: general,
                    accountName: accountName,
                    swatchUrl: props === null || props === void 0 ? void 0 : props.swatchUrl,
                    presetConfig: props === null || props === void 0 ? void 0 : props.presetConfig
                })
            }),
            props.toaster.show && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-details__toaster ".concat(props.toaster.mobileOnly ? "--mobile" : "", " ").concat(sticky ? "--sticky" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Toaster["default"], {
                    message: props.toaster.message
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-details",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container kf-react-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "header-section",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product-details__breadcrumb",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                                        id: "breadcrumb",
                                        "aria-label": "Breadcrumb",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "product-details__breadcrumb-link",
                                                onClick: ()=>{
                                                    var ref;
                                                    return analytics_addDataLayer({
                                                        breadCrumbObj: {
                                                            breadCrumbTitle: "breadcrumb",
                                                            breadCrumbPath: "".concat(props === null || props === void 0 ? void 0 : (ref = props.staticTexts) === null || ref === void 0 ? void 0 : ref.home).toLowerCase()
                                                        },
                                                        url: (homePagePath.indexOf("http") === -1 ? window.location.origin : "") + getShortenedUrl(homePagePath)
                                                    });
                                                },
                                                href: homePagePath,
                                                children: props.staticTexts.home
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                "aria-hidden": "true",
                                                children: " / "
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "product-details__breadcrumb-link",
                                                onClick: ()=>{
                                                    var ref;
                                                    return analytics_addDataLayer({
                                                        breadCrumbObj: {
                                                            breadCrumbTitle: "breadcrumb",
                                                            breadCrumbPath: "".concat(props === null || props === void 0 ? void 0 : props.staticTexts.home, " > ").concat((props === null || props === void 0 ? void 0 : props.productCategoryType) ? props === null || props === void 0 ? void 0 : props.productCategoryType : (ref = props.staticTexts) === null || ref === void 0 ? void 0 : ref.serviceParts).toLowerCase()
                                                        },
                                                        url: (plpUrl.indexOf("http") === -1 ? window.location.origin : "") + getShortenedUrl(plpUrl)
                                                    });
                                                },
                                                href: plpUrl,
                                                children: props.productCategoryType ? props.productCategoryType : props.staticTexts.serviceParts
                                            })
                                        ]
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "print-overview product-details__overview-block product-info",
                            id: "product-details__overview-block",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "product-img-block product-details__image-gallery print-overview-left",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ProductGalleryView, {
                                        data: imagesData,
                                        productData: productAnalyticsData,
                                        staticTexts: props.staticTexts,
                                        productGalleryLabel: props.productGalleryLabel,
                                        enablePresets: enablePresets,
                                        presetConfig: props.presetConfig,
                                        swatchUrl: props.swatchUrl,
                                        templateType: templateType,
                                        sku: props.sku,
                                        pdpData: props.pdpData,
                                        accountName: accountName,
                                        showSaleBadge: props.showSaleBadge,
                                        imageColorDetails: imageColorDetails
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: templateType === constants.SAMPLE ? "product-info-block product-details__content-section print-overview-right sample-product" : "product-info-block product-details__content-section print-overview-right",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ProductSummary, {
                                            pdpProductCustomerFacingName: pdpProductCustomerFacingName,
                                            productSummaryDetails: props.productSummaryDetails,
                                            price: props.price,
                                            discountedPrice: props.discountedPrice,
                                            currencySign: props.currencySign,
                                            persona: props.persona,
                                            orderSample: props.orderSample,
                                            isDiscontinued: isDiscontinued,
                                            staticTexts: props.staticTexts,
                                            authorData: props.authorData,
                                            enableaddtocart: enableaddtocart,
                                            productData: productAnalyticsData,
                                            onAddToCart: props.onAddToCart,
                                            discountPercent: props.discountPercent,
                                            isType: props.isType,
                                            priceTag: priceTag,
                                            isSample: templateType === constants.SAMPLE,
                                            templateType: templateType,
                                            analyticsProductInfo: JSON.stringify(productInfo),
                                            cart: props.cart,
                                            disableEcommerce: disableEcommerce,
                                            productCategoryType: props.productCategoryType
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: isDiscontinued === true ? "summaryWrapper summaryWrapper summaryWrapperDiscountinued select-style-block" : "summaryWrapper select-style-block",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "summaryWrapper__top-block",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: templateType === constants.SAMPLE ? "product-select-style__product-devider--none" : "product-select-style__product-devider"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "product-details__content-section summaryWrapper-right",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "",
                                                        children: [
                                                            enableselectstyle && (Object.keys(props.options).length > 0 || props.customLabel || props.productSelectYourStyle["ProductDescriptionDetail_s"]) && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_SelectYourStyle, {
                                                                ...props.productSelectYourStyle,
                                                                productImages: createMap(props.productImages),
                                                                swatchUrl: props.swatchUrl,
                                                                productTitle: props.name,
                                                                ProductLocalCategory: props.ProductLocalCategory_s,
                                                                productCollection: props.productCollection,
                                                                i18n: props.staticTexts,
                                                                imageDetails: props.options["ProductDetailImageURL_s"],
                                                                descriptionDetails: props.options["ProductDescriptionDetail_s"],
                                                                brandName: general === null || general === void 0 ? void 0 : (ref18 = general.siteName) === null || ref18 === void 0 ? void 0 : ref18.toLowerCase(),
                                                                lwAppName: general === null || general === void 0 ? void 0 : (ref19 = general.lwAppName) === null || ref19 === void 0 ? void 0 : ref19.toLowerCase(),
                                                                selectOption: (val, facet, datalayerTitle)=>props.selectOption(val, facet, datalayerTitle),
                                                                setSkuVariant: (sku, finish)=>props.setSkuVariant(sku, finish),
                                                                colorDiscontinuedVarients: props.colorsData,
                                                                styleOptionsNotPresent: props === null || props === void 0 ? void 0 : props.styleOptionsNotPresent,
                                                                isDiscontinued: props === null || props === void 0 ? void 0 : props.discontinuedProduct,
                                                                customLabel: props.customLabel,
                                                                isColorDiscontinued: discontinuedColor,
                                                                analyticsProductInfo: JSON.stringify(productInfo),
                                                                availableColors: props.availableColors,
                                                                authorData: props.authorData,
                                                                comboSkuDetails: props.comboSkuDetails,
                                                                productCategoryType: props.productCategoryType,
                                                                priceData: props === null || props === void 0 ? void 0 : props.priceData,
                                                                isCollapsedPDP: props === null || props === void 0 ? void 0 : props.isCollapsedPDP,
                                                                presetConfig: props.presetConfig,
                                                                accountName: accountName
                                                            }),
                                                            !props.price ? "" : enablecalculator && !isDiscontinued && showTrimCal && /*#__PURE__*/ (0,jsx_runtime.jsx)(TrimCalculator_TrimCalculator, {
                                                                soldByBox: props.soldByBox,
                                                                soldByUom: props.soldByUom,
                                                                price: props.price,
                                                                priceByBox: props.discountedPricePerBox > 0 ? props.discountedPricePerBox : props.pricePerBox > 0 ? props.pricePerBox : 1,
                                                                staticTexts: props.staticTexts,
                                                                templateType: templateType,
                                                                customLabel: props.customLabel,
                                                                analyticsProductInfo: JSON.stringify(productInfo),
                                                                sku: props.sku,
                                                                setOnChangeStockAlert: setOnChangeStockAlert,
                                                                t: props.t,
                                                                cart: props.cart,
                                                                disableEcommerce: disableEcommerce,
                                                                RegionUOM: RegionUOM,
                                                                currencySign: props === null || props === void 0 ? void 0 : props.currencySign,
                                                                SKUInventoryStatus: (ref20 = props.productSummaryDetails) === null || ref20 === void 0 ? void 0 : ref20["SKUAnnSacksNonStock_b"]
                                                            }),
                                                            templateType === "grout" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "product-details__need-link-block",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: "javascript:void(0)",
                                                                    className: "pdp-tile__need-link",
                                                                    onClick: ()=>openGroutChartModal(),
                                                                    children: props && (props === null || props === void 0 ? void 0 : (ref21 = props.customLabel) === null || ref21 === void 0 ? void 0 : ref21.grouttitle) ? props.customLabel.grouttitle : props && props.staticTexts ? props.staticTexts.productGroutNeed : ""
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "row buy-area add-to-cart-main-block",
                                                                children: /*#__PURE__*/ (0,react.createElement)(ProductDetailView_AddToCart, {
                                                                    ...props.addToCartProps,
                                                                    key: props.sku,
                                                                    t: props.t,
                                                                    staticTexts: props.staticTexts,
                                                                    onQtyChange: (qty)=>handleQuantityChange(qty),
                                                                    onAddToCart: (cartItemProduct, cb)=>props.onAddToCart(cartItemProduct, cb),
                                                                    onAdd: ()=>props.onAddToCompare(),
                                                                    onRemove: ()=>props.onRemoveFromCompare(),
                                                                    checkCategory: ()=>props.checkProductCategory(),
                                                                    comparedProductsCount: comparedProductsCount,
                                                                    sku: props.sku,
                                                                    isComboSku: props.isComboSku,
                                                                    productCategory: props.ProductLocalCategory_s,
                                                                    isEnable: props.isEnable,
                                                                    isParts: props.isParts,
                                                                    productOnStock: props.productOnStock,
                                                                    isColorDiscontinued: isColorDiscontinued,
                                                                    isDiscontinued: isDiscontinued,
                                                                    specialOrder: (ref22 = props.addToCartProps) === null || ref22 === void 0 ? void 0 : ref22.specialOrder,
                                                                    backOrder: (ref23 = props.addToCartProps) === null || ref23 === void 0 ? void 0 : ref23.backOrder,
                                                                    productIsRetail: props.productIsRetail,
                                                                    showToaster: props.showToaster,
                                                                    onAvailableColor: ()=>props.onAvailableColor(),
                                                                    productData: productAnalyticsData,
                                                                    findStoreUrl: props.findStoreUrl,
                                                                    promoTitle: props.promoTitle,
                                                                    promoDescription: props.promoDescription,
                                                                    enablePromo: props.enablePromo,
                                                                    isFavorite: props.isFavorite,
                                                                    price: props.discountedPrice > 0 ? props.discountedPrice : props.price,
                                                                    imagesData: props.imagesData,
                                                                    templateType: templateType,
                                                                    customLabel: props.customLabel,
                                                                    favItem: props.favItem,
                                                                    ctData: props.ctData,
                                                                    updateRecalculateRoomInfo: (lineItemId, recalculateAdditionalInfo, customQuantity, cb)=>props.updateRecalculateRoomInfo(lineItemId, recalculateAdditionalInfo, customQuantity, cb),
                                                                    analyticsProductInfo: JSON.stringify(productInfo),
                                                                    priceTag: priceTag,
                                                                    ProductDescriptionDetail_s: props.productSelectYourStyle["ProductDescriptionDetail_s"],
                                                                    currencySign: props.currencySign,
                                                                    productSummaryDetails: props.productSummaryDetails,
                                                                    authorData: props.authorData,
                                                                    SKUInventoryStatus: props.SKUInventory,
                                                                    onChangeStockAlert: onChangeStockAlert,
                                                                    config: config,
                                                                    general: general
                                                                })
                                                            }),
                                                            !isDiscontinued && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "recommended-list-details",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "recommended-list-main-block",
                                                                    children: [
                                                                        navData.find((o)=>o.label === props.customLabel.recommendedOne) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "recommended-list-first-label",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                href: props.customLabel && props.customLabel.recommendedOneId ? props.customLabel.recommendedOneId : "#",
                                                                                className: "recommended-list-first-link",
                                                                                onClick: ()=>recommendedListClickHandler(props.customLabel.recommendedOne),
                                                                                children: props.customLabel && props.customLabel.recommendedOne ? props.customLabel.recommendedOne : ""
                                                                            })
                                                                        }) : null,
                                                                        navData.find((o)=>o.label === props.customLabel.recommendedTwo) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "recommended-list-second-label",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                href: props.customLabel && props.customLabel.recommendedTwoId ? props.customLabel.recommendedTwoId : "#",
                                                                                className: "recommended-list-second-link",
                                                                                onClick: ()=>recommendedListClickHandler(props.customLabel.recommendedTwo),
                                                                                children: props.customLabel && props.customLabel.recommendedTwo ? props.customLabel.recommendedTwo : ""
                                                                            })
                                                                        }) : null
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var v1_ProductDetailView = (ProductDetailView);

// EXTERNAL MODULE: ./src/store/features/cartSlice.js
var cartSlice = __webpack_require__(64925);
// EXTERNAL MODULE: ./store/features/asPdpSlice.js
var asPdpSlice = __webpack_require__(53367);
// EXTERNAL MODULE: ./i18n/usePdpi18n.js
var usePdpi18n = __webpack_require__(58886);
;// CONCATENATED MODULE: ./components/ProductDetail/v1/ProgressiveLoader.jsx





const ProgressiveLoader = (props)=>{
    var ref, ref1, ref2;
    const { loaderData: pdpDetails = {}  } = props;
    const { accountName =""  } = pdpDetails;
    const [width] = (0,useWindowResize/* default */.Z)();
    const [imagesData, setImagesData] = (0,react.useState)([]);
    const [imageData, setImageData] = (0,react.useState)({});
    var ref3;
    const [presetConfig] = (0,react.useState)(JSON.parse((ref3 = pdpDetails === null || pdpDetails === void 0 ? void 0 : pdpDetails.presetConfigs) !== null && ref3 !== void 0 ? ref3 : "{}"));
    const urlParams = new URLSearchParams(window.location.search);
    var ref4;
    const urlSku = (ref4 = (0,helper/* sanitizeDOMString */.TRt)(urlParams.get("skuId"))) !== null && ref4 !== void 0 ? ref4 : "";
    const { pdpProductCustomerFacingName , productInfoJson  } = pdpDetails;
    const formatImages = (labels, urls, ResourceCredits, templates)=>{
        const images = [];
        for(let i = 0; i < urls.length; i++){
            var ref;
            var _i;
            images.push({
                label: (_i = labels[i]) !== null && _i !== void 0 ? _i : "",
                url: (0,helper/* isObject */.Kn2)(urls[i]) ? (ref = urls[i]) === null || ref === void 0 ? void 0 : ref.src : urls[i],
                resourceCredits: ResourceCredits[i],
                template: templates[i],
                accountName
            });
        }
        return images;
    };
    (0,react.useEffect)(()=>{
        let variantImages = pdpDetails["productImages.labelWithUrl_ss"];
        let selectedSku = pdpDetails["variantList.sku_ss"] ? pdpDetails["variantList.sku_ss"][0] : urlSku;
        let variantImageLabels = [], variantImageURLs = [], variantImageTemplates = [], lifeStyleVariantImageLabels = [], variantResourceCredits = [], imagesData_ = [], lifeStyleVariantResourceCredits = [], lifeStyleVariantTemplates = [], lifeStyleVariantImageURLs = [];
        if (variantImages && variantImages.length > 0) {
            variantImages.map((img)=>{
                var ref;
                let imgDetail = img.split("|");
                if (selectedSku === imgDetail[0]) {
                    variantImageLabels.push(imgDetail[1] + "|" + imgDetail[2]);
                    variantResourceCredits.push(imgDetail[3] ? imgDetail[3] : "");
                    variantImageTemplates.push("LandscapeCategory");
                    let _urlIndex = imgDetail.length - 1;
                    if (imgDetail[_urlIndex] && imgDetail[_urlIndex].indexOf("http") > -1) {
                        variantImageURLs.push(imgDetail[_urlIndex]);
                    } else {
                        variantImageURLs.push(image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src);
                    }
                }
                if ((ref = imgDetail[0]) === null || ref === void 0 ? void 0 : ref.startsWith("IMGV")) {
                    lifeStyleVariantImageLabels.push(imgDetail[1] + "|" + imgDetail[2]);
                    lifeStyleVariantResourceCredits.push(imgDetail[3] ? imgDetail[3] : "");
                    lifeStyleVariantTemplates.push("Lifestyle");
                    let _urlIndex1 = (imgDetail === null || imgDetail === void 0 ? void 0 : imgDetail.length) - 1;
                    if (imgDetail[_urlIndex1] && imgDetail[_urlIndex1].indexOf("http") > -1) {
                        lifeStyleVariantImageURLs.push(imgDetail[_urlIndex1]);
                    } else {
                        lifeStyleVariantImageURLs.push(image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src);
                    }
                }
            });
            if (variantImageURLs.length < 1) {
                variantImageLabels.push(selectedSku);
                variantImageURLs.push(image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src);
                variantResourceCredits.push("");
            }
        } else {
            variantImageLabels.push(selectedSku);
            variantImageURLs.push(image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src);
            variantResourceCredits.push("");
        }
        imagesData_[selectedSku] = formatImages(variantImageLabels, variantImageURLs, variantResourceCredits, variantImageTemplates);
        imagesData_["lifeStyleImageVariants"] = formatImages(lifeStyleVariantImageLabels, lifeStyleVariantImageURLs, lifeStyleVariantResourceCredits, lifeStyleVariantTemplates);
        setImagesData(imagesData_[selectedSku]);
    }, [
        pdpDetails
    ]);
    (0,react.useLayoutEffect)((0,helper/* debounce */.DsO)(()=>{
        var ref, ref1;
        const tempImageData = (imagesData === null || imagesData === void 0 ? void 0 : imagesData.length) && {
            ...imagesData[0],
            url: (0,helper/* getPDPPresetUrl */.AJ0)(pdpDetails.swatchUrl, presetConfig, ((ref = imagesData[0]) === null || ref === void 0 ? void 0 : ref.url) || "", width, (ref1 = imagesData[0]) === null || ref1 === void 0 ? void 0 : ref1.template, accountName)
        };
        setImageData(tempImageData);
    }), [
        imagesData
    ]);
    const getDesignByTitle = ()=>{
        let productDesignerByText = "";
        if ((pdpDetails === null || pdpDetails === void 0 ? void 0 : pdpDetails.pdpDesignerName) && pdpProductCustomerFacingName.toLowerCase().indexOf(pdpDetails === null || pdpDetails === void 0 ? void 0 : pdpDetails.pdpDesignerName.toLowerCase()) === -1) {
            productDesignerByText = (pdpDetails === null || pdpDetails === void 0 ? void 0 : pdpDetails.pdpDesignerName) ? "By" + " " + (pdpDetails === null || pdpDetails === void 0 ? void 0 : pdpDetails.pdpDesignerName) : "";
        }
        return productDesignerByText;
    };
    const productInfoObj = productInfoJson !== null && productInfoJson !== void 0 ? productInfoJson : {};
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "product-detail-page min-vh-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "product-details",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container kf-react-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "header-section",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product-details__breadcrumb",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: "product-details__breadcrumb-link gbh-data-layer",
                                        href: "",
                                        children: [
                                            " ",
                                            "Home",
                                            " "
                                        ]
                                    }),
                                    "/",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: "product-details__breadcrumb-link gbh-data-layer",
                                        href: "",
                                        children: [
                                            " ",
                                            pdpDetails === null || pdpDetails === void 0 ? void 0 : pdpDetails.ProductLocalCategory_s,
                                            " "
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "print-overview product-details__overview-block product-info",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product-img-block product-details__image-gallery print-overview-left",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "image-reel row",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "image-reel__image-thumb-view no-print",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                className: "pl-0 ml-0 image-reel__image-thumb-view-ul",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "image-reel__image-list",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "image-reel__image-thumb",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            role: "button",
                                                            src: imageData === null || imageData === void 0 ? void 0 : (ref = imageData.url) === null || ref === void 0 ? void 0 : ref.replace("PAWEB", accountName),
                                                            className: "img-fluid",
                                                            alt: productInfoObj.pdpImageAlt,
                                                            tabIndex: "0"
                                                        })
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "image-reel__image-stack-view",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "image-reel__image-stack-view-block",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                        className: "pl-0 list-inline image-reel__image-stack-list",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    role: "button",
                                                                    // src={pdpDesktopImage}
                                                                    src: imageData === null || imageData === void 0 ? void 0 : (ref1 = imageData.url) === null || ref1 === void 0 ? void 0 : ref1.replace("PAWEB", accountName),
                                                                    className: "print d-none d-sm-block image-reel__stack-list-image",
                                                                    alt: pdpProductCustomerFacingName
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    role: "button",
                                                                    // src={pdpMobileImage}
                                                                    src: imageData === null || imageData === void 0 ? void 0 : (ref2 = imageData.url) === null || ref2 === void 0 ? void 0 : ref2.replace("PAWEB", accountName),
                                                                    className: "print d-sm-none image-reel__stack-list-image",
                                                                    alt: pdpProductCustomerFacingName
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "image-reel__photo-credit"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product-info-block product-details__content-section print-overview-right",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-12 product-summary__product-summary-block p-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "product-summary",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "product-summary__desc",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "product-summary__desc",
                                                    children: [
                                                        pdpProductCustomerFacingName,
                                                        " ",
                                                        getDesignByTitle()
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "product-summary__price",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "shimmer-loading__para shimmer height-30"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "product-summary__discount",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "shimmer-loading__para shimmer height-30"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "product-summary__details",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "shimmer-loading__para shimmer height-30"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "product-summary__button-block",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "shimmer-loading__para shimmer height-30"
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var v1_ProgressiveLoader = (ProgressiveLoader);

// EXTERNAL MODULE: ./components/ProductDetail/v1/productDetailsHelper.jsx
var v1_productDetailsHelper = __webpack_require__(34073);
// EXTERNAL MODULE: ./utils/product.js
var product = __webpack_require__(29843);
;// CONCATENATED MODULE: ./components/ProductDetail/v1/ProductDetail.jsx
























const ProductOverview = (props)=>{
    var ref;
    const { data: authorData = {} , pdpData ={} , slug: slugProp = props.slug || "" , config ={}  } = props;
    const [availableColorFirstSku, setAvailableColorFirstSku] = (0,react.useState)("");
    const [slug, setSlug] = (0,react.useState)(slugProp);
    const [allVariantsDetails, setAllVariantsDetails] = (0,react.useState)([]);
    const [loadShowEvent, setLoadShowEvent] = (0,react.useState)(false);
    const [pdprops, setPdprops] = (0,react.useState)({});
    const [pricesData, setPricesData] = (0,react.useState)([]);
    const [comboSku, setComboSku] = (0,react.useState)([]);
    const [imagesData, setImagesData] = (0,react.useState)([]);
    const [regionSoldOnline, setRegionSoldOnline] = (0,react.useState)([]);
    const [badgesProps, setBadgesProps] = (0,react.useState)();
    const [listPrices, setListPrices] = (0,react.useState)([]);
    const [discountedPrices, setDiscountedPrices] = (0,react.useState)([]);
    const [discountPercent, setDiscountPercent] = (0,react.useState)([]);
    const [productSummary, setProductSummary] = (0,react.useState)([]);
    const [productGalleryLabel, setProductGalleryLabel] = (0,react.useState)();
    const [orderSample, setOrderSample] = (0,react.useState)();
    const [productSelectYourStyle, setProductSelectYourStyle] = (0,react.useState)();
    const [availableColors, setAvailableColors] = (0,react.useState)([]);
    const [isType, setIsType] = (0,react.useState)([]);
    const [presetConfigObject, setPresetConfigObject] = (0,react.useState)({});
    const [videoIds, setVideoIds] = (0,react.useState)([]);
    const [availableStock, setAvailableStock] = (0,react.useState)(0);
    const [colorFiles, setColorFiles] = (0,react.useState)([]);
    const [colorNames, setColorNames] = (0,react.useState)([]);
    const [state, setState] = (0,react.useState)({});
    const [reqCartData, setReqCartData] = (0,react.useState)({});
    const [superSku] = (0,react.useState)("");
    const [isParts] = (0,react.useState)("");
    const [selectedSku, setSelectedSku] = (0,react.useState)("");
    const [tabDetailsUpdate, setTabDetailsUpdate] = (0,react.useState)();
    var ref1;
    const [language] = (0,react.useState)((ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en");
    const [plpServletPath] = (0,react.useState)(config === null || config === void 0 ? void 0 : config.plpServletPath);
    const [SKUInventory, setSKUInventory] = (0,react.useState)();
    const [showSaleBadge, setShowSaleBadge] = (0,react.useState)(false);
    const dispatch = (0,es/* useDispatch */.I0)();
    const { cart , cart: { id: cartLoaded = ""  } = {}  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    const { favorites  } = (0,es/* useSelector */.v9)(favoritesSlice/* selectFavoritesState */.Qx);
    const { ctData , asTabDetails: asTabDetailsFromState  } = (0,es/* useSelector */.v9)(pdpSlice/* selectPdpState */.BY);
    const { isEnable , comparedProducts , category: productCategory , compareSectionData  } = (0,es/* useSelector */.v9)(compareSlice/* compareState */.NP);
    var ref2;
    const designServiceDataFromProp = (ref2 = authorData === null || authorData === void 0 ? void 0 : authorData.designServices) !== null && ref2 !== void 0 ? ref2 : [];
    var ref3;
    const installationDataFromProp = (ref3 = authorData === null || authorData === void 0 ? void 0 : authorData.installServices) !== null && ref3 !== void 0 ? ref3 : [];
    const persona = (0,helper/* getUserPersona */.shu)();
    const overSizedType = "4";
    const { general ={} , internationalization: { locale ="" , currencySign ="" , currencyCode =""  } = {}  } = config;
    const { disableCommerce: disableEcommerce = false , cartLandingPagePath , findProPagePath: findProPagePathUrl = "/" , findStorePagePath ="" , newBadgeName ="" , saleBadgeName ="" , exclusiveBadgeName ="" , discontinuedBadgeName ="" , lwAppName ="" , swatchUrl =""  } = general;
    const badgeText = {
        new: newBadgeName,
        onSale: saleBadgeName,
        exclusive: exclusiveBadgeName,
        discontinued: discontinuedBadgeName
    };
    const staticTexts = (0,usePdpi18n/* default */.Z)(authorData, badgeText, name);
    const { promoTitle ="" , productDetailData ={} , priceData ={} , options ={} , comboSkuData , soldByBox ="" , soldByUom ="" , selectMoreTooltipData =[] , masterSku ="" , currOptions ={} , userZipCode ="" , isNearest , servicesData ={} , installationData =[] , designServiceData =[] , zipCodeData =[] , toaster ={
        show: false,
        message: "",
        mobileOnly: false
    }  } = state;
    const { id , ProductLocalCategory_s: productLocalCategory = "" , Product_Category: productCate = "" , ProductCollection_s: productCollection = "" , isCollapsedPDP_b: isCollapsedPDP = false , ProductBrandNameDisplay_s: productBrandNameDisplay = ""  } = productDetailData;
    (0,react.useEffect)(()=>{
        if (promoTitle !== null) {
            getServiceData();
            (0,v1_productDetailsHelper/* getZipCodeJsonFile */.O1)(state.jsonFileUrl, (data)=>{
                const { zipcode =[]  } = data;
                setState((prevState)=>{
                    return {
                        ...prevState,
                        zipCodeData: zipcode
                    };
                });
            });
        }
    }, [
        promoTitle
    ]);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(productDetailData)) {
            var ref, ref1;
            let imagesData = [];
            let videoIds = [];
            let pricesData = [];
            let listPrices = [];
            let colorsData = [];
            let variants = [];
            let colorFiles = [];
            let colorNames = [];
            let comboSku = [];
            let orderMessaging = [];
            let discountedPrices = [];
            let discountPercent = [];
            let requiredItemstoInstall = [];
            let availableColors = [];
            let colors = [];
            let productSummary = [];
            let productGalleryLabel = [];
            let orderSample = [];
            let productSelectYourStyle = [];
            let soldByBox = 1;
            let soldByUom = [];
            let variantIds = [];
            let disContinuedColors = [];
            let customerSkus = [];
            let isType = [];
            let isRegionSoldOnline = false;
            let regionSoldOnline = [];
            let styleOptionsNotPresent = false;
            // get list of variants
            if (productDetailData["variantList.sku_ss"]) {
                variants = productDetailData["variantList.sku_ss"];
            }
            // get list of variant colors
            if (productDetailData["Color.SKU.Details_ss"]) {
                colors = productDetailData["Color.SKU.Details_ss"].map((color)=>{
                    const d = color.split("|");
                    return {
                        name: d[0],
                        swatch: d[1],
                        sku: d[2],
                        isStock: d[3],
                        discontinued: !(d[4] === "false" || Date.parse(d[4]) > Date.now()),
                        customerSku: d[5],
                        finishName: d[6]
                    };
                });
            }
            // get list of variant Ids
            if (productDetailData["variantList.variantId_is"]) {
                variantIds = productDetailData["variantList.variantId_is"];
            }
            // get list of variant color files
            if (productDetailData["SKUColorSwatchFilename_ss"]) {
                colorFiles = productDetailData["SKUColorSwatchFilename_ss"];
            }
            // get list of variant finish names
            if (productDetailData["SKUColorFinishName_ss"]) {
                colorNames = productDetailData["SKUColorFinishName_ss"];
            }
            // get required items to install
            if (productDetailData["ProductRequiredAccessoryGroup_ss"]) requiredItemstoInstall = productDetailData["ProductRequiredAccessoryGroup_ss"];
            // get Youtube Url's
            if (productDetailData["ProductYoutubeID_s"]) {
                videoIds = productDetailData["ProductYoutubeID_s"].split("|").map((v)=>({
                        type: "video",
                        url: v
                    }));
            }
            setVideoIds(videoIds);
            setColorFiles(colorFiles);
            setColorNames(colorNames);
            //Get the product gallery new and exclusive label.
            productGalleryLabel["productExclusive"] = productDetailData["ProductExclusive_s"] ? productDetailData["ProductExclusive_s"] : "";
            //Get data for Product Summary component.
            productSummary["ProductPageTitle_s"] = productDetailData["ProductPageTitle_s"] ? productDetailData["ProductPageTitle_s"] : "";
            productSummary["productName_s"] = get_default()(productDetailData, "productName_s", "");
            productSummary["ProductDesigner_s"] = get_default()(productDetailData, "ProductDesigner_s", "");
            productSummary["priceListPersona"] = productDetailData["PriceList".concat(persona, ".displayProductFinalPrice_s")] ? productDetailData["PriceList".concat(persona, ".displayProductFinalPrice_s")] : "";
            productSummary["ProductDescriptionProductShort_s"] = productDetailData["ProductDescriptionProductShort_s"] ? productDetailData["ProductDescriptionProductShort_s"] : "";
            productSummary["ProductDescriptionSmall_s"] = productDetailData["ProductDescriptionSmall_s"] ? productDetailData["ProductDescriptionSmall_s"] : "";
            productSummary["SKUSamples_ss"] = productDetailData["SKUSamples_ss"] ? productDetailData["SKUSamples_ss"] : "";
            productSummary["SKUBadgeInfo_ss"] = [];
            productSummary["LeadTimeRange_s"] = get_default()(productDetailData, "LeadTimeRange_s", "");
            productSummary["noBadge_b"] = get_default()(productDetailData, "noBadge_b", "");
            productSummary["SKUInventoryStatus_s"] = get_default()(productDetailData, "SKUInventoryStatus_s", "");
            productSummary["SKUAnnSacksNonStock_b"] = get_default()(productDetailData, "SKUAnnSacksNonStock_b", "");
            productSummary["ProductASLeadTimeCopy_s"] = get_default()(productDetailData, "ProductASLeadTimeCopy_s", "");
            //Get data for Product Select Your Style component.
            productSelectYourStyle["colorDetails"] = get_default()(productDetailData, "Color.SKU.Details_ss", "");
            setProductSummary(productSummary);
            productSelectYourStyle["colorFamily"] = get_default()(productDetailData, "Color.Family.SKU.Details", "");
            productSelectYourStyle["finishPopUpData"] = productDetailData["Color.Family.Count.Details"] ? productDetailData["Color.Family.Count.Details"] : "";
            productSelectYourStyle["ProductDescriptionDetail_s"] = productDetailData["ProductDescriptionDetail_s"] ? productDetailData["ProductDescriptionDetail_s"] : "";
            productSelectYourStyle["finishType"] = get_default()(productDetailData, "colorFinishTypeList_ss", "");
            productSelectYourStyle["colorFinishTypeDetails"] = get_default()(productDetailData, "Color.Finish.Type.Details_ss", "");
            productSelectYourStyle["selectMoreTooltipData"] = selectMoreTooltipData;
            productSelectYourStyle["currentSku"] = selectedSku;
            setProductSelectYourStyle(productSelectYourStyle);
            //Get order sample data
            orderSample["sampleSKUList_ss"] = productDetailData["sampleSKUList_ss"] ? productDetailData["sampleSKUList_ss"] : "";
            setOrderSample(orderSample);
            if (cart.lineItems && cart.lineItems.length > 0) {
                cart.lineItems.filter((item)=>item.productSlug["en-US"] === slug).map((product)=>{
                    if (product.discountedPrice) {
                        var ref, ref1, ref2, ref3, ref4;
                        discountedPrices[product.variant.sku] = Number((product.discountedPrice.value.centAmount / 100).toFixed(2));
                        let percentOff;
                        if (((ref1 = product === null || product === void 0 ? void 0 : (ref = product.discountedPrice) === null || ref === void 0 ? void 0 : ref.includedDiscounts[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.discount) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.obj) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.value) === null || ref4 === void 0 ? void 0 : ref4.type) === "absolute") {
                            percentOff = get_default()(product.discountedPrice, "includedDiscounts[0].discount.obj.value.money[0].centAmount", 0);
                            isType[product.variant.sku] = "absolute";
                        } else {
                            percentOff = get_default()(product.discountedPrice, "includedDiscounts[0].discount.obj.value.permyriad", 0);
                            isType[product.variant.sku] = "relative";
                        }
                        discountPercent[product.variant.sku] = percentOff > 0 ? Number(percentOff / 100) : 0;
                    }
                });
            }
            let variantImages = productDetailData["productImages.labelWithUrl_ss"];
            let variantImageLabels = [];
            let variantImageURLs = [];
            let variantResourceCredits = [];
            let lifeStyleVariantImageLabels = [];
            let lifeStyleVariantImageURLs = [];
            let lifeStyleVariantResourceCredits = [];
            let variantImageTemplates = [];
            let lifeStyleVariantTemplates = [];
            if (variantImages && variantImages.length > 0) {
                variantImages.map((img)=>{
                    var ref;
                    let imgDetail = img.split("|");
                    if (selectedSku === imgDetail[0]) {
                        variantImageLabels.push(imgDetail[1] + "|" + imgDetail[2]);
                        variantResourceCredits.push(imgDetail[3] ? imgDetail[3] : "");
                        variantImageTemplates.push("LandscapeCategory");
                        let _urlIndex = imgDetail.length - 1;
                        if (imgDetail[_urlIndex] && imgDetail[_urlIndex].indexOf("http") > -1) {
                            variantImageURLs.push(imgDetail[_urlIndex]);
                        } else {
                            variantImageURLs.push(image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src);
                        }
                    }
                    if ((ref = imgDetail[0]) === null || ref === void 0 ? void 0 : ref.startsWith("IMGV")) {
                        lifeStyleVariantImageLabels.push(imgDetail[1] + "|" + imgDetail[2]);
                        lifeStyleVariantResourceCredits.push(imgDetail[3] ? imgDetail[3] : "");
                        lifeStyleVariantTemplates.push("Lifestyle");
                        let _urlIndex1 = (imgDetail === null || imgDetail === void 0 ? void 0 : imgDetail.length) - 1;
                        if (imgDetail[_urlIndex1] && imgDetail[_urlIndex1].indexOf("http") > -1) {
                            lifeStyleVariantImageURLs.push(imgDetail[_urlIndex1]);
                        } else {
                            lifeStyleVariantImageURLs.push(image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src);
                        }
                    }
                });
                if (variantImageURLs.length < 1) {
                    variantImageLabels.push(selectedSku);
                    variantImageURLs.push(image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src);
                    variantResourceCredits.push("");
                }
            } else {
                variantImageLabels.push(selectedSku);
                variantImageURLs.push(image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src);
                variantResourceCredits.push("");
            }
            imagesData[selectedSku] = formatImages(variantImageLabels, variantImageURLs, variantResourceCredits, variantImageTemplates);
            imagesData["lifeStyleImageVariants"] = formatImages(lifeStyleVariantImageLabels, lifeStyleVariantImageURLs, lifeStyleVariantResourceCredits, lifeStyleVariantTemplates);
            setImagesData(imagesData);
            //Get the product gallery photo credit label by-default.
            productGalleryLabel["resourceCredit_s"] = imagesData[selectedSku][0].resourceCredits ? imagesData[selectedSku][0].resourceCredits : "";
            productGalleryLabel["newTag"] = "";
            productGalleryLabel["isSale"] = "";
            setProductGalleryLabel(productGalleryLabel);
            for(let i = 0; i < variants.length; i++){
                const variantSku = variants[i];
                if ((allVariantsDetails === null || allVariantsDetails === void 0 ? void 0 : allVariantsDetails.length) > 0) {
                    if (allVariantsDetails[0][variantSku] !== undefined) {
                        if (selectedSku === variantSku) {
                            soldByUom = allVariantsDetails[0][variantSku]["SKUPiecesperUOM_s"] !== undefined ? allVariantsDetails[0][variantSku]["SKUPiecesperUOM_s"] : "";
                            soldByBox = allVariantsDetails[0][variantSku]["SKUPiecesperBOX_s"] !== undefined ? allVariantsDetails[0][variantSku]["SKUPiecesperBOX_s"] : 1;
                            // Previously it was SKUReleaseforShipment_dt and now it is RegionLaunchDate_dt and this was modified for AS-8579
                            let sKUReleaseforShipmentdt = allVariantsDetails[0][variantSku]["RegionLaunchDate_dt"] !== undefined ? allVariantsDetails[0][variantSku]["RegionLaunchDate_dt"] : "";
                            productGalleryLabel["newTag"] = sKUReleaseforShipmentdt !== "" ? getDateInSixMonth(sKUReleaseforShipmentdt, Date.now()) : "";
                            productGalleryLabel["isSale"] = get_default()(productDetailData, "priceList.".concat(persona, ".saleOffer_s"), "");
                            styleOptionsNotPresent = allVariantsDetails[0][variantSku]["styleOptionsNotPresent_b"] !== undefined;
                            if (allVariantsDetails[0][variantSku]["SKUBadgeInfo_ss"] !== undefined) {
                                productSummary["SKUBadgeInfo_ss"] = allVariantsDetails[0][variantSku]["SKUBadgeInfo_ss"] ? allVariantsDetails[0][variantSku]["SKUBadgeInfo_ss"] : "";
                            }
                        }
                        setState((prevState)=>({
                                ...prevState,
                                soldByBox,
                                soldByUom,
                                productSummary,
                                styleOptionsNotPresent
                            }));
                        orderMessaging[i] = {
                            id: variantSku,
                            backOrderData: allVariantsDetails[0][variantSku]["RegionOnBackOrder_s"] !== undefined ? allVariantsDetails[0][variantSku]["RegionOnBackOrder_s"] : "No",
                            specialOrderData: allVariantsDetails[0][variantSku]["SKUSpecialOrder_s"] !== undefined ? allVariantsDetails[0][variantSku]["SKUSpecialOrder_s"] : "No"
                        };
                    }
                }
                if (ctData.masterVariant) {
                    var ref2, ref3, ref4, ref5, ref6;
                    let product = {};
                    if (variantSku === ctData.masterVariant.sku) product = ctData.masterVariant;
                    else product = ctData.variants.find((variant)=>variantSku === variant.sku);
                    // Get variant prices from CT data
                    let priceObj = product === null || product === void 0 ? void 0 : (ref2 = product.prices) === null || ref2 === void 0 ? void 0 : ref2.find((price)=>{
                        var ref, ref1, ref2;
                        return ((ref = price.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && ((ref1 = price.customerGroup) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.obj) === null || ref2 === void 0 ? void 0 : ref2.key) === persona;
                    });
                    if (!(priceObj === null || priceObj === void 0 ? void 0 : priceObj.value)) priceObj = product === null || product === void 0 ? void 0 : (ref3 = product.prices) === null || ref3 === void 0 ? void 0 : ref3.find((price)=>{
                        var ref;
                        return ((ref = price.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && !price.customerGroup;
                    });
                    var ref7;
                    pricesData[variantSku] = Number((((ref7 = priceObj === null || priceObj === void 0 ? void 0 : (ref4 = priceObj.value) === null || ref4 === void 0 ? void 0 : ref4.centAmount) !== null && ref7 !== void 0 ? ref7 : 0) / 100).toFixed(2));
                    if (discountedPrices[variantSku] === 0 || !discountedPrices[variantSku]) {
                        var ref8, ref9, ref10, ref11, ref12;
                        var ref13;
                        discountedPrices[variantSku] = Number((((ref13 = priceObj === null || priceObj === void 0 ? void 0 : (ref8 = priceObj.discounted) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.value) === null || ref9 === void 0 ? void 0 : ref9.centAmount) !== null && ref13 !== void 0 ? ref13 : 0) / 100).toFixed(2));
                        if ((priceObj === null || priceObj === void 0 ? void 0 : (ref10 = priceObj.discounted) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.discount) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.obj) === null || ref12 === void 0 ? void 0 : ref12.value.type) === "absolute") {
                            var ref14, ref15, ref16, ref17, ref18;
                            var ref19;
                            discountPercent[variantSku] = Number(((ref19 = (ref18 = priceObj === null || priceObj === void 0 ? void 0 : (ref14 = priceObj.discounted) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.discount) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.obj) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.value) === null || ref17 === void 0 ? void 0 : ref17.money[0]) === null || ref18 === void 0 ? void 0 : ref18.centAmount) !== null && ref19 !== void 0 ? ref19 : 0) / 100);
                            isType[variantSku] = "absolute";
                        } else {
                            var ref20, ref21, ref22, ref23;
                            var ref24;
                            discountPercent[variantSku] = Number(((ref24 = priceObj === null || priceObj === void 0 ? void 0 : (ref20 = priceObj.discounted) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.discount) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.obj) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.value) === null || ref23 === void 0 ? void 0 : ref23.permyriad) !== null && ref24 !== void 0 ? ref24 : 0) / 100);
                            isType[variantSku] = "relative";
                        }
                    }
                    const listPrice = product === null || product === void 0 ? void 0 : (ref5 = product.prices) === null || ref5 === void 0 ? void 0 : ref5.find((price)=>{
                        var ref;
                        return ((ref = price.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && !price.customerGroup;
                    });
                    var ref25;
                    listPrices[variantSku] = Number((((ref25 = listPrice === null || listPrice === void 0 ? void 0 : (ref6 = listPrice.value) === null || ref6 === void 0 ? void 0 : ref6.centAmount) !== null && ref25 !== void 0 ? ref25 : 0) / 100).toFixed(2));
                    setListPrices(listPrices);
                    // Check if variant is a Combo SKU
                    comboSku[variantSku] = (product === null || product === void 0 ? void 0 : product.attributes.find((attr)=>attr.name === "ComboSKU")) ? true : false;
                    // Check if RegionSoldOnline
                    const isOnline = "";
                    regionSoldOnline[variantSku] = isOnline;
                    isRegionSoldOnline = isOnline;
                    setComboSku(comboSku);
                    setRegionSoldOnline(regionSoldOnline);
                }
                setPricesData(pricesData);
            }
            // get data related to each color variant
            colors.forEach((color)=>{
                const colorObj = {
                    id: color.sku,
                    name: "product-color",
                    value: color.sku,
                    label: color.name,
                    colorUrl: color.swatch !== "N/A" ? constants["default"].COLOR_FILE_URL + color.swatch : color.swatch,
                    checked: color.sku === selectedSku ? true : false,
                    discontinuedColor: color.discontinued,
                    finishName: color.finishName
                };
                color.discontinued ? disContinuedColors.push(colorObj) : availableColors.push(colorObj);
                customerSkus[color.sku] = color.customerSku;
            });
            const isDisContinuedColor = (ref = colors.find((color)=>color.sku === selectedSku)) === null || ref === void 0 ? void 0 : ref.discontinued;
            colorsData = isDisContinuedColor ? disContinuedColors : availableColors;
            var _id;
            if (availableColors && availableColors[0]) setAvailableColorFirstSku((_id = availableColors[0].id) !== null && _id !== void 0 ? _id : "");
            setAvailableColors(availableColors);
            var ref26;
            const pdprops = {
                sku: selectedSku,
                customerFacingSKU: customerSkus[selectedSku],
                name: isParts ? get_default()(productDetailData, "productName_s", "") : get_default()(productDetailData, "ProductBrandName_s", ""),
                desc: get_default()(productDetailData, "ProductDescriptionProductShort_s", ""),
                customerBrandName: get_default()(productDetailData, "CustomerFacingBrand_s", ""),
                currencySign: currencySign,
                discontinuedProduct: get_default()(productDetailData, "productRegionAllVariantDiscontinued_b", false),
                ProductRequiredAccessoriesGroupsList: get_default()(productDetailData, "ProductProductRecommendedAccessories_ss", []),
                stickyHeaderProps: {
                    productSku: selectedSku,
                    title: isParts ? get_default()(productDetailData, "productName_s", "") : get_default()(productDetailData, "ProductBrandName_s", ""),
                    description: get_default()(productDetailData, "ProductDescriptionProductShort_s", ""),
                    itemStatus: "available",
                    color: {
                        label: get_default()(colorsData.find((item)=>item.id === selectedSku), "label", ""),
                        url: get_default()(colorsData.find((item)=>item.id === selectedSku), "colorUrl", "")
                    }
                },
                requiredItems: requiredItemstoInstall !== null && requiredItemstoInstall !== void 0 ? requiredItemstoInstall : [],
                productOnStock: availableStock,
                colorsData,
                addToCartProps: {
                    compareChecked: Boolean(comparedProducts === null || comparedProducts === void 0 ? void 0 : comparedProducts.find((prod)=>masterSku === prod["masterSKU_s"])),
                    backOrder: get_default()(orderMessaging.find((item)=>{
                        return (item === null || item === void 0 ? void 0 : item.id) === selectedSku;
                    }), "backOrderData", "No"),
                    specialOrder: get_default()(orderMessaging.find((item)=>{
                        return (item === null || item === void 0 ? void 0 : item.id) === selectedSku;
                    }), "specialOrderData", "No")
                },
                detailsProps: {
                    length: get_default()(productDetailData, "ProductOverallLengthInches_s", 0),
                    width: get_default()(productDetailData, "ProductOverallWidthInches_s", 0),
                    height: get_default()(productDetailData, "ProductOverallHeightInches_s", 0),
                    dimensionUnit: "in",
                    detailsData: get_default()(productDetailData, "ProductWebFeatures_ss", [])
                },
                productIsRetail: get_default()(productDetailData, "ProductIsRetail", false),
                businessUnitName: get_default()(productDetailData, "category1_s", ""),
                productSaleable: true,
                superSku,
                productCollectionsName: get_default()(productDetailData, "ProductBrandNameDisplay_s", ""),
                ProductPriceSpiderIncluded_s: (productDetailData === null || productDetailData === void 0 ? void 0 : productDetailData.ProductPriceSpiderIncluded_s) === "true" ? true : false,
                globalDiscount: Number((pricesData[selectedSku] - get_default()(productDetailData, "priceList.".concat(persona, ".finalPrice_d"), pricesData[selectedSku])).toFixed(2)),
                freightPolicyType: get_default()(productDetailData, "ProductFreightPolicyType_s", ""),
                productPartnerBuyNow: false,
                isFavorite: (ref26 = favorites === null || favorites === void 0 ? void 0 : (ref1 = favorites.lineItems) === null || ref1 === void 0 ? void 0 : ref1.some((obj)=>{
                    var ref;
                    return (obj === null || obj === void 0 ? void 0 : (ref = obj.variant) === null || ref === void 0 ? void 0 : ref.sku) === selectedSku;
                })) !== null && ref26 !== void 0 ? ref26 : false,
                favItem: favorites,
                ctData: ctData.id
            };
            if (pdprops.ProductPriceSpiderIncluded_s || isDisContinuedColor || !isRegionSoldOnline) {
                if (pdprops.ProductPriceSpiderIncluded_s) {
                    pdprops.productPartnerBuyNow = true;
                }
                pdprops.productSaleable = false;
            }
            setPdprops(pdprops);
            //Get badge values for product
            const shipmentDate = get_default()(productDetailData, "RegionLaunchDate_dt", "");
            const badgesProps = {
                isNewProduct: (0,helper/* showNewBadge */.ZTk)(shipmentDate),
                badgeVal: get_default()(productDetailData, "priceList.".concat(persona, ".saleOffer_s"), ""),
                exclusiveBadge: get_default()(productDetailData, "ProductExclusive_s", "")
            };
            setBadgesProps(badgesProps);
            setDiscountedPrices(discountedPrices);
            setDiscountPercent(discountPercent);
            setIsType(isType);
            const saleDetailsSS = productDetailData["Sale.".concat(persona, ".Details_ss")];
            const selectedSkuSaleDetails = saleDetailsSS === null || saleDetailsSS === void 0 ? void 0 : saleDetailsSS.find((saleDetail)=>{
                return (saleDetail === null || saleDetail === void 0 ? void 0 : saleDetail.split("|")[0]) === selectedSku;
            });
            setShowSaleBadge((selectedSkuSaleDetails === null || selectedSkuSaleDetails === void 0 ? void 0 : selectedSkuSaleDetails.split("|")[1]) === "Yes");
        }
    }, [
        productDetailData,
        allVariantsDetails,
        selectedSku,
        ctData,
        favorites
    ]);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(authorData) && !isEmpty_default()(general)) {
            const { presetConfigs ="{}"  } = authorData !== null && authorData !== void 0 ? authorData : {
                presetConfigs: "{}"
            };
            const presetConfigObject = JSON.parse(presetConfigs);
            setPresetConfigObject(presetConfigObject);
        }
    }, [
        authorData,
        general
    ]);
    (0,react.useEffect)(()=>{
        if (productCollection && productLocalCategory && isCollapsedPDP) {
            getOptions();
        }
    }, [
        productCollection,
        productLocalCategory,
        isCollapsedPDP,
        productDetailData
    ]);
    (0,react.useEffect)(()=>{
        setSlug(slugProp);
    }, [
        slugProp
    ]);
    const fetchSkuFromUrl = ()=>{
        const urlParams = new URLSearchParams(window.location.search);
        const urlSku = (0,helper/* sanitizeDOMString */.TRt)(urlParams.get("skuId"));
        setSelectedSku(urlSku ? urlSku : selectedSku);
    };
    const onPageLoad = ()=>{
        try {
            fetchSkuFromUrl();
            const fl = (0,helper/* getPdpFLs */.C6y)(persona).join(",");
            api/* apim.post */.TH.post("search/pdp/".concat(slug), {
                fl,
                q: "*:*",
                fq: 'language_s:("'.concat(language, '")'),
                collections: lwAppName.toLowerCase(),
                profilename: isParts ? "profile_service_parts_PDP" : "profile_".concat(lwAppName.toLowerCase(), "_PDP"),
                profilename: "profile_".concat(lwAppName.toLowerCase(), "_PDP"),
                search_type: "product_overview"
            }).then((res)=>{
                if (res && res.data) {
                    var ref, ref1;
                    dispatch((0,asPdpSlice/* setAsProductDetails */.Wf)(res.data));
                    const productData = get_default()(res.data, "response.docs[0]", {});
                    if (productData["variantList.sku_ss"]) {
                        getVarientsInfo(productData, productData["variantList.sku_ss"]);
                    }
                    let isCurated = false;
                    var ref2;
                    let productConfiguration = (ref2 = (ref1 = (ref = res.data.response) === null || ref === void 0 ? void 0 : ref.docs[0]) === null || ref1 === void 0 ? void 0 : ref1.ProductConfiguration_ss) !== null && ref2 !== void 0 ? ref2 : false;
                    if (productConfiguration && productConfiguration[0] === "Curated Bath") {
                        isCurated = true;
                    }
                    //Curated Bath Collection
                    const comboSkuDetails = get_default()(res.data, "fusion.ComboSkuDetails", []);
                    //curated bath child combo
                    const childSelectedSku = comboSkuDetails && comboSkuDetails.length > 0 && comboSkuDetails.find((size)=>size.selected_b === true);
                    const childSkuDetails = childSelectedSku.ChildSKUDetails;
                    setState((prevState)=>{
                        return {
                            ...prevState,
                            productDetailData: productData,
                            viewLoader: false,
                            masterSku: get_default()(productData, "masterSKU_s", ""),
                            comboSkuData: comboSkuDetails,
                            childSkuData: childSkuDetails,
                            priceData: {
                                ...priceData,
                                lwAnyPrice: productData["priceList.ANY.price_d"] ? productData["priceList.ANY.price_d"] : ""
                            }
                        };
                    });
                    setTabDetailsUpdate(true);
                    localStorage.setItem("itemFinalPrice", 0);
                    // set product tab details
                    setProductTabDetails(productData, childSkuDetails, comboSkuDetails, isCurated);
                }
                dispatch((0,pdpSlice/* getProductBySlug */.Co)(slug));
            });
        } catch (err) {
            console.log("catch err pdp onPageload");
        }
        getServiceData();
    };
    (0,react.useEffect)(()=>{
        const a = async ()=>{
            if (!_.isEmpty(ctData)) {
                const { customerGroup ="" , fallbackCustomerGroup =""  } = await (0,helper/* getCustomerGroup */.CIf)();
                const masterVariant = get_default()(ctData, "masterVariant", {});
                const variants = get_default()(ctData, "variants", []);
                const allVariants = [
                    ...variants,
                    masterVariant
                ];
                const allAsPrice = (0,helper/* getAsPrice */.mkK)(allVariants, [
                    "stand-alone-price",
                    "prices"
                ], customerGroup, fallbackCustomerGroup, currencyCode);
                setState((prevState)=>({
                        ...prevState,
                        priceData: {
                            ...priceData,
                            ...allAsPrice
                        }
                    }));
            }
        };
        a();
    }, [
        ctData
    ]);
    (0,react.useEffect)(()=>{
        onPageLoad();
    }, [
        lwAppName
    ]);
    const setProductTabDetails = (productData, childSkuDetails, comboSkuDetails, isCurated)=>{
        // TECHNICAL INFORMATION
        let technicalTabs = [];
        if (comboSkuDetails && comboSkuDetails.length > 0) {
            var _Technical;
            const technical = (_Technical = childSkuDetails.Technical) !== null && _Technical !== void 0 ? _Technical : "";
            technicalTabs = technical.map((item)=>({
                    brandName: item.ProductBusinessUnit_ss[0] || "",
                    category: item.ProductLocalCategory_s || "",
                    description: item["ProductWebTechnology_ss"] || "",
                    specSheet: item["ProductResource.SpecPDFFileName.resourceFullWebURL_ss"] || "",
                    installation: item["ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss"] || "",
                    threeDRevit: "",
                    twodDWGPlanView: item["ProductResource.DWGPlanView.resourceFullWebURL_ss"] || "",
                    DXFPlanView: item["ProductResource.DXFPlanView.resourceFullWebURL_ss"] || "",
                    twodFrontView: item["ProductResource.DWGFrontView.resourceFullWebURL_ss"] || "",
                    DXFFrontView: item["ProductResource.DXFFrontView.resourceFullWebURL_ss"] || "",
                    twoDSideView: item["ProductResource.DWGSideView.resourceFullWebURL_ss"] || "",
                    DXFSideView: item["ProductResource.DXFSideView.resourceFullWebURL_ss"] || "",
                    HomeownersGuide: item["ProductResource.HomeownersGuide.resourceFullWebURL_ss"] || ""
                }));
        } else {
            technicalTabs = [
                {
                    description: productData && productData["ProductWebTechnology_ss"] || "",
                    brandName: productData && productData["CustomerFacingBrand_s"] || ""
                }
            ];
        }
        //FEATURES INFORMATION:
        let featureTabs = [];
        if (comboSkuDetails && comboSkuDetails.length > 0) {
            const features = childSkuDetails.Feature || "";
            featureTabs = features && features.map((item)=>({
                    brandName: item.ProductBusinessUnit_ss[0] || "",
                    productLocalCategory: item.ProductLocalCategory_s || "",
                    description: item["ProductWebFeatures_ss"] || ""
                }));
        }
        const asTabDetails = {
            tabData: {
                details: {
                    description: productData && productData["ProductNarrativeDescription_s"] || "",
                    tearSheet: productData && productData["ProductResource.TearSheetPDF.resourceFullWebURL_ss"] || ""
                },
                recommendedUse: {
                    description: productData && productData["ProductWebFeatures_ss"] || ""
                },
                technicalTab: technicalTabs,
                featureTab: featureTabs
            },
            selectedVariantSku: state.selectedSku || productData.masterSKU_s,
            productGenericDescription: productData["ProductDescriptionGeneric_s"] ? productData["ProductDescriptionGeneric_s"] : "",
            priceList: productData["priceList.ANY.price_d"] ? productData["priceList.ANY.price_d"] : "",
            productBrandNameDisplay: productData["ProductBrandNameDisplay_s"],
            isCurated: isCurated
        };
        if (Object.keys(asTabDetailsFromState).length === 0 || tabDetailsUpdate) {
            setTabDetailsUpdate(false);
            dispatch((0,pdpSlice/* getAsTabDetails */.Jy)(asTabDetails));
        }
    };
    const getUserLocation = ()=>{
        (0,helper/* getMyLocation */.fPm)().then((getLocation)=>{
            var _zipcode;
            setState((prevState)=>({
                    ...prevState,
                    userZipCode: (_zipcode = getLocation.zipcode) !== null && _zipcode !== void 0 ? _zipcode : ""
                }, ()=>checkUserZipCode(th.userZipCode)));
        });
    };
    const getServiceData = async ()=>{
        if (!isEmpty_default()(designServiceDataFromProp)) {
            const designServicesSkus = designServiceDataFromProp.map((product)=>{
                if (product.sku) {
                    return product.sku;
                }
            });
            const productData = await (0,helper/* getProductsBySku */.uXU)(designServicesSkus);
            setState((prevState)=>({
                    ...prevState,
                    designServiceData: productData
                }));
        }
        if (!isEmpty_default()(installationDataFromProp)) {
            const installtionSkus = installationDataFromProp.map((list)=>{
                if (list.sku) {
                    return list.sku;
                }
            });
            const getInstallationData = await (0,helper/* getProductsBySku */.uXU)(installtionSkus);
            setState((prevState)=>({
                    ...prevState,
                    installationData: getInstallationData
                }));
            getUserLocation();
        }
    };
    const getVarientsInfo = (productsData, varientId)=>{
        let tmpId = "";
        if (varientId && (varientId === null || varientId === void 0 ? void 0 : varientId.length) > 0) {
            let i;
            for(i = 0; i < varientId.length; i++){
                let tmpVariants = '"' + varientId[i] + '"';
                tmpId = tmpId + tmpVariants + ",";
            }
            tmpId = tmpId != "" ? tmpId.substring(0, tmpId.lastIndexOf(",")) : "";
        }
        api/* apim.post */.TH.post("search/pdp/".concat(slug), {
            q: "*:*",
            fl: "sku_s,slug_s,id,RegionDiscontinuedDate_dt, RegionOnBackOrder_s, RegionStatesExcluded_ss, SKUBadgeInfo_ss, SKUPiecesperBOX_s, SKUPiecesperUOM_s, SKUReleaseforShipment_dt,RegionLaunchDate_dt, RegionSpecialOrder_s, ctId_s, SKUInventoryStatus_s, SKUAnnSacksNonStock_b, noBadge_b, styleOptionsNotPresent_b",
            fq: "sku_s:(".concat(tmpId, '),language_s:("').concat(language, '")'),
            collections: isParts ? "service_parts" : lwAppName.toLowerCase(),
            profilename: isParts ? "profile_service_parts_PDP" : "profile_".concat(lwAppName.toLowerCase(), "_PDP"),
            search_type: "product_overview"
        }).then((variantsResult)=>{
            if (variantsResult && variantsResult.data) {
                var ref;
                const variantsData = get_default()(variantsResult.data, "response.docs", {});
                let tmpVariantsData = [];
                let tmpVariantsInfo = [];
                let k;
                for(k = 0; k < variantsData.length; k++){
                    let tmpSku = variantsData[k]["sku_s"] ? variantsData[k]["sku_s"] : "";
                    if (tmpSku) {
                        tmpVariantsInfo[tmpSku] = variantsData[k];
                    }
                }
                tmpVariantsData.push(tmpVariantsInfo);
                const inventoryStatus = (ref = tmpVariantsInfo[selectedSku]) === null || ref === void 0 ? void 0 : ref.SKUAnnSacksNonStock_b;
                setAllVariantsDetails(tmpVariantsData);
                setSKUInventory(inventoryStatus);
                const sku = selectedSku === "" ? getInitialSku(varientId, productsData["masterSKU_s"], tmpVariantsData) : selectedSku;
                let recommendedAccessories = [];
                if (productsData["ProductProductRecommendedAccessories_ss"]) {
                    recommendedAccessories = productsData["ProductProductRecommendedAccessories_ss"];
                } else if (productsData["ProductProductRecommendedAccessories_s"]) {
                    recommendedAccessories.push(productsData["ProductProductRecommendedAccessories_s"]);
                }
                (0,asPdpSlice/* setAsProductDetails */.Wf)({
                    sku,
                    slug,
                    recommendedAccessories
                });
                dispatch((0,pdpSlice/* setPDP */.qK)({
                    sku,
                    slug,
                    recommendedAccessories
                }));
                setSelectedSku(sku);
                setTabDetailsUpdate(true);
                if (sku) {
                    getAvailableStock(sku);
                }
                window.addEventListener("popstate", ()=>{
                    fetchSkuFromUrl();
                    getAvailableStock(sku);
                    dispatch((0,asPdpSlice/* setAsProductDetails */.Wf)({
                        sku
                    }));
                    dispatch((0,pdpSlice/* setPDP */.qK)({
                        sku
                    }));
                });
            }
        });
    };
    const getInitialSku = (varientId, masterSKU_s, productVariantData)=>{
        let availableSkus = [];
        if ((productVariantData === null || productVariantData === void 0 ? void 0 : productVariantData.length) > 0) {
            let variants = varientId;
            variants.map((variant, i)=>{
                let discontinuedColor = false;
                if (productVariantData[0][variant]) {
                    discontinuedColor = productVariantData[0][variant]["RegionDiscontinuedDate_dt"] !== undefined ? productVariantData[0][variant]["RegionDiscontinuedDate_dt"] !== false && Date.parse(productVariantData[0][variant]["RegionDiscontinuedDate_dt"]) < Date.now() : false;
                }
                if (!discontinuedColor) availableSkus.push(variant);
            });
        }
        var ref;
        return (ref = availableSkus[0]) !== null && ref !== void 0 ? ref : masterSKU_s;
    };
    const getAvailableStock = async (sku)=>{
        if (!disableEcommerce) {
            const count = await (0,utils_cart/* getStock */.K5)(sku).then((qty)=>{
                return qty;
            });
            setAvailableStock(count);
        }
        setLoadShowEvent(true);
    };
    const setSkuVariant = function(sku) {
        let finish = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        if (sku) {
            setTabDetailsUpdate(true);
            setSelectedSku(sku);
        }
        getAvailableStock(sku);
        const url = new URL(window.location.href);
        let searchParams = url.searchParams;
        searchParams.set("skuId", sku);
        finish !== "" ? searchParams.set("finish", finish) : "";
        const urlSearch = "?" + searchParams.toString();
        window.history.replaceState(window.location.pathname, document.title, urlSearch);
        dispatch((0,pdpSlice/* setPDP */.qK)({
            sku
        }));
    };
    const checkProductCategory = ()=>{
        if (compareproductsCategory === productCate || compareproductsCategory === "") {
            return true;
        }
        return false;
    };
    const formatImages = (labels, urls, ResourceCredits, templates)=>{
        const images = [];
        for(let i = 0; i < urls.length; i++){
            var _i;
            images.push({
                label: (_i = labels[i]) !== null && _i !== void 0 ? _i : "",
                url: urls[i],
                resourceCredits: ResourceCredits[i],
                template: templates[i]
            });
        }
        return images;
    };
    const addRequiredItems = (list)=>{
        setReqCartData(list);
    };
    const addToCart = (items, cb)=>{
        let totalAdded = 0;
        items.forEach((item)=>totalAdded += item.quantity);
        let itemCountMessage = totalAdded === 1 ? "(".concat(totalAdded, ") ").concat(staticTexts.itemAdded, " ") : "(".concat(totalAdded, ") ").concat(staticTexts.itemsAdded, " ");
        const ToasterMssg = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    itemCountMessage,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: cartLandingPagePath,
                        children: staticTexts.yourCart
                    }),
                    "."
                ]
            });
        dispatch((0,cartSlice/* addToCart */.Xq)([
            ...items,
            ...reqCartData
        ], true, "", cb, false, null, false, dist_lib/* isMobile */.tq && (window === null || window === void 0 ? void 0 : window.outerWidth) < 1024 ? ()=>showToaster(/*#__PURE__*/ (0,jsx_runtime.jsx)(ToasterMssg, {})) : null));
    };
    const showToaster = (mssg, mobileOnly)=>{
        setState((prevState)=>({
                ...prevState,
                toaster: {
                    show: true,
                    message: mssg,
                    mobileOnly: mobileOnly !== null && mobileOnly !== void 0 ? mobileOnly : false
                }
            }));
        setTimeout(()=>setState((prevState)=>({
                    ...prevState,
                    toaster: {
                        show: false,
                        message: "",
                        mobileOnly: false
                    }
                })), 3000);
    };
    // Get list of available options to be shown under Select More Options
    const getOptions = async ()=>{
        var ref;
        const { data  } = await api/* apim.get */.TH.get("/search/plp", {
            params: {
                fl: "slug_s",
                q: "*:*",
                rows: "1",
                fq: [
                    'Collapse_Field_s:("'.concat(productLocalCategory, " ").concat(productCollection, '")'),
                    "isCollapsedPDP_b:".concat(isCollapsedPDP)
                ],
                profilename: "profile_".concat(lwAppName.toLowerCase(), "_PDP"),
                collections: lwAppName.toLowerCase()
            },
            paramsSerializer: (params)=>{
                return lib_default().stringify(params, {
                    arrayFormat: "repeat",
                    encode: true
                });
            }
        });
        let curOptions = {};
        if (data && (data === null || data === void 0 ? void 0 : (ref = data.facet_counts) === null || ref === void 0 ? void 0 : ref.facet_fields)) {
            var _facet_fields;
            const facets = (_facet_fields = data.facet_counts.facet_fields) !== null && _facet_fields !== void 0 ? _facet_fields : {};
            Object.entries(facets).map((facet)=>{
                if (productDetailData[facet[0]]) {
                    var ref;
                    curOptions[facet[0]] = (ref = productDetailData[facet[0]]) !== null && ref !== void 0 ? ref : "";
                }
            });
            setState((prevState)=>({
                    ...prevState,
                    options: facets,
                    currOptions: curOptions
                }));
        }
        api/* apim.get */.TH.get("/search/tooltip", {
            params: {
                collection: lwAppName.toLowerCase()
            }
        }).then((res)=>{
            if (res && res.data) {
                var _data;
                const tooltipData = (_data = res.data) !== null && _data !== void 0 ? _data : {};
                setState((prevState)=>({
                        ...prevState,
                        selectMoreTooltipData: tooltipData
                    }));
            }
        });
    };
    // Search for product variant based on selected option and redirect to that PDP
    const selectOption = async function(value, facet) {
        let datalayerTitle = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
        const modifiedValue = decodeURIComponent(value).replace(/"/g, '\\"');
        api/* apim.get */.TH.get("/search/plp", {
            params: {
                fl: "slug_s,ProductLocalCategory_s,masterSKU_s,ProductDescriptionProductShort_s,priceList.*.saleOffer_s,priceList.ANY.price_d,Color.SKU.Details_ss,ProductBrandName_s,ProductDetailImageURL_s,productName_s,ProductPriceSpiderIncluded_s, pdp_url_s",
                q: "*:*",
                rows: "1",
                fq: [
                    'ProductBrandNameDisplay_s:("'.concat(productBrandNameDisplay, '")'),
                    'ProductLocalCategory_s:("'.concat(encodeURIComponent(productLocalCategory), '")'),
                    "".concat(facet, ':("').concat(modifiedValue, '")')
                ],
                profilename: "profile_".concat(lwAppName.toLowerCase(), "_PDP"),
                collections: lwAppName.toLowerCase()
            },
            paramsSerializer: (params)=>{
                return lib_default().stringify(params, {
                    arrayFormat: "repeat",
                    encode: false
                });
            }
        }).then(async (result)=>{
            if (datalayerTitle) {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
                const selectedProductInfo = await getSelectedProductInfo(result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : (ref1 = ref.response) === null || ref1 === void 0 ? void 0 : ref1.docs[0]).then((res)=>{
                    return res;
                });
                addDataLayer({
                    title: "".concat(datalayerTitle),
                    shapeVal: ((ref6 = (ref4 = result === null || result === void 0 ? void 0 : (ref2 = result.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.response) === null || ref3 === void 0 ? void 0 : ref3.docs[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4["ProductDetailImageURL_s"]) === null || ref5 === void 0 ? void 0 : ref5.split("|")) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.toLowerCase) === null || ref8 === void 0 ? void 0 : ref8.call(ref7)) || "",
                    productInfo: selectedProductInfo === null || selectedProductInfo === void 0 ? void 0 : selectedProductInfo.toLowerCase()
                });
            }
            if (result) {
                const slug = get_default()(result, "data.response.docs[0].slug_s", "");
                if (slug) {
                    if (productLocalCategory && plpServletPath) {
                        let pdpPageDetails = plpServletPath.find((el)=>el.categories.includes(productLocalCategory));
                        window.location = pdpPageDetails ? (pdpPageDetails === null || pdpPageDetails === void 0 ? void 0 : pdpPageDetails.url) ? (0,helper/* getShortenedUrl */.Ppy)(pdpPageDetails.url + "/" + slug + ".html") : "" : "";
                    }
                }
            }
        });
    };
    const getSelectedProductInfo = async (data)=>{
        var ref, ref1, ref2, ref3;
        let selectedDiscountedPrice, selectedPercentOff, selectedDiscountPercent;
        cart.lineItems.filter((item)=>{
            return item.productSlug["en-US"] === (data === null || data === void 0 ? void 0 : data["slug_s"]);
        }).map((product)=>{
            if (product.discountedPrice) {
                var ref, ref1, ref2, ref3, ref4;
                selectedDiscountedPrice = Number((product.discountedPrice.value.centAmount / 100).toFixed(2));
                if (((ref1 = product === null || product === void 0 ? void 0 : (ref = product.discountedPrice) === null || ref === void 0 ? void 0 : ref.includedDiscounts[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.discount) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.obj) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.value) === null || ref4 === void 0 ? void 0 : ref4.type) === "absolute") {
                    selectedPercentOff = get_default()(product.discountedPrice, "includedDiscounts[0].discount.obj.value.money[0].centAmount", 0);
                } else {
                    selectedPercentOff = get_default()(product.discountedPrice, "includedDiscounts[0].discount.obj.value.permyriad", 0);
                }
                selectedDiscountPercent = selectedPercentOff > 0 ? Number(selectedPercentOff / 100) : 0;
            }
        });
        const selectedColorDetail = data === null || data === void 0 ? void 0 : (ref = data["Color.SKU.Details_ss"]) === null || ref === void 0 ? void 0 : ref.find((color)=>{
            var ref;
            return ((ref = color === null || color === void 0 ? void 0 : color.split("|")) === null || ref === void 0 ? void 0 : ref[2]) === (data === null || data === void 0 ? void 0 : data["masterSKU_s"]);
        });
        const { productCouponCode , productCoupondiscount  } = (0,helper/* getCurrentSkuCouponDiscounts */.mPk)({
            cart,
            sku: data === null || data === void 0 ? void 0 : data["masterSKU_s"]
        });
        const imageUrl = (ref2 = data === null || data === void 0 ? void 0 : (ref1 = data["ProductDetailImageURL_s"]) === null || ref1 === void 0 ? void 0 : ref1.split("|")) === null || ref2 === void 0 ? void 0 : ref2[1];
        const stockCount = await (0,utils_cart/* getStock */.K5)(data === null || data === void 0 ? void 0 : data["masterSKU_s"]).then((qty)=>{
            return qty;
        });
        return JSON.stringify({
            description: (data === null || data === void 0 ? void 0 : data["ProductDescriptionProductShort_s"]) || "n/a",
            frequency: "n/a",
            globalPromotionPrice: Number(selectedDiscountedPrice) || Number(data === null || data === void 0 ? void 0 : data["priceList.ANY.price_d"]) || "n/a",
            isRecommended: "n/a",
            isSendNow: "n/a",
            isSubscription: "n/a",
            priceState: Number(selectedDiscountPercent) > 0 ? "percentOff|" + selectedDiscountPercent : "regular price",
            productBasePrice: Number(data === null || data === void 0 ? void 0 : data["priceList.ANY.price_d"]) || "n/a",
            productCategory: (data === null || data === void 0 ? void 0 : data["ProductLocalCategory_s"]) || "n/a",
            productColor: ((ref3 = selectedColorDetail === null || selectedColorDetail === void 0 ? void 0 : selectedColorDetail.split("|")) === null || ref3 === void 0 ? void 0 : ref3[0]) || "n/a",
            productCoupondiscount: productCoupondiscount,
            productCouponCode: productCouponCode.join("|") || "n/a",
            productID: (data === null || data === void 0 ? void 0 : data["masterSKU_s"]) || "n/a",
            productName: (data === null || data === void 0 ? void 0 : data["productName_s"]) || "n/a",
            productPartnerBuyNow: (data === null || data === void 0 ? void 0 : data["ProductPriceSpiderIncluded_s"]) ? true : false,
            productRoom: (data === null || data === void 0 ? void 0 : data["ProductLocalCategory_s"]) || "n/a",
            productSalePrice: Number(selectedDiscountedPrice) ? Number(selectedDiscountedPrice) : Number(data === null || data === void 0 ? void 0 : data["priceList.ANY.price_d"]) || "n/a",
            productSaleable: (data === null || data === void 0 ? void 0 : data["RegionSoldOnline"]) || "n/a",
            productStatus: stockCount > 0 ? "in stock" : "out of stock",
            productSuperSku: "n/a",
            productTileName: (data === null || data === void 0 ? void 0 : data["productName_s"]) || "n/a",
            quantity: 1,
            defaultImageName: imageUrl || "n/a",
            ratings: "n/a",
            numberOfReviews: "n/a",
            pdpType: (0,helper/* pdpTypeFormat */.V4r)({
                businessUnitName: data === null || data === void 0 ? void 0 : data["ProductLocalCategory_s"],
                ProductPriceSpiderIncluded_s: data === null || data === void 0 ? void 0 : data["ProductPriceSpiderIncluded_s"],
                discontinuedProductb: !(data === null || data === void 0 ? void 0 : data["RegionSoldOnline"]),
                ProductRequiredAccessoriesGroupsList: data === null || data === void 0 ? void 0 : data["ProductRequiredAccessoryGroup_ss"],
                superSku: data === null || data === void 0 ? void 0 : data["masterSKU_s"]
            }),
            productFindingMethod: "n/a",
            productCollectionsName: (data === null || data === void 0 ? void 0 : data["productName_s"]) || "n/a",
            productBrand: (data === null || data === void 0 ? void 0 : data["CustomerFacingBrand_s"]) || "n/a",
            globalOffer: (data === null || data === void 0 ? void 0 : data["priceList.".concat(persona, ".saleOffer_s")]) || "n/a",
            globalDiscount: Number(selectedDiscountedPrice) ? Number(data === null || data === void 0 ? void 0 : data["priceList.ANY.price_d"]) - Number(selectedDiscountedPrice) : 0,
            itemType: (0,helper/* getCartItemType */.Nth)(data === null || data === void 0 ? void 0 : data["ProductLocalCategory_s"], data === null || data === void 0 ? void 0 : data["CustomerFacingBrand_s"])
        });
    };
    const seeAvailableColor = ()=>{
        setSkuVariant(availableColorFirstSku, "");
    };
    const getZipCode = (zipCodeVal)=>{
        setState((prevState)=>({
                ...prevState,
                userZipCode: zipCodeVal
            }, ()=>checkUserZipCode(zipCodeVal)));
    };
    const checkUserZipCode = (userZipCodeVal)=>{
        let newCodes = [];
        zipCodeData.map((codes)=>{
            Object.keys(codes).forEach((key)=>{
                newCodes.push(codes[key].includes(userZipCodeVal));
            });
        });
        setState((prevState)=>({
                ...prevState,
                isNearest: newCodes.find((result)=>result === true) ? true : false
            }));
    };
    const getDateInSixMonth = (productDate, currentDate)=>{
        let newDate = new Date(currentDate);
        let productNewDate = new Date(productDate);
        let dateDiff = new Date(newDate.setMonth(newDate.getMonth() - 6));
        if (dateDiff.getTime() <= productNewDate.getTime()) {
            return "Yes";
        }
        return "";
    };
    const updateRecalculateRoomInfo = (lineItemId, recalculateAdditionalInfo, customQuantity, cb)=>{
        let itemCountMessage = customQuantity > 0 ? "".concat(customQuantity, " ").concat(staticTexts.itemAdded, " ") : "".concat(staticTexts.updateItemsErrorMsg, " ");
        const ToasterMsg = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    itemCountMessage,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: cartLandingPagePath,
                        children: staticTexts.yourCart
                    }),
                    "."
                ]
            });
        (0,helper/* recalculateCartRoomInfo */.NxS)(lineItemId, recalculateAdditionalInfo, Number(window === null || window === void 0 ? void 0 : window.outerWidth) < 1024 ? false : true, cb, dist_lib/* isMobile */.tq && (window === null || window === void 0 ? void 0 : window.outerWidth) < 1024 ? ()=>showToaster(/*#__PURE__*/ (0,jsx_runtime.jsx)(ToasterMsg, {})) : null);
    };
    return !isEmpty_default()(productDetailData) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ProductDetailView, {
        ...pdprops,
        RegionUOM: productDetailData === null || productDetailData === void 0 ? void 0 : productDetailData["RegionAltUOM_s"],
        productImages: productDetailData["productImages.labelWithUrl_ss"],
        persona: isParts ? null : persona,
        toaster: toaster,
        staticTexts: staticTexts,
        options: options,
        currOptions: currOptions,
        productCategoryType: productCate,
        isComboSku: comboSku[selectedSku],
        imagesData: [
            ...Object.values(imagesData[selectedSku] || []),
            ...Object.values(imagesData["lifeStyleImageVariants"] || []),
            ...videoIds
        ],
        isRegionSoldOnline: regionSoldOnline[selectedSku],
        badgesProps: badgesProps,
        price: (0,helper/* getAsFinalPrice */.OIu)(priceData[[
            selectedSku
        ]], null),
        pricePerBox: pricesData[selectedSku],
        listPrice: listPrices[selectedSku],
        discountedPrice: (0,helper/* getAsFinalPrice */.OIu)(priceData[[
            selectedSku
        ]], true),
        discountedPricePerBox: discountedPrices[selectedSku],
        discountPercent: discountPercent[selectedSku],
        setSkuVariant: (sku, finish)=>setSkuVariant(sku, finish),
        selectOption: (val, facet, datalayerTitle)=>selectOption(val, facet, datalayerTitle),
        getStock: ()=>(0,utils_cart/* getStock */.K5)(selectedSku),
        onAddToCart: (cartValue, cb)=>addToCart(cartValue, cb),
        onAddToCompare: ()=>(0,product/* addToCompareProduct */.dX)(selectedSku, productDetailData, lwAppName, persona, compareSectionData),
        onRemoveFromCompare: ()=>(0,product/* removeFromCompareProduct */.Zj)(selectedSku),
        checkProductCategory: ()=>checkProductCategory(),
        comparedProductsCount: comparedProducts === null || comparedProducts === void 0 ? void 0 : comparedProducts.length,
        isEnable: isEnable,
        findProPagePath: findProPagePathUrl,
        locale: locale,
        currencySign: currencySign,
        currencyCode: currencyCode,
        addItemsToCart: (list)=>addRequiredItems(list),
        showToaster: (mssg, mob)=>showToaster(mssg, mob),
        onAvailableColor: ()=>seeAvailableColor(),
        overSizedType: overSizedType,
        userZipCode: userZipCode,
        isNearest: isNearest,
        cart: cart,
        getZipCode: (zipCodeVal)=>getZipCode(zipCodeVal),
        servicesData: servicesData,
        installationData: installationData,
        designServiceData: designServiceData,
        installationDataFromProp: installationDataFromProp,
        designServiceDataFromProp: designServiceDataFromProp,
        findStoreUrl: findStorePagePath,
        promoTitle: promoTitle,
        promoDescription: state.promoDescription,
        enablePromo: state.enablePromo,
        productSummaryDetails: productSummary,
        productGalleryLabel: productGalleryLabel,
        soldByBox: soldByBox,
        soldByUom: soldByUom,
        orderSample: orderSample,
        brandNameDisplay: productBrandNameDisplay,
        ProductLocalCategory_s: productLocalCategory,
        productCollection: productCollection,
        productSelectYourStyle: productSelectYourStyle || {},
        customLabel: {
            ...staticTexts,
            ...authorData
        },
        authorData: {
            ...staticTexts,
            ...authorData
        },
        availableColors: availableColors,
        selectMoreTooltipData: selectMoreTooltipData,
        isType: isType[selectedSku],
        updateRecalculateRoomInfo: (lineItemId, recalculateAdditionalInfo, customQuantity, cb)=>updateRecalculateRoomInfo(lineItemId, recalculateAdditionalInfo, customQuantity, cb),
        ...props,
        presetConfig: presetConfigObject,
        swatchUrl: swatchUrl,
        SKUInventory: SKUInventory,
        comboSkuDetails: comboSkuData,
        priceData: priceData,
        pdpData: authorData,
        isCollapsedPDP: isCollapsedPDP,
        config: config,
        loadShowEvent: loadShowEvent,
        showSaleBadge: showSaleBadge,
        styleOptionsNotPresent: state === null || state === void 0 ? void 0 : state.styleOptionsNotPresent
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ProgressiveLoader, {
        loaderData: {
            ...authorData,
            ...pdpData
        }
    });
};
/* harmony default export */ var ProductDetail = (ProductOverview);

// EXTERNAL MODULE: ./public/icons/PDF-ANN.svg
var PDF_ANN = __webpack_require__(70315);
// EXTERNAL MODULE: ./public/icons/download-dark-gray.svg
var download_dark_gray = __webpack_require__(91883);
;// CONCATENATED MODULE: ./components/ProductDetail/v1/ProductTabDetail/TabDetails.jsx





const TabDetails = (props)=>{
    const { detailsData , productBrandName , productInfo  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "content-row",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-text",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: detailsData === null || detailsData === void 0 ? void 0 : detailsData.description
                })
            }),
            (detailsData === null || detailsData === void 0 ? void 0 : detailsData.tearSheet) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-pdf pdfList",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "files",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        title: productBrandName,
                        href: detailsData === null || detailsData === void 0 ? void 0 : detailsData.tearSheet,
                        target: "_blank",
                        className: "uploadFile",
                        rel: "noreferrer",
                        onClick: ()=>{
                            var ref;
                            analytics_addDataLayer({
                                title: "file download",
                                url: detailsData === null || detailsData === void 0 ? void 0 : (ref = detailsData.tearSheet) === null || ref === void 0 ? void 0 : ref[0],
                                isDetailsTab: true,
                                productInfo,
                                eventStatus: "success",
                                pdfProps: {
                                    isPdf: true,
                                    fileName: "".concat(productBrandName.toLowerCase()),
                                    pdf_Data: JSON.stringify({
                                        fileNameAndFileType: "".concat(productBrandName.toLowerCase() + ".pdf")
                                    })
                                }
                            });
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "pdfWrapper",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: PDF_ANN/* default */.Z === null || PDF_ANN/* default */.Z === void 0 ? void 0 : PDF_ANN/* default.src */.Z.src
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: productBrandName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: download_dark_gray/* default */.Z === null || download_dark_gray/* default */.Z === void 0 ? void 0 : download_dark_gray/* default.src */.Z.src
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var ProductTabDetail_TabDetails = (TabDetails);

;// CONCATENATED MODULE: ./public/icons/2d-side-gray.svg
/* harmony default export */ var _2d_side_gray = ({"src":"/_next/static/media/2d-side-gray.d069beba.svg","height":25,"width":22});
;// CONCATENATED MODULE: ./public/icons/external-link.svg
/* harmony default export */ var external_link = ({"src":"/_next/static/media/external-link.584bde94.svg","height":16,"width":15});
;// CONCATENATED MODULE: ./components/ProductDetail/v1/ProductTabDetail/TabTechnical.jsx










const TabTechnical = (param)=>{
    let { technicalData , staticTexts , authorData , isCurated , productInfo  } = param;
    const { dwg , dxf  } = staticTexts;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "title-info tech-info",
        children: technicalData && technicalData.length > 0 && technicalData.map((technical, index)=>{
            if (technical.description && technical.description.length > 0 || technical.specSheet && technical.specSheet.length > 0 || technical.installation && technical.installation.length > 0 || technical.threeDRevit && technical.threeDRevit.length > 0 || technical.twodDWGPlanView && technical.twodDWGPlanView.length > 0 || technical.DXFPlanView && technical.DXFPlanView.length > 0 || technical.twodFrontView && technical.twodFrontView.length > 0 || technical.DXFFrontView && technical.DXFFrontView.length > 0 || technical.twoDSideView && technical.twoDSideView.length > 0 || technical.DXFSideView && technical.DXFSideView.length > 0 || technical.HomeownersGuide && technical.HomeownersGuide.length > 0) {
                var ref, ref1;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: technical.brandName ? "info-row info-row-content" : "info-row-content",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "cont-col",
                            children: [
                                isCurated && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "title",
                                    children: "".concat(technical.brandName || "", " ").concat(technical.category || "")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    children: technical.description && ((ref = technical.description) === null || ref === void 0 ? void 0 : ref.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: item
                                        }, i)))
                                }),
                                ((ref1 = authorData.wetFlooring) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && authorData.wetFlooring.filter((brand)=>{
                                    var ref, ref1;
                                    return ((ref = brand.businessUnit) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === ((ref1 = technical.brandName) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase());
                                }).map((matchingBrand, index)=>{
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                        className: "wetfloor",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "wetFlooringTitle",
                                                children: matchingBrand.title ? matchingBrand.title : ""
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "link-block",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: external_link === null || external_link === void 0 ? void 0 : external_link.src,
                                                        className: "linkicon"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: matchingBrand.link ? matchingBrand.link : "javascript:void(0)",
                                                        target: "_blank",
                                                        title: matchingBrand.title ? matchingBrand.title : "",
                                                        className: "link",
                                                        onClick: ()=>{
                                                            var ref, ref1;
                                                            analytics_addDataLayer({
                                                                title: matchingBrand === null || matchingBrand === void 0 ? void 0 : (ref = matchingBrand.label) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
                                                                isTechnicalTab: true,
                                                                productInfo,
                                                                url: "".concat((window === null || window === void 0 ? void 0 : (ref1 = window.location) === null || ref1 === void 0 ? void 0 : ref1.origin) + (matchingBrand === null || matchingBrand === void 0 ? void 0 : matchingBrand.link))
                                                            });
                                                        },
                                                        children: matchingBrand.label ? matchingBrand.label : ""
                                                    })
                                                ]
                                            })
                                        ]
                                    }, "matchingBrand-".concat(index));
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "pdf-col",
                            children: [
                                technical.specSheet && technical.specSheet.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "files",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                className: "heading",
                                                children: staticTexts.specification
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                href: technical.specSheet,
                                                target: "_blank",
                                                className: "uploadFile",
                                                rel: "noreferrer",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "pdfWrapper",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: PDF_ANN/* default */.Z === null || PDF_ANN/* default */.Z === void 0 ? void 0 : PDF_ANN/* default.src */.Z.src
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: staticTexts.specsSheet
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: download_dark_gray/* default */.Z === null || download_dark_gray/* default */.Z === void 0 ? void 0 : download_dark_gray/* default.src */.Z.src
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                technical.installation && technical.installation.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "files",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            className: "heading",
                                            children: staticTexts.Installation ? staticTexts.Installation : ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            href: technical.installation,
                                            target: "_blank",
                                            className: "uploadFile",
                                            rel: "noreferrer",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "pdfWrapper",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: PDF_ANN/* default */.Z === null || PDF_ANN/* default */.Z === void 0 ? void 0 : PDF_ANN/* default.src */.Z.src
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: staticTexts.Installation ? staticTexts.Installation : ""
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: download_dark_gray/* default */.Z === null || download_dark_gray/* default */.Z === void 0 ? void 0 : download_dark_gray/* default.src */.Z.src
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                technical.threeDRevit || technical.twodDWGPlanView || technical.DXFPlanView || technical.twodFrontView || technical.DXFFrontView || technical.twoDSideView || technical.DXFSideView ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "files drawing_pdf",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            className: "heading",
                                            children: staticTexts.cadDrawings ? staticTexts.cadDrawings : ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "items",
                                            children: [
                                                technical.threeDRevit && technical.threeDRevit.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    href: technical.threeDRevit[0],
                                                    target: "_blank",
                                                    className: "uploadFile",
                                                    rel: "noreferrer",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: "pdfWrapper",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: download_dark_gray/* default */.Z === null || download_dark_gray/* default */.Z === void 0 ? void 0 : download_dark_gray/* default.src */.Z.src
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: staticTexts.threeDfile ? staticTexts.threeDfile : ""
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: download_dark_gray/* default */.Z === null || download_dark_gray/* default */.Z === void 0 ? void 0 : download_dark_gray/* default.src */.Z.src
                                                        })
                                                    ]
                                                }),
                                                technical.twodDWGPlanView && technical.twodDWGPlanView.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    href: technical.twodDWGPlanView[0],
                                                    target: "_blank",
                                                    className: "uploadFile",
                                                    rel: "noreferrer",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: "pdfWrapper",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: download_dark_gray/* default */.Z === null || download_dark_gray/* default */.Z === void 0 ? void 0 : download_dark_gray/* default.src */.Z.src
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: staticTexts.twoDplan ? "".concat(staticTexts.twoDplan, " ").concat(dwg) : ""
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: download_dark_gray/* default */.Z === null || download_dark_gray/* default */.Z === void 0 ? void 0 : download_dark_gray/* default.src */.Z.src
                                                        })
                                                    ]
                                                }),
                                                technical.DXFPlanView && technical.DXFPlanView.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    href: technical.DXFPlanView[0],
                                                    target: "_blank",
                                                    className: "uploadFile",
                                                    rel: "noreferrer",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: "pdfWrapper",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: download_dark_gray/* default */.Z === null || download_dark_gray/* default */.Z === void 0 ? void 0 : download_dark_gray/* default.src */.Z.src
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: staticTexts.twoDplan ? "".concat(staticTexts.twoDplan, " ").concat(dxf) : ""
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: download_dark_gray/* default */.Z === null || download_dark_gray/* default */.Z === void 0 ? void 0 : download_dark_gray/* default.src */.Z.src
                                                        })
                                                    ]
                                                }),
                                                technical.twodFrontView && technical.twodFrontView.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    href: technical.twodFrontView[0],
                                                    target: "_blank",
                                                    className: "uploadFile",
                                                    rel: "noreferrer",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: "pdfWrapper",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: download_dark_gray/* default */.Z === null || download_dark_gray/* default */.Z === void 0 ? void 0 : download_dark_gray/* default.src */.Z.src
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: staticTexts.twoDfront ? "".concat(staticTexts.twoDfront, " ").concat(dwg) : ""
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: download_dark_gray/* default */.Z === null || download_dark_gray/* default */.Z === void 0 ? void 0 : download_dark_gray/* default.src */.Z.src
                                                        })
                                                    ]
                                                }),
                                                technical.DXFFrontView && technical.DXFFrontView.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    href: technical.DXFFrontView[0],
                                                    target: "_blank",
                                                    className: "uploadFile",
                                                    rel: "noreferrer",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: "pdfWrapper",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: download_dark_gray/* default */.Z === null || download_dark_gray/* default */.Z === void 0 ? void 0 : download_dark_gray/* default.src */.Z.src
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: staticTexts.twoDfront ? "".concat(staticTexts.twoDfront, " ").concat(dxf) : ""
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: download_dark_gray/* default */.Z === null || download_dark_gray/* default */.Z === void 0 ? void 0 : download_dark_gray/* default.src */.Z.src
                                                        })
                                                    ]
                                                }),
                                                technical.twoDSideView && technical.twoDSideView.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    href: technical.twoDSideView[0],
                                                    target: "_blank",
                                                    className: "uploadFile",
                                                    rel: "noreferrer",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: "pdfWrapper",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: _2d_side_gray === null || _2d_side_gray === void 0 ? void 0 : _2d_side_gray.src
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: staticTexts.twoDside ? "".concat(staticTexts.twoDside, " ").concat(dwg) : ""
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: download_dark_gray/* default */.Z === null || download_dark_gray/* default */.Z === void 0 ? void 0 : download_dark_gray/* default.src */.Z.src
                                                        })
                                                    ]
                                                }),
                                                technical.DXFSideView && technical.DXFSideView.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    href: technical.DXFSideView[0],
                                                    target: "_blank",
                                                    className: "uploadFile",
                                                    rel: "noreferrer",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: "pdfWrapper",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: _2d_side_gray === null || _2d_side_gray === void 0 ? void 0 : _2d_side_gray.src
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: staticTexts.twoDside ? "".concat(staticTexts.twoDside, " ").concat(dxf) : ""
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: download_dark_gray/* default */.Z === null || download_dark_gray/* default */.Z === void 0 ? void 0 : download_dark_gray/* default.src */.Z.src
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, "Drawing-".concat(index))
                                    ]
                                }) : null
                            ]
                        })
                    ]
                }, "technical-".concat(index));
            } else {
                return null;
            }
        })
    });
};
/* harmony default export */ var ProductTabDetail_TabTechnical = (TabTechnical);

;// CONCATENATED MODULE: ./components/ProductDetail/v1/ProductTabDetail/FeatureTab.jsx



const FeatureTab = (param)=>{
    let { featureData =[] , data: authorData  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "title-info feature-info",
        children: JSON.stringify(authorData, null, 4)
    });
};
/* harmony default export */ var ProductTabDetail_FeatureTab = (FeatureTab);

;// CONCATENATED MODULE: ./components/ProductDetail/v1/ProductTabDetail/SkuInfo.jsx





const SkuInfo = (props)=>{
    const [priceListTooltip, setpriceListTooltip] = (0,react.useState)(false);
    const { price , sku , description , skulabel , listlabel , authorData , productInfo  } = props;
    const priceListTooltipHandler = (data)=>{
        setpriceListTooltip(true);
        analytics_addDataLayer({
            title: "list info mouseover",
            isDetailsTab: true,
            productInfo,
            toolTipProps: {
                isToolTip: true,
                toolTipValue: data === null || data === void 0 ? void 0 : data.toLowerCase()
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "skuinfo-row",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "skuinfo-text",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "note",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "label",
                                children: skulabel
                            }),
                            " :",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "sku",
                                children: sku
                            })
                        ]
                    }),
                    description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "customNotes",
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "skuprice-info price-list",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "list-label",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "",
                            children: listlabel
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: info === null || info === void 0 ? void 0 : info.src,
                            role: "tooltip",
                            tabIndex: 0,
                            onMouseOver: ()=>priceListTooltipHandler(authorData.priceListTooltip),
                            onFocus: ()=>priceListTooltipHandler(authorData.priceListTooltip),
                            onBlur: ()=>setpriceListTooltip(false),
                            onMouseLeave: ()=>setpriceListTooltip(false),
                            className: "price-listTooltipIcon"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "price-list__price",
                            children: price && "$".concat(price)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "price-list__list-tooltip".concat(priceListTooltip ? "--show" : "--hide"),
                            children: (authorData === null || authorData === void 0 ? void 0 : authorData.priceListTooltip) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "price-list__list-tooltip-wrapper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolTip/* default */.Z, {
                                    message: authorData.priceListTooltip
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var ProductTabDetail_SkuInfo = (SkuInfo);

;// CONCATENATED MODULE: ./components/ProductDetail/v1/ProductTabDetail/TabRecommended.jsx


const TabRecommended = (param)=>{
    let { recommendedUseData , category  } = param;
    if (category === "Slabs") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-text",
                children: recommendedUseData && recommendedUseData.description.length > 0 && (recommendedUseData === null || recommendedUseData === void 0 ? void 0 : recommendedUseData.description.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "tabWrapper-list-type",
                        children: item
                    })))
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            children: recommendedUseData && recommendedUseData.description.length > 0 && (recommendedUseData === null || recommendedUseData === void 0 ? void 0 : recommendedUseData.description.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "tabWrapper-list-type",
                    children: item
                }, "recommended-".concat(index))))
        })
    });
};
/* harmony default export */ var ProductTabDetail_TabRecommended = (TabRecommended);

;// CONCATENATED MODULE: ./components/ProductDetail/v1/ProductTabDetail/LeadTime.jsx









const LeadTime = (props)=>{
    const { leadTimeData , leadTimeRange =""  } = props;
    const leadTimeDocumentLabel = "Lead time & shipping guidelines";
    const [showShippingTooltip, setShowShippingTooltip] = (0,react.useState)(false);
    const { leadTimeTab  } = (0,es/* useSelector */.v9)(pdpSlice/* selectPdpState */.BY);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "content-row",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "col-text",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "shipping-status",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "shipping-status__shipping-time",
                                children: constants.SHIPS_IN_LABEL + " " + leadTimeRange
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "product-summary__shipping-tooltip-block",
                                onMouseEnter: ()=>setShowShippingTooltip(true),
                                onMouseLeave: ()=>setShowShippingTooltip(false),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: info === null || info === void 0 ? void 0 : info.src,
                                        role: "tooltip",
                                        tabIndex: 0,
                                        className: "shipingtooltip_leadtime",
                                        alt: "Shipping Info"
                                    }),
                                    showShippingTooltip && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "tooltipWrapperleadtime",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tooltip__containerleadtime",
                                            dangerouslySetInnerHTML: {
                                                __html: (leadTimeTab === null || leadTimeTab === void 0 ? void 0 : leadTimeTab.shippingInfoTooltip) || "<p>No information available</p>"
                                            }
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: (0,helper/* sanitizeInnerHtml */.KD0)(leadTimeTab === null || leadTimeTab === void 0 ? void 0 : leadTimeTab.leadTimeDescription) || "No description available"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-pdf pdfList",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "files",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        title: leadTimeDocumentLabel,
                        href: leadTimeData === null || leadTimeData === void 0 ? void 0 : leadTimeData.leadTimeDocumentURL,
                        target: "_blank",
                        className: "uploadFile",
                        rel: "noreferrer",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "pdfWrapper",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: PDF_ANN/* default */.Z === null || PDF_ANN/* default */.Z === void 0 ? void 0 : PDF_ANN/* default.src */.Z.src
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: leadTimeDocumentLabel
                                    }),
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: download_dark_gray/* default */.Z === null || download_dark_gray/* default */.Z === void 0 ? void 0 : download_dark_gray/* default.src */.Z.src
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var ProductTabDetail_LeadTime = (LeadTime);

;// CONCATENATED MODULE: ./components/ProductDetail/v1/ProductTabDetail/index.jsx













const ProductTabDetail = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    const tabDetailState = (0,es/* useSelector */.v9)(pdpSlice/* selectPdpState */.BY);
    const pdpStateDetails = (0,es/* useSelector */.v9)(asPdpSlice/* selectAsPdpState */.o0);
    const { asTabDetails: tData  } = tabDetailState;
    const { tab1 , tab2 , tab3 , tab4 , tabContent1 , tabContent2 , tabContent3 , tabContent4 , tabDescription4 , leadTimeLink  } = props.authorData;
    const { asProductDetails: productDetails  } = pdpStateDetails;
    const productDetailsString = JSON.stringify((window === null || window === void 0 ? void 0 : (ref = window.adobeDataLayer) === null || ref === void 0 ? void 0 : (ref1 = ref.getState) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.call(ref, "page")) === null || ref2 === void 0 ? void 0 : ref2.productInfo) || {});
    const { productBrandNameDisplay =""  } = tData;
    const { availableFileName , availableFileNameForSpecification , fileName , skulabel , listlabel , specsSheet , specification , Installation , cadDrawings , threeDfile , twoDplan , twoDfront , twoDside , dwg , dxf  } = (0,usePdpi18n/* default */.Z)(props.authorData, "", "", productBrandNameDisplay);
    const tabList = [
        {
            title: tab1,
            tabContent: tabContent1
        },
        {
            title: tab2,
            tabContent: tabContent2
        },
        {
            title: tab3,
            tabContent: tabContent3
        },
        {
            title: tab4,
            tabContent: tabContent4
        }
    ];
    const category = (productDetails === null || productDetails === void 0 ? void 0 : (ref3 = productDetails.response) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.docs) === null || ref4 === void 0 ? void 0 : ref4.length) > 0 ? productDetails === null || productDetails === void 0 ? void 0 : (ref5 = productDetails.response) === null || ref5 === void 0 ? void 0 : ref5.docs[0].ProductLocalCategory_s : "";
    const leadTimeRange = (productDetails === null || productDetails === void 0 ? void 0 : (ref6 = productDetails.response) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.docs) === null || ref7 === void 0 ? void 0 : ref7.length) > 0 ? productDetails === null || productDetails === void 0 ? void 0 : (ref8 = productDetails.response) === null || ref8 === void 0 ? void 0 : ref8.docs[0].LeadTimeRange_s : "";
    const tabsValues = tabList.filter((tab)=>tab.tabContent !== undefined).map((tab)=>({
            title: tab.title.toUpperCase(),
            tabContent: tab.tabContent.toUpperCase()
        }));
    const refsArray = tabsValues.map(()=>(0,react.useRef)(null));
    const tabNavRef = (0,react.useRef)(null);
    const [activeTab, setActiveTab] = (0,react.useState)({
        tab: tabsValues.length > 0 ? tabsValues[0].tabContent : null,
        index: 0
    });
    if (tData && Object.keys(tData).length !== 0) {
        const { isCurated , selectedVariantSku , priceList , productGenericDescription , productBrandNameDisplay: productBrandNameDisplay1 , tabData ={}  } = tData;
        const { details ={} , recommendedUse ={} , technicalTab ={} , featureTab ={}  } = tabData;
        let leadTime = {
            leadTimeLabel: tabContent4 || "",
            description: tabDescription4 || "",
            leadTimeDocumentURL: leadTimeLink || ""
        };
        const staticTexts = {
            availableFileName,
            availableFileNameForSpecification,
            fileName,
            skulabel,
            listlabel,
            specsSheet,
            specification,
            Installation,
            cadDrawings,
            threeDfile,
            twoDplan,
            twoDfront,
            twoDside,
            dwg,
            dxf
        };
        const productBrandName = productBrandNameDisplay1 ? category === "Slabs" ? staticTexts.availableFileNameForSpecification : staticTexts.availableFileName : staticTexts.fileName;
        const renderTabComponent = (tab)=>{
            switch(tab){
                case "DETAIL":
                case "DETAILS":
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTabDetail_TabDetails, {
                        detailsData: details,
                        productBrandName: productBrandName,
                        productInfo: productDetailsString
                    });
                case "RECOMMENDEDUSE":
                case "RECOMMENDED USE":
                case "MOREINFORMATION":
                case "MORE INFORMATION":
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTabDetail_TabRecommended, {
                        recommendedUseData: recommendedUse,
                        category: category
                    });
                case "TECHNICAL":
                case "TECHNICALS":
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTabDetail_TabTechnical, {
                        technicalData: technicalTab,
                        staticTexts: staticTexts,
                        authorData: props.authorData,
                        isCurated: isCurated,
                        productInfo: productDetailsString
                    });
                case "FEATURE":
                case "FEATURES":
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTabDetail_FeatureTab, {
                        featureData: featureTab,
                        authorData: props.authorData
                    });
                case "LEADTIME":
                case "LEAD TIME":
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTabDetail_LeadTime, {
                        leadTimeData: leadTime,
                        leadTimeRange: leadTimeRange
                    });
                default:
                    return null;
            }
        };
        const handleTabClick = (tab, index)=>{
            var ref;
            setActiveTab({
                tab: tab.tabContent,
                index
            });
            analytics_addDataLayer({
                title: "header tab navigation",
                productInfo: productDetailsString,
                navProps: {
                    isNav: true,
                    navTitle: tab === null || tab === void 0 ? void 0 : (ref = tab.title) === null || ref === void 0 ? void 0 : ref.toLowerCase()
                }
            });
            const element = refsArray[index];
            tabNavRef.current.scrollTo({
                left: element.current.offsetLeft - 18,
                behavior: "smooth"
            });
        };
        const hasDetails = !!details;
        const hasRecommendedUse = recommendedUse && recommendedUse.description !== "";
        const hasTechnicalTab = !!technicalTab.length && technicalTab.some((item)=>item.description && item.description.length > 0 || item.specSheet && item.specSheet.length > 0 || item.installation && item.installation.length > 0 || item.threeDRevit && item.threeDRevit.length > 0 || item.twodDWGPlanView && item.twodDWGPlanView.length > 0 || item.DXFPlanView && item.DXFPlanView.length > 0 || item.twodFrontView && item.twodFrontView.length > 0 || item.DXFFrontView && item.DXFFrontView.length > 0 || item.twoDSideView && item.twoDSideView.length > 0 || item.DXFSideView && item.DXFSideView.length > 0 || item.HomeownersGuide && item.HomeownersGuide.length > 0);
        const hasFeatureTab = !!featureTab.length && featureTab.some((item)=>item.description && item.description.length > 0);
        const hasLeadTime = !!details;
        tabsValues.forEach((tab)=>{
            switch(tab.tabContent){
                case "DETAIL":
                case "DETAILS":
                    tab.hasData = hasDetails;
                    break;
                case "RECOMMENDEDUSE":
                case "RECOMMENDED USE":
                    tab.hasData = hasRecommendedUse;
                    break;
                case "TECHNICAL":
                case "TECHNICALS":
                    tab.hasData = hasTechnicalTab;
                    break;
                case "FEATURE":
                case "FEATURES":
                    tab.hasData = hasFeatureTab;
                    break;
                case "LEAD TIME":
                case "LEADTIME":
                    tab.hasData = hasLeadTime // Lead time data need to get from LW (Need to re-visit here)
                    ;
                    break;
                default:
                    break;
            }
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "wrapper",
            id: "product-details-tab-details",
            total: tData ? Object.keys(tData).length : 0,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "wrapper__tab-devider"
                }),
                (tabsValues === null || tabsValues === void 0 ? void 0 : tabsValues.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tabWrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tabNav",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                ref: tabNavRef,
                                role: "tablist",
                                "aria-label": "Product Details Tabs",
                                children: tabsValues.map((tab, index)=>tab.hasData && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        ref: refsArray[index],
                                        id: "product-tab-".concat(index),
                                        role: "tab",
                                        "aria-selected": activeTab.index === index,
                                        tabIndex: "0",
                                        "aria-controls": "product-tabpanel-".concat(index),
                                        onClick: ()=>handleTabClick(tab, index),
                                        onKeyDown: (e)=>{
                                            if (e.key === "Enter" || e.key === " ") {
                                                e.preventDefault();
                                                handleTabClick(tab, index);
                                            }
                                        },
                                        className: activeTab.index === index ? "active" : "",
                                        children: category === "Slabs" && [
                                            "RECOMMENDED USE",
                                            "RECOMMENDEDUSE"
                                        ].includes(tab.title) ? "MORE INFORMATION" : tab.title
                                    }, index))
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tabContent",
                            id: "product-tabpanel-".concat(activeTab.index),
                            role: "tabpanel",
                            "aria-labelledby": "product-tab-".concat(activeTab.index),
                            tabIndex: 0,
                            children: [
                                renderTabComponent(activeTab.tab),
                                category !== "Slabs" && activeTab.index === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTabDetail_SkuInfo, {
                                    price: priceList,
                                    sku: selectedVariantSku,
                                    description: productGenericDescription,
                                    skulabel: staticTexts.skulabel,
                                    listlabel: staticTexts.listlabel,
                                    authorData: props.authorData,
                                    productInfo: productDetailsString
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        className: "shimmer-loading__para shimmer height-30"
    });
};
/* harmony default export */ var v1_ProductTabDetail = (ProductTabDetail);

// EXTERNAL MODULE: ./src/components/PairsWellWith/PairsWellWith.jsx + 1 modules
var PairsWellWith = __webpack_require__(75376);
// EXTERNAL MODULE: ./src/components/ProductDetail/v3/ProductAccordion/index.jsx + 1 modules
var ProductAccordion = __webpack_require__(22644);
// EXTERNAL MODULE: ./src/components/Review/v1/Review.jsx + 2 modules
var Review = __webpack_require__(87255);
// EXTERNAL MODULE: ./src/components/ProductDetail/v3/ProductLandingTeasers/ProductExf.jsx
var ProductExf = __webpack_require__(92762);
;// CONCATENATED MODULE: ./components/ProductDetail/v1/PDPLoader/index.jsx


const PDPLoader = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "product-detail-page min-vh-100",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-details",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container kf-react-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "header-section",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product-details__breadcrumb",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "product-details__breadcrumb-link gbh-data-layer",
                                            href: ""
                                        }),
                                        "/",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "product-details__breadcrumb-link gbh-data-layer",
                                            href: ""
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "print-overview product-details__overview-block product-info",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "product-img-block product-details__image-gallery print-overview-left",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "image-reel row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "image-reel__image-thumb-view no-print",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    className: "pl-0 ml-0 image-reel__image-thumb-view-ul",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: "image-reel__image-list",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "image-reel__image-thumb"
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "image-reel__image-stack-view",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "image-reel__image-stack-view-block",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                            className: "pl-0 list-inline image-reel__image-stack-list",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {})
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "image-reel__photo-credit"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-12 product-summary__product-summary-block p-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "product-summary",
                                        id: "product-summary-wrapper",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "product-summary__title"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "product-summary__desc",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "product-summary__desc"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "product-summary__desc"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "product-summary__price",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "product-summary__price-first"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "product-summary__price-sec"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "product-summary__discount",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "product-summary__discount-price"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "product-summary__price-sec"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "product-summary__percent-off"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "product-summary__details"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "product-summary__button-block"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "product-summary__icons-block",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "product-summary__icons-part-first",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "product-details__list-text"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "product-details__tooltip-main-block",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "product-details__list-tooltip-wrapper"
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var v1_PDPLoader = (PDPLoader);

// EXTERNAL MODULE: ./src/components/core/Head/NextHead.jsx
var NextHead = __webpack_require__(46760);
// EXTERNAL MODULE: ./src/components/ProductDetail/v3/ProductDetailView/PDPCuratedProducts/index.jsx
var PDPCuratedProducts = __webpack_require__(85342);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./src/pages/products/pdp-v2.jsx




























/**
 * renders ProductDetailsPage page
 * @return {JSX.Element}
 */ function ProductDetailsPage(param) {
    let { tmpData: data = {} , headertmp: header , footertmp: footer , ip , globalScript , footerScript , analyticsData , gbhDataLayerCustom , slug , tmpSkuId: skuId , type , pdpData , apiStatus: status , apiStatusText: statusText , initialImgAlt , initialImgUrl , initialImageFullUrl , fullUrl , isPart , siteName , metaContent , groutData  } = param;
    const dispatch = (0,es/* useDispatch */.I0)();
    const router = (0,next_router.useRouter)();
    const isSsr = (0,useIsSsr/* default */.Z)();
    const { access_token: accessToken  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { pageIsInteractive  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { isTeaserLoaded  } = (0,es/* useSelector */.v9)(pdpSlice/* selectPdpState */.BY);
    const [pageRedirect, setPageRedirect] = (0,react.useState)("");
    const { redirectTarget: { page: { path =""  } = {}  } = {}  } = data;
    const [config, setConfig] = (0,react.useState)({});
    const [priceSpiderKey, setPriceSpiderKey] = (0,react.useState)("");
    const [priceSpiderLanguage, setPriceSpiderLanguage] = (0,react.useState)("");
    const [priceSpiderCountry, setPriceSpiderCountry] = (0,react.useState)("");
    const [isBundleProduct, setIsBundleProduct] = (0,react.useState)("");
    const [currencyCode, setCurrencyCode] = (0,react.useState)("");
    const [persona, setPersona] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>setConfig(config));
        scrollToTop();
        if (!(0,helper/* isLoadTargetAnalyticsEventLoaded */.LoY)()) {
            window.initDataLayerTop();
        }
        const { ProductLocalCategory_s: productLocalCategory = "" , Product_Category: productCategory = "" , CustomerFacingSKU_s: skuID = "" , CustomerFacingBrand_s: siteName = ""  } = pdpData || {};
        window.needPdpdata = {
            productSubCatergory: (productLocalCategory === null || productLocalCategory === void 0 ? void 0 : productLocalCategory.toLowerCase()) || (productCategory === null || productCategory === void 0 ? void 0 : productCategory.toLowerCase()),
            skuID,
            siteName: siteName.toLowerCase()
        };
        if (gbhDataLayerCustom) dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(gbhDataLayerCustom));
        const persona = (0,helper/* getUserPersona */.shu)();
        setPersona(persona);
        return ()=>dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(""));
    }, []);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(config)) {
            const psKey = get_default()(config, "general.priceSpiderKey", "");
            if (psKey) {
                setPriceSpiderKey(psKey);
            }
            const psLanguage = get_default()(config, "internationalization.language", "");
            if (psLanguage) {
                setPriceSpiderLanguage(psLanguage);
            }
            const psCountry = get_default()(config, "internationalization.country", "");
            if (psCountry) {
                setPriceSpiderCountry(psCountry);
            }
            const currencyCode = get_default()(config, "internationalization.currencyCode", "");
            if (currencyCode) {
                setCurrencyCode(currencyCode);
            }
        }
    }, [
        config
    ]);
    (0,react.useEffect)(()=>{
        if (ip) sessionStorage.setItem("true-ip", ip);
    }, [
        ip
    ]);
    (0,usePageAuth/* default */.Z)();
    (0,react.useEffect)(()=>{
        if (analyticsData) (0,helper/* getDataLayerObj */.C2G)(analyticsData);
    }, [
        analyticsData
    ]);
    (0,react.useEffect)(()=>{
        if (path) {
            setPageRedirect((0,helper/* removeAndCleanLink */.xEh)(path));
        }
    }, [
        path
    ]);
    (0,react.useEffect)(()=>{
        if (!isSsr && pageRedirect) {
            router.push(pageRedirect);
        }
    }, [
        isSsr,
        pageRedirect
    ]);
    (0,react.useEffect)(()=>{
        if (pdpData && accessToken && pageIsInteractive && !isTeaserLoaded) {
            (0,productDetailsHelper/* getTeaserFragments */.lX)(data, pdpData);
        }
    }, [
        accessToken,
        pdpData,
        pageIsInteractive,
        isTeaserLoaded
    ]);
    const scrollToTop = ()=>{
        window.scrollTo(0, 0);
    };
    const { language: metaLanguage = "" , accountName =""  } = data;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextHead/* default */.Z, {
                psKey: priceSpiderKey,
                psCountry: priceSpiderCountry,
                psLanguage: priceSpiderLanguage,
                fullUrl: fullUrl,
                metaLanguage: metaLanguage,
                pdpData: pdpData,
                isPart: isPart,
                initialImageFullUrl: initialImageFullUrl,
                skuId: skuId,
                siteName: siteName,
                isBundleProduct: isBundleProduct,
                currencyCode: currencyCode,
                persona: persona
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "zoomdatapdp",
                src: "https://s7d1.scene7.com/s7viewers/html5/js/ZoomViewer.js"
            }, "zoomdatapdp"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageLayout/* default */.Z, {
                header: header ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageHeader/* default */.Z, {
                    header: header,
                    title: pdpData === null || pdpData === void 0 ? void 0 : pdpData.metaTitle_s,
                    description: pdpData === null || pdpData === void 0 ? void 0 : pdpData.metaDescription_s,
                    templateName: data === null || data === void 0 ? void 0 : data.templateName,
                    globalScripting: globalScript
                }) : null,
                footer: footer ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageFooter/* default */.Z, {
                    footer: footer,
                    footerScripting: footerScript
                }) : null,
                children: data && !isEmpty_default()(pdpData) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "min-vh-100",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AemGrid/* default */.Z, {
                        data: data,
                        count: 0,
                        productDetail: (data, slug, skuId, type)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetail, {
                                data: {
                                    ...data,
                                    accountName
                                },
                                pdpData: pdpData,
                                groutData: groutData,
                                slug: slug,
                                skuId: skuId,
                                type: type,
                                initialImgAlt: initialImgAlt,
                                initialImgUrl: initialImgUrl,
                                setIsBundleProduct: setIsBundleProduct,
                                config: config
                            }),
                        productTabDetails: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ProductTabDetail, {
                                authorData: data
                            }),
                        productDetailFiller: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(v1_PDPLoader, {
                                initialImgAlt: initialImgAlt,
                                initialImgUrl: initialImgUrl,
                                pdpJson: data,
                                pdpData: pdpData,
                                skuId: skuId
                            }),
                        pairsWellWith: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PairsWellWith/* default */.Z, {
                                data: data,
                                skuId: skuId
                            }),
                        productAccordion: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAccordion/* default */.Z, {
                                data: data
                            }),
                        review: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Review/* default */.Z, {
                                data: data
                            }),
                        productExf: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductExf/* default */.Z, {
                                data: data
                            }),
                        slug: slug,
                        skuId: skuId,
                        type: type,
                        pdpCuratedProduct: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PDPCuratedProducts/* default */.Z, {
                                authData: data,
                                slug: slug,
                                skuId: skuId
                            })
                    })
                }) : null
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ var pdp_v2 = (ProductDetailsPage);


/***/ }),

/***/ 8618:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SelectDropdown_wrapper__ot64Z"};

/***/ }),

/***/ 46805:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Toaster_wrapper__3Ggw_"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,6351,6342,4432,7333,4904,361,9851,3913,5921,4204,4382,3785,919,7965,4947,9774,2888,179], function() { return __webpack_exec__(81324); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);